<template>
  <div>
    <div
      v-if="
        (!decoded && isLanding) ||
        (!decoded && !isInterno) ||
        (decoded.consultor && isInterno)
      "
      :class="`${isLanding ? 'form-landing' : 'p-2'}`"
    >
      <vx-card :class="!showPanel ? 'painel-no-border' : 'painel-border'">
        <div class="text-center mb-5" v-if="hideLogo != true">
          <img
            v-if="logo != '' && isInterno === false && !isLanding"
            :src="logo"
            width="70%"
            style="display: inline; max-width: 250px"
          />
        </div>
        <div
          v-if="isPropostaConsultor && dadosConsultor"
          class="text-center mb-10"
        >
          <vx-card>
            <h5 class="text-left mb-5">{{ $t('Consultor') }}</h5>
            <div class="vx-row">
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIEAAACBCAMAAADQfiliAAAAYFBMVEVPT0/////w8PAxMTFERERAQEBKSkpHR0fj4+M9PT3d3d26urqVlZX7+/tTU1PNzc2rq6ujo6NeXl5ZWVl1dXXX19ebm5s2NjbFxcV/f39ra2uFhYXq6uplZWWMjIy0tLR0Q7UjAAAFvUlEQVR4nM2c2baqMAyGS22LiCAzOIDv/5a7gCBCh4QNS/+7s84q/eyQJmm6ibNG9HTx4+Z6S9KQhGlyuzaxfznRVd8i+M79ex0KxpgrBOklhCv/LcL67uMxcATUvyaMu0PPcwmX8+Tq4yAQBDTKuKfrfILh8SxCQEAJgio7MHv3Lwh2yKpgU4JHlIK7HyDS6LEZAT2HHNV9Lx6eIZNhJwhij63ovxXzYvtc2AiCiK3tv2NgkY3BQpAn/+m/Y0jyfxDQM3L9qSS4eTmYCHLy3wHoxcLLKoKgKDfpv1VZ6FeDluCRrdmBOvHsiCXIU3dDAELcULcgNQRV+f8lOFNZYQhib+v+pbwYTnDeZg/Mxc5QgmbLNTgVVyEoCJo9pqCXp0BYEpz3GoFWilFYEMT7rIFBbLEc5wTVflPQy5tvyhlBjrHEgpeHViXHWK8yNxEcQ0T3YfPMH5TSR+43KcCFHRQe9QRBBv4xLHlOz1zq1+D142aBlqAAbwNvceYHMXgCWaEjuIC/wVU2/gJ2Z8qpvzAhoND+iav2OHL4WpiM4IQAfBrwpxJAbmXoLE5PiDdBDm0urhoAadDBP+K9JUeCIAHPot7xDKD2TCTjfhgJIii+qzxjXyqg25lFc4IAvp1PBoITeDGyYRAGAviBFBoAHAdsVMcj6kVAwQeS2xgJ7mCr6tEPArhfpt2KvSKwWR0sY0/wgJ9Inin+cRwf7t+EjwkBnNxGgPAvePQmCFJwMxvBE+HjpcFIUCE8M+4bCTBOHqtGggwRIPHISIAJNUQ2ENADvJXC1fwQfDdKHeiLAGyQWxmNMm44e9NMsK28zEhAMNFGNw2SgGIascKcFsoLzIBy2hH4iBDB4BsMuiJG1PM7AkwTy15shbCK3Q8iDk3gLZYRz1KoqCuhkuCEmjjzudQKtbPYSRJgRo0I89ncqsHsLDmrBGdDCLMlzB+o4N+9S4IalbNitkEAu8udRO0QCncNegTzuYBNP4SUwH3Ll0rTYqyweVhxIhdszsR4ND3RX7sQH92mMBCgtmL3NZ+g80Zy+eoFjlhGgpg02DbiZiDAWPhObkPQbQgzEKA/Jq7khm5U6sO2I/pKQtwI5lzqZdgM6IUozyaCcNQHhboLE4zXPyglSJPYSusuIwKfUSv6J4uM4LgKVn5tRRv3ppqH4LbmYihcsw56/24hjL/5VrpiL5DWlqoIVmXlkxX2YFMCaQ/wNnFbgiv+XNiWwD3jz8ZtCeTZuK6dKmzAZCHeX/LxPlLXTpVWpau+dMH7iXLuNK7is8SvKeknIn1l13OTuy6VdLkn8v9R35O+MiJeEEwkTXU0VVTQY9UkAl650cYL4JjJLdPYUlLyUh6l0PnoYiZQ3Cg8UZgy2nOdCgG6feviRkDsLHjtQ4u8BgV+ze0MXexszx+wGlxk9sFQ2W8Au/yBzcN2PXvOQCffsjP6HIrlXPfOa37/OA5n88d9ay7NNZYSQXQJDcPwyqUZ8oluDavwM+lRaxGGfKLey1f7g1jp/ccxp6rLK4t6CwCJoDO7Y15ZNw0exgaZdFIvx3duXXOyC1OYjtNd+RMn9wvqaEvphqyT+idO7ljU4RbXFrOhdVR+f3LPpL5r25vg465NeTmzM8FQAWC4c92ZYHbnqspE7kswv3dW3b3vTDC/e1eY5l0JlvUHihqMPQlUNRhOPh+EPQmYog5luSN3JFDX4izqkfYcA3U90rwwbz+Cj/I8Q13abgRcW5c2q83bi8BUm+c80smWZDndStN9JtJP33Neozl12PoKzC00XWDmGs0fqFP9gVrdH6hXlgjfrtnecRSgdes/ULv/A+8X5KY8fPkNxw+8Y/mBtzw/8J7J2fBNF1n3pstp37UBEnI2Cbb+XZvz/bd9zg+8b5SiMf/qG8+OoUi/+s611bff+rb69nvnTl9+8/2CsL57Z3u+e39BfPft/xtj9vcPzuv//sEfFSxPnb+gvH0AAAAASUVORK5CYII="
                  alt="Avatar"
                  style="width: 32px; height: 32px; display: inline"
                  class="rounded-circle avatar border border-white"
                />

                <div>
                  {{ dadosConsultor.nome }}
                </div>
              </div>
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <div>
                  <feather-icon
                    :icon="'MailIcon'"
                    class="inline-flex rounded-full"
                    :style="{ background: `rgba(var(--vs-black),.15)` }"
                  ></feather-icon>
                </div>
                {{ dadosConsultor.email }}
              </div>
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <div>
                  <feather-icon
                    :icon="'PhoneIcon'"
                    class="inline-flex rounded-full"
                    :style="{ background: `rgba(var(--vs-black),.15)` }"
                  ></feather-icon>
                </div>
                {{ dadosConsultor.celular }} / {{ dadosConsultor.telefone }}
              </div>
            </div>
          </vx-card>
        </div>
        <form
          v-if="passo === 0 && isInterno"
          role="form"
          @submit.stop.prevent="onSubmit"
          autocomplete="nope"
        >
          <div class="vx-row">
            <div class="vx-col w-full sm:w-1/2 md:w-1/3 mb-2">
              <span>Selecione a {{ $t('Regional') }}</span>
              <v-select
                :options="regionais"
                name="Cooperativa"
                id="Cooperativa"
                v-model="form.regional"
                :state="validateState(translatedRegional)"
                :class="validateClass(translatedRegional)"
                @input="buscaDivisoes(), definirDadosRegional()"
                :disabled="!podeAlterarRegional || regionais.length === 1"
              ></v-select>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/3 mb-2">
              <span>Selecione a {{ $t('divisão') }}</span>
              <v-select
                :options="divisoes"
                name="Divisao"
                id="Divisao"
                v-model="form.idDivisao"
                :reduce="(item) => item.id"
                v-validate="{ required: true }"
                :state="validateState(translatedDivision)"
                :class="validateClass(translatedDivision)"
                disabled
              ></v-select>
            </div>
          </div>
          <div class="vx-row mt-3">
            <!-- <div class="vx-col sm:w-1/4 w-full mb-2">
              <span>Origem do Lead:</span>
              <v-select
                :options="listLeads"
                name="Origem do Lead"
                id="Origem do Lead"
                label="origem"
                v-model="form.origemLead"
                :reduce="(item) => item.idOrigemLeads"
                :state="validateState('Origem do Lead')"
                :class="validateClass('Origem do Lead')"
                :disabled="propostaViaMigracaoSga"
              ></v-select>
            </div> -->
            <div class="vx-col sm:w-1/4 w-full mb-2 flex items-end pb-1">
              <ul class="flex gap-6">
                <li>
                  <vs-radio
                    v-model="propostaMultipla"
                    vs-name="propostaMultipla"
                    vs-value="unica"
                    >Único</vs-radio
                  >
                </li>
                <li v-if="mostrarMultiPropostas()">
                  <vs-radio
                    v-model="propostaMultipla"
                    vs-name="propostaMultipla"
                    vs-value="multi"
                    :disabled="propostaViaMigracaoSga"
                    >Diversos</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>
        </form>
        <form
          v-if="passo === 1"
          role="form"
          @submit.stop.prevent
          autocomplete="nope"
        >
          <input type="password" style="display: none" readonly />
          <div v-if="produtos.length == 0">
            <div class="vx-row mb-3">
              <div
                :class="`coluna-switch vx-col w-full mb-3 ${
                  verificaEmpresa() && 'sm:w-1/2'
                }`"
              >
                <div style="display: flex; gap: 10px">
                  <vs-switch
                    nome="__veiculoZero123"
                    id="_veiculoZero321"
                    color="primary"
                    v-model="isCarroZero"
                    style="width: 60px"
                    :disabled="desabilitarInputVeiculoZero"
                  >
                    <span slot="on">Sim</span>
                    <span slot="off">Não</span>
                  </vs-switch>
                  <span class="label-switch">
                    {{
                      !verificaEmpresa()
                        ? `Veículo Zero, ainda não possui placa.`
                        : `Veículo zero`
                    }}
                  </span>
                </div>
              </div>

              <div
                :class="`coluna-switch vx-col w-full mb-3 ${
                  verificaEmpresa() && 'sm:w-1/2'
                }`"
              >
                <div v-if="false" style="display: flex; gap: 10px">
                  <vs-switch
                    nome="isTaxiOrApp"
                    id="isTaxiOrApp"
                    color="primary"
                    v-model="form.isTaxiOrApp"
                    style="width: 60px"
                    :disabled="
                      form.somenteAgregado ||
                      (idTipoFipe && idTipoFipe.id === tipoVeiculo.CAMINHAO)
                    "
                  >
                    <span slot="on">Sim</span>
                    <span slot="off">Não</span>
                  </vs-switch>
                  <span class="label-switch">Táxi/APP</span>
                </div>
              </div>

              <div
                v-if="verificaEmpresa()"
                :class="`coluna-switch vx-col w-full mb-3 ${
                  verificaEmpresa() && 'sm:w-1/2'
                }`"
              >
                <div style="display: flex; gap: 10px">
                  <vs-switch
                    name="__propostaSomenteAgregado123"
                    id="_propostaSomenteAgregado321"
                    color="primary"
                    v-model="propostaParaSomenteAgregado"
                    style="width: 60px"
                    @input="ajustarPropostaParaSomenteAgregado"
                  >
                    <span slot="on">Sim</span>
                    <span slot="off">Não</span>
                  </vs-switch>
                  <span class="label-switch"
                    >Proposta para
                    {{
                      this.mascaraAgregado ? this.mascaraAgregado : 'agregado'
                    }}</span
                  >
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div
                :class="`vx-col w-full  ${
                  isInterno == true ? 'sm:w-1/4' : 'sm:w-1/3'
                }  mb-2`"
              >
                <vs-input
                  class="w-full capitalize"
                  label="Nome e Sobrenome"
                  v-model="form.nome"
                  name="Nome"
                  id="Nome"
                  v-validate="{ required: true }"
                  :state="validateState('Nome')"
                  :class="validateClass('Nome')"
                  @blur.native="salvaProspect()"
                  :disabled="isCampoNomeDisabled"
                />
              </div>

              <div
                :class="`vx-col w-full ${
                  isInterno == true ? 'sm:w-1/4' : 'sm:w-1/3'
                }  mb-2`"
              >
                <vs-input
                  class="w-full"
                  label="E-mail"
                  v-model="form.email"
                  name="Email"
                  autocapitalize="off"
                  autocorrect="off"
                  v-validate="{ email: true }"
                  @blur.native="salvaProspect()"
                  :state="validateState('Email')"
                  :class="validateClass('Email')"
                />
              </div>

              <div
                :class="`vx-col ${
                  isInterno == true ? 'sm:w-1/4' : 'sm:w-1/3'
                } w-full mb-2`"
              >
                <label for="Celular" class="vs-select--label">Celular</label>
                <the-mask
                  mask="(##) #####-####"
                  id="Celular"
                  class="vs-inputx vs-input--input normal hasValue w-full"
                  v-model="form.celular"
                  name="Celular"
                  :masked="true"
                  v-validate="{ required: true, min: 15 }"
                  @blur.native="verificaCelular(form.celular), salvaProspect()"
                  :state="validateState('Celular')"
                  :class="validateClass('Celular')"
                  :disabled="isCampoCelularDisabled"
                />
              </div>
              <div v-if="isInterno" class="vx-col sm:w-1/4 w-full mb-2">
                <label for="Telefone" class="vs-select--label">
                  {{ nomenclatura120 ? 'Fixo' : 'Telefone' }}
                </label>
                <the-mask
                  mask="(##) ####-####"
                  id="Telefone"
                  class="vs-inputx vs-input--input normal hasValue w-full"
                  v-model="form.telefone"
                  name="Telefone"
                  :masked="true"
                  v-validate="{ min: 14 }"
                  :state="validateState('Telefone')"
                  :class="validateClass('Telefone')"
                />
              </div>
            </div>

            <div class="vx-row">
              <div
                v-if="isInterno"
                :class="`vx-col ${
                  isInterno ? 'sm:w-1/4' : 'sm:w-1/2'
                } w-full mb-2`"
              >
                <label for="Tipos de Proposta" class="vs-select--label"
                  >Tipo de proposta</label
                >
                <v-select
                  :options="seletorTiposProposta"
                  name="Tipos de Proposta"
                  id="Tipos de Proposta"
                  v-model="form.tipoProposta"
                  v-validate="{ required: true }"
                  label="text"
                  :state="validateState('Tipos de Proposta')"
                  :class="validateClass('Tipos de Proposta')"
                  :disabled="propostaViaMigracaoSga"
                ></v-select>
              </div>

              <div
                v-if="(usaUF || isInterno) && !isLanding"
                :class="`vx-col ${
                  isInterno ? 'sm:w-1/4' : 'sm:w-1/2'
                } w-1/2 mb-2`"
              >
                <label for="Estado" class="vs-select--label">Estado</label>
                <v-select
                  :options="estados"
                  name="Estado"
                  id="Estado"
                  autocomplete="off"
                  @input="
                    buscaDadosSelectsCidades(
                      'domMunicipio',
                      'cidades',
                      'nomeCidade',
                      'idCidade',
                    ),
                      selecionaEstado()
                  "
                  v-model="estado"
                  v-validate="{ required: true }"
                  label="label"
                  :state="validateState('Estado')"
                  :class="validateClass('Estado')"
                ></v-select>
              </div>

              <div
                v-if="(usaUF || isInterno) && !isLanding"
                :class="`vx-col ${
                  isInterno ? 'sm:w-1/4' : 'sm:w-2/2'
                } w-1/2 mb-2`"
              >
                <label for="Cidade" class="vs-select--label">Cidade</label>
                <v-select
                  :options="cidades"
                  name="Cidade"
                  id="Cidade"
                  @input="selecionaCidade()"
                  v-model="cidade"
                  v-validate="{ required: true }"
                  label="label"
                  :state="validateState('Cidade')"
                  :class="validateClass('Cidade')"
                ></v-select>
              </div>
              <div
                v-if="!isInterno && !isLanding"
                class="vx-col sm:w-1/6 sm:block gap-3 flex w-3/5 justify-between mb-2"
              >
                <span class="sm:mt-0 mt-3 text-sm" v-if="usaUF">Usar CEP</span>
                <span class="sm:mt-0 mt-3 text-sm" v-if="!usaUF"
                  >Não sei o CEP</span
                >
                <vs-switch
                  class="mt-2"
                  color="success"
                  v-model="usaUF"
                  style="width: 60px"
                >
                  <span slot="on">UF</span>
                  <span slot="off">CEP</span>
                </vs-switch>
              </div>
              <div
                v-if="!usaUF && !isInterno && !isLanding"
                class="vx-col sm:w-1/4 w-full mb-2"
              >
                <vs-input
                  class="sm:w-1/1 w-full"
                  label="CEP"
                  name="Cep"
                  id="Cep"
                  @keyup.native="keymonitor"
                  v-model="cep"
                  v-validate="{ required: true, min: 10 }"
                  :state="validateState('Cep')"
                  :danger="validateClass('Cep')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  v-mask="'##.###-###'"
                />
              </div>

              <!-- Local de Estacionamento -->
              <div
                v-if="exigirCampoEstacionamentoProposta"
                class="vx-col sm:w-1/4 w-full mb-2"
              >
                <label for="localEstacionamento" class="vs-select--label">{{
                  labelLocalEstacionamento
                }}</label>
                <v-select
                  :options="listLocaisEstacionamento"
                  :name="labelLocalEstacionamento"
                  id="localEstacionamento"
                  v-model="form.idTipoEstacionamento"
                  v-validate="{ required: true }"
                  :reduce="(item) => item.idTipoEstacionamento"
                  label="nome"
                  :state="validateState(labelLocalEstacionamento)"
                  :class="validateClass(labelLocalEstacionamento)"
                ></v-select>
              </div>
            </div>

            <!-- bem protege -->
            <div v-if="verificaEmpresa()" class="vx-row" style="display: flex">
              <!-- placa chassi -->
              <div
                :class="`vx-col ${
                  exibirPlaca() || form.somenteAgregado
                    ? 'sm:w-1/3'
                    : exibirPlaca()
                    ? 'sm:w-1/3'
                    : 'sm:w-1/4'
                } w-full mb-2`"
              >
                <!-- AAplaca -->
                <!-- Placa -->
                <!-- <div v-if="exibirPlaca()" class="vx-col sm:w-1/3 w-full mb-2"> -->
                <label
                  v-if="form.tipoProposta != 'Substituição' && exibirPlaca()"
                  for=""
                  class="vs-select--label"
                  >Placa</label
                >
                <label
                  v-if="form.tipoProposta == 'Substituição' && exibirPlaca()"
                  for=""
                  class="vs-select--label"
                  >Placa que vai entrar</label
                >
                <the-mask
                  v-if="exibirPlaca()"
                  mask="AAA-#XX#"
                  style="text-transform: uppercase"
                  id="input-2"
                  class="vs-inputx vs-input--input normal hasValue w-full"
                  v-model="form.placa"
                  name="Placa"
                  :masked="true"
                  @input="keymonitorPlaca"
                  @blur.native="salvaProspect()"
                  v-validate="{ required: true, length: 8 }"
                  :state="validateState('Placa')"
                  :class="validateClass('Placa')"
                />

                <label
                  v-if="form.somenteAgregado == true"
                  for=""
                  class="vs-select--label"
                  >Placa</label
                >
                <the-mask
                  mask="AAA-#XX#"
                  v-if="form.somenteAgregado == true"
                  style="text-transform: uppercase"
                  id="input-2"
                  class="vs-inputx vs-input--input normal hasValue w-full"
                  v-model="form.placa"
                  name="Placa"
                  :masked="true"
                  disabled
                />

                <vs-input
                  v-if="
                    !exibirPlaca() &&
                    verificaEmpresa() &&
                    form.somenteAgregado === false
                  "
                  class="vs-inputx normal hasValue w-full"
                  label="Chassi"
                  v-model="form.chassi"
                  name="Chassi"
                  id="Chassi"
                  v-validate="{ required: true, min: 17, max: 17 }"
                  :state="validateState('Chassi')"
                  :danger="validateClass('Chassi')"
                  @keyup.native="verificaChassiBaseBP"
                />
              </div>

              <!-- data de saída -->
              <div
                v-if="
                  !exibirPlaca() &&
                  verificaEmpresa() &&
                  form.somenteAgregado == false
                "
                :class="`vx-col ${
                  (isInterno == true && exibirPlaca()) || form.somenteAgregado
                    ? 'sm:w-1/3'
                    : exibirPlaca()
                    ? 'sm:w-1/3'
                    : 'sm:w-1/4'
                } w-full mb-2`"
              >
                <vs-input
                  v-if="!exibirPlaca() && verificaEmpresa()"
                  class="w-full"
                  label="Data de saída da NF"
                  v-mask="'##/##/####'"
                  v-model="form.dataNf"
                  @keyup.native="validarDataSaidaNf"
                  name="Data de saída da NF"
                  id="dataSaidaNF"
                  v-validate="'date_format:dd/MM/yyyy'"
                  :state="validateState('Data de saída da NF')"
                  :danger="validateClass('Data de saída da NF')"
                />
              </div>

              <!-- tipo veículo -->
              <div
                v-if="
                  placaEncontrada == true ||
                  !exibirPlaca() ||
                  formCompletoB2C ||
                  form.somenteAgregado ||
                  (placaEncontrada == false && exibirIptDadosVeiculo)
                "
                :class="`vx-col ${
                  (isInterno == true && exibirPlaca()) || form.somenteAgregado
                    ? 'sm:w-1/3'
                    : exibirPlaca()
                    ? 'sm:w-1/3'
                    : 'sm:w-1/4'
                } w-full mb-2`"
              >
                <label for="" class="vs-select--label">Tipo de veículo</label>
                <v-select
                  :options="tipos"
                  name="Tipo Veículo"
                  id="Tipo Veículo"
                  @input="selecionaTipoFipe()"
                  v-model="idTipoFipe"
                  v-validate="{ required: true }"
                  label="label"
                  :state="validateState('Tipo Veículo')"
                  :class="validateClass('Tipo Veículo')"
                ></v-select>
              </div>
              <!-- grupo -->
              <div
                v-if="
                  placaEncontrada == true ||
                  !exibirPlaca() ||
                  formCompletoB2C ||
                  form.somenteAgregado ||
                  (placaEncontrada == false && exibirIptDadosVeiculo)
                "
                :class="`vx-col ${
                  isInterno == true && exibirPlaca() ? 'sm:w-1/3' : 'sm:w-1/4'
                } w-full mb-2 container h-16`"
              >
                <vs-col
                  class="mb-2 semPadding"
                  vs-lg="12"
                  vs-sm="12"
                  vs-xs="12"
                  vs-type="flex"
                  vs-align="center"
                >
                  <label
                    v-if="habilitaAlterarGrupo || (idGrupo && idGrupo.label)"
                    >Grupo do Veículo:
                    <span class="font-bold"> {{ idGrupo.label }}</span></label
                  >
                  <vs-button
                    v-if="habilitaAlterarGrupo"
                    v-tooltip="'trocar Grupo do Veículo'"
                    radius
                    color="success"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="ml-5"
                    @click="mostrarModalGrupos = true"
                  ></vs-button>
                </vs-col>
              </div>
              <div
                v-if="isClasse && idTipoFipe && idTipoFipe.id === 3"
                class="vx-col sm:w-1/4 w-full mb-2"
              >
                <div>
                  <span class="vs-select--label">Classe</span>
                  <v-select
                    :options="classes"
                    name="Classe"
                    id="Classe"
                    @input="selecionaClasse()"
                    v-validate="{ required: true }"
                    v-model="form.classe"
                    label="label"
                  />
                </div>
              </div>
            </div>

            <!-- OUTRAS EMPRESA -->

            <div v-else-if="!verificaEmpresa()" class="vx-row">
              <div
                :class="`vx-col ${
                  isInterno == true ? 'sm:w-1/3' : 'sm:w-1/3'
                } w-full mb-2`"
              >
                <label v-if="exibirPlaca()" for="Placa" class="vs-select--label"
                  >Placa</label
                >
                <the-mask
                  mask="AAA-#XX#"
                  v-if="exibirPlaca()"
                  style="text-transform: uppercase"
                  id="Placa"
                  class="vs-inputx vs-input--input normal hasValue w-full"
                  v-model="form.placa"
                  name="Placa"
                  :masked="true"
                  @input="keymonitorPlaca"
                  v-validate="{ required: true, length: 8 }"
                  :state="validateState('Placa')"
                  :class="validateClass('Placa')"
                />
                <label
                  v-if="!exibirPlaca() && !verificaEmpresa()"
                  for="placa2"
                  class="vs-select--label"
                  >Placa</label
                >
                <the-mask
                  mask="AAA-#XX#"
                  v-if="!exibirPlaca() && !verificaEmpresa()"
                  style="text-transform: uppercase"
                  id="placa2"
                  class="vs-inputx vs-input--input normal hasValue w-full"
                  v-model="form.placa"
                  name="placa2"
                  :masked="true"
                  disabled
                />
              </div>

              <div
                :class="`vx-col ${
                  isInterno == true ? 'sm:w-1/3' : 'sm:w-1/3'
                } w-full mb-2`"
              >
                <label for="" class="vs-select--label">Tipo de veículo</label>
                <v-select
                  :options="tipos"
                  name="Tipo Veículo"
                  id="Tipo Veículo"
                  @input="selecionaTipoFipe()"
                  v-model="idTipoFipe"
                  v-validate="{ required: true }"
                  label="label"
                  :state="validateState('Tipo Veículo')"
                  :class="validateClass('Tipo Veículo')"
                ></v-select>
              </div>
              <div
                :class="`vx-col ${
                  isInterno == true ? 'sm:w-1/3' : 'sm:w-1/3'
                } w-full mb-2 container h-16`"
              >
                <vs-col
                  class="mb-2 semPadding"
                  vs-lg="12"
                  vs-sm="12"
                  vs-xs="12"
                  vs-type="flex"
                  vs-align="center"
                >
                  <label
                    v-if="!habilitaAlterarGrupo || (idGrupo && idGrupo.label)"
                    >Grupo do Veículo:
                    <span class="font-bold"> {{ idGrupo.label }}</span></label
                  >
                  <vs-button
                    v-if="!habilitaAlterarGrupo"
                    v-tooltip="'trocar Grupo do Veículo'"
                    radius
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="d-inline"
                    @click="mostrarModalGrupos = true"
                  ></vs-button>
                </vs-col>
              </div>
            </div>

            <!-- OUTRAS EMPRESA -->

            <div v-if="configuracaoPropostaCaminhao" class="vx-row mt-6 mb-6">
              <div v-if="permitirCaminhao" class="vx-col sm:w-1/4 w-full mb-2">
                <vs-checkbox
                  v-model="form.caminhao"
                  :disabled="form.somenteAgregado === false"
                >
                  {{ this.mascaraCaminhao ? this.mascaraCaminhao : 'Caminhão' }}
                </vs-checkbox>
              </div>

              <div
                v-if="permitirImplemento"
                class="vx-col sm:w-1/4 w-full mb-2"
              >
                <vs-checkbox :checked="false" v-model="form.implemento">
                  {{
                    this.mascaraImplemento
                      ? this.mascaraImplemento
                      : 'Implemento'
                  }}
                </vs-checkbox>
              </div>

              <div v-if="permitirAgregado" class="vx-col sm:w-1/4 w-full mb-2">
                <vs-checkbox :checked="false" v-model="form.agregado">
                  {{ this.mascaraAgregado ? this.mascaraAgregado : 'agregado' }}
                </vs-checkbox>
              </div>
            </div>

            <div class="vx-row" style="">
              <div
                v-if="permitirImplemento || permitirAgregado"
                class="vx-col sm:w-1/2 mb-2"
                style="
                  display: flex;
                  align-items: center;
                  gap: 5px;
                  padding: 17px 10px;
                "
              >
                <vs-button
                  v-if="form.implemento"
                  color="primary"
                  type="border"
                  icon="add"
                  @click="
                    abrirModalComplemento(),
                      (tipoConfiguracaoCaminhao = 'implemento')
                  "
                  >Adicionar
                  {{
                    this.mascaraImplemento
                      ? this.mascaraImplemento
                      : 'Implemento'
                  }}</vs-button
                >
                <vs-button
                  v-if="form.agregado"
                  color="primary"
                  type="border"
                  icon="add"
                  @click="
                    abrirModalComplemento(),
                      (tipoConfiguracaoCaminhao = 'agregado')
                  "
                  >Adicionar
                  {{
                    this.mascaraAgregado ? this.mascaraAgregado : 'Agregado'
                  }}</vs-button
                >
              </div>
            </div>
            <div v-if="placaEncontrada == true" ref="ModelosEncontrados">
              <vs-alert
                active="true"
                class="bg-secondary text-light mt-3 p-3 mb-3"
              >
                <p>
                  {{ dadosPlaca.marcaModelo }} - {{ dadosPlaca.ano }}/{{
                    dadosPlaca.anoModelo
                  }}
                  - <b>Situação</b> {{ dadosPlaca.situacao }}
                </p>
              </vs-alert>
              <div class="p-3 mb-3">
                Encontramos {{ modelosFipeEncontrados.length }} modelos que se
                assemelham ao seu veículo, selecione o Modelo correto.
              </div>
              <vs-list>
                <vs-list-item
                  v-for="item in modelosFipeEncontrados"
                  :key="item.codigo_fipe"
                  :variant="`${item.selecionado == true ? 'success' : ''}`"
                  :title="item.texto_modelo"
                  :subtitle="`${item.codigo_fipe}  /  ${item.ano_modelo}-${
                    item.combustivel
                  } ${item.score ? '(score-' + item.score + ')' : ''}`"
                >
                  <vs-radio
                    color="success"
                    v-model="radioSelecionado"
                    :vs-value="item.codigo_fipe"
                    @change="selecionaModelo(item)"
                  ></vs-radio>
                </vs-list-item>

                <vs-list-item title="Nenhum dos modelos acima">
                  <vs-radio
                    color="success"
                    v-model="radioSelecionado"
                    :vs-value="'nenhum'"
                    @change="
                      placaEncontrada = false;
                      btnDisabled2 = false;
                      formCompletoB2C = true;
                      cilindradas = null;
                    "
                  ></vs-radio>
                </vs-list-item>
              </vs-list>
              <div
                v-if="exibeCilindrada == true"
                class="vx-col sm:w-1/3 w-full mt-3 mb-2"
              >
                <vs-input
                  class="w-full"
                  label="Cilindradas"
                  name="Cilindradas"
                  id="Cilindradas"
                  type="number"
                  v-model="cilindradas"
                  v-validate="{ min: 3, required: true }"
                  :state="validateState('Cilindradas')"
                  :class="validateClass('Cilindradas')"
                />
              </div>
            </div>
            <div v-else>
              <div v-if="form.somenteAgregado" class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <label for="">
                    Placa do
                    {{
                      this.mascaraAgregado ? this.mascaraAgregado : 'agregado'
                    }}</label
                  >
                  <the-mask
                    mask="AAA-#XX#"
                    style="text-transform: uppercase"
                    id="placa3"
                    class="vs-inputx vs-input--input normal hasValue w-full"
                    v-model="form.placa"
                    name="placa3"
                    :masked="true"
                    v-validate="{ required: true, length: 8 }"
                    :state="validateState('Placa')"
                    :class="validateClass('Placa')"
                  />
                </div>

                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <label for="">
                    Chassi do
                    {{
                      this.mascaraAgregado ? this.mascaraAgregado : 'agregado'
                    }}</label
                  >
                  <vs-input
                    class="w-full"
                    name="Chassi do Agregado"
                    v-model="form.chassi"
                    v-validate="{ min: 17, max: 17 }"
                    :state="validateState('Chassi do Agregado')"
                    :danger="validateClass('Chassi do Agregado')"
                    @input="chassiToUpperCase(form.chassi)"
                    @keyup.native="verificaChassiBaseBP"
                  />
                </div>
              </div>

              <div v-if="form.somenteAgregado === true" class="vx-row">
                <div class="vx-col sm:w-1/1 w-full mb-2">
                  <label for="">
                    Descrição do
                    {{
                      this.mascaraAgregado ? this.mascaraAgregado : 'agregado'
                    }}</label
                  >
                  <vs-input
                    class="w-full"
                    name="Descição do Agregado"
                    v-model="form.descricaoAgregado"
                    v-validate="{ min: 5, required: true }"
                    :state="validateState('Descição do Agregado')"
                    :danger="validateClass('Descição do Agregado')"
                  />
                </div>
              </div>

              <div
                class="vx-row"
                v-if="
                  placaEncontrada == true ||
                  !exibirPlaca() ||
                  formCompletoB2C ||
                  (placaEncontrada == false && exibirIptDadosVeiculo == true)
                "
              >
                <div
                  v-if="form.somenteAgregado == false"
                  :class="`vx-col ${
                    isInterno == true ? 'sm:w-1/2' : 'sm:w-1/6'
                  } w-full mb-2`"
                >
                  <label for="" class="vs-select--label">Marca</label>
                  <v-select
                    :options="marcas"
                    name="Marca"
                    id="Marca"
                    @input="preencheModelo()"
                    v-model="idMarca"
                    v-validate="{ required: true }"
                    label="text"
                    :state="validateState('Marca')"
                    :class="validateClass('Marca')"
                    :disabled="desabilitaAlterarMarca"
                  ></v-select>
                </div>
                <div
                  v-else
                  :class="`vx-col ${
                    isInterno == true ? 'sm:w-1/2' : 'sm:w-1/2'
                  } w-full mb-2`"
                >
                  <label for="">
                    Marca do
                    {{
                      this.mascaraAgregado ? this.mascaraAgregado : 'agregado'
                    }}</label
                  >
                  <v-select
                    :options="marcaAgregadoImplemento"
                    v-model="form.veiculo.marca"
                    label="label"
                  ></v-select>
                </div>

                <div
                  v-if="form.somenteAgregado === false"
                  :class="`vx-col ${
                    exibeCilindrada == true
                      ? 'sm:w-1/3'
                      : isInterno == true
                      ? 'sm:w-1/2'
                      : 'sm:w-1/6'
                  } w-full mb-2`"
                >
                  <label for="" class="vs-select--label">Ano Modelo</label>
                  <v-select
                    :options="anosModelo"
                    name="Ano Modelo"
                    id="Ano Modelo"
                    @input="selecionaAnoModelo()"
                    v-model="idAnoModelo"
                    label="text"
                    :disabled="desabilitaAlterarAnoModelo"
                  ></v-select>
                </div>
                <div
                  v-else-if="this.idGrupo.permiteSomenteAgregado"
                  :class="`vx-col ${
                    exibeCilindrada == true
                      ? 'sm:w-1/3'
                      : isInterno == true
                      ? 'sm:w-1/2'
                      : 'sm:w-1/2'
                  } w-full mb-2`"
                >
                  <vs-input
                    class="w-full"
                    label="Ano Modelo"
                    name="Ano Modelo"
                    v-model="form.veiculo.anoModelo"
                    v-mask="'####'"
                    v-validate="{ min: 4, max: 4, required: true }"
                    :state="validateState('Ano Modelo')"
                    :danger="validateClass('Ano Modelo')"
                  />
                </div>

                <div
                  v-if="form.somenteAgregado === false"
                  class="vx-col sm:w-1/2 w-full mb-2"
                >
                  <label for="" class="vs-select--label">Modelo</label>
                  <v-select
                    :options="modelos"
                    name="Modelo"
                    id="Modelo"
                    @input="preencheAnos()"
                    v-model="idModelo"
                    v-validate="{ required: true }"
                    label="text"
                    :state="validateState('Modelo')"
                    :class="validateClass('Modelo')"
                    :disabled="desabilitaAlterarModelo"
                  ></v-select>
                </div>

                <div v-else class="vx-col sm:w-1/2 w-full mb-2">
                  <label for="">
                    Modelo do
                    {{
                      this.mascaraAgregado ? this.mascaraAgregado : 'agregado'
                    }}</label
                  >
                  <v-select
                    :options="modeloAgregadoImplemento"
                    v-model="form.veiculo.modelo"
                    label="label"
                  ></v-select>
                </div>

                <div
                  :class="`vx-col ${
                    exibeCilindrada == true
                      ? 'sm:w-1/3'
                      : isInterno == true
                      ? 'sm:w-1/2'
                      : 'sm:w-1/6'
                  } w-full mb-2`"
                  v-if="form.somenteAgregado === false"
                >
                  <label for="" class="vs-select--label">Ano Fabricação</label>
                  <v-select
                    :options="anosFabricacao"
                    name="Ano Fabricação"
                    id="Ano Fabricação"
                    @input="buscaValorFipe()"
                    v-model="idAnoFabricacao"
                    label="text"
                    :disabled="desabilitaAlterarAnoFabricacao"
                  ></v-select>
                </div>
                <div
                  :class="`vx-col ${
                    exibeCilindrada == true
                      ? 'sm:w-1/3'
                      : isInterno == true
                      ? 'sm:w-1/2'
                      : 'sm:w-1/2'
                  } w-full mb-2`"
                  v-else-if="this.idGrupo.permiteSomenteAgregado"
                >
                  <vs-input
                    class="w-full"
                    label="Ano Fabricação"
                    name="Ano Fabricação"
                    v-model="form.veiculo.anoFabricacao"
                    v-mask="'####'"
                    v-validate="{ min: 4, max: 4, required: true }"
                    :state="validateState('Ano Fabricação')"
                    :danger="validateClass('Ano Fabricação')"
                  />
                </div>
                <div
                  v-if="exibeCilindrada == true"
                  class="vx-col sm:w-1/3 w-full mb-2"
                >
                  <vs-input
                    class="w-full"
                    label="Cilindradas"
                    name="Cilindradas"
                    id="Cilindradas"
                    type="number"
                    v-model="cilindradas"
                    v-validate="{ min: 3, required: true }"
                    :state="validateState('Cilindradas')"
                    :class="validateClass('Cilindradas')"
                  />
                </div>
              </div>
            </div>

            <div v-if="form.implementos.length > 0">
              <h4 class="mb-3 mt-6">Implementos</h4>
              <hr class="" />
              <vs-list>
                <vs-list-item
                  v-for="(item, index) in form.implementos"
                  :key="index"
                  :title="definirTituloListaComplementos(item)"
                  :subtitle="definirSubTituloListaComplementos(item)"
                >
                  <div class="vs-row" style="display: flex; gap: 2px">
                    <vs-button
                      color="primary"
                      type="border"
                      icon="edit"
                      @click="
                        editarComplemento({ ...item, index: index }),
                          (tipoConfiguracaoCaminhao = 'implemento')
                      "
                    ></vs-button>
                    <vs-button
                      color="danger"
                      type="border"
                      icon="delete"
                      @click="excluirComplemento({ ...item, index: index })"
                    ></vs-button>
                  </div>
                </vs-list-item>
              </vs-list>
              <div
                v-if="exibeCilindrada == true"
                class="vx-col sm:w-1/3 w-full mt-3 mb-2"
              >
                <vs-input
                  class="w-full"
                  label="Cilindradas"
                  name="Cilindradas"
                  id="Cilindradas"
                  type="number"
                  v-model="cilindradas"
                  v-validate="{ min: 3, required: true }"
                  :state="validateState('Cilindradas')"
                  :class="validateClass('Cilindradas')"
                />
              </div>
            </div>

            <div
              v-if="
                form.agregados.length > 0 &&
                (form.agregados[0].comissaoAplicada !== 0 ||
                  form.agregados[0].valorComissaoAplicadaFinal !== 0)
              "
            >
              <h4 class="mb-3 mt-6">Agregados</h4>
              <hr class="" />
              <vs-list>
                <vs-list-item
                  v-for="(item, index) in form.agregados"
                  :key="index"
                  :title="definirTituloListaComplementos(item)"
                  :subtitle="definirSubTituloListaComplementos(item)"
                >
                  <div class="vs-row" style="display: flex; gap: 2px">
                    <vs-button
                      color="primary"
                      type="border"
                      icon="edit"
                      @click="
                        editarComplemento({ ...item, index: index }),
                          (tipoConfiguracaoCaminhao = 'agregado')
                      "
                    ></vs-button>
                    <vs-button
                      color="danger"
                      type="border"
                      icon="delete"
                      @click="excluirComplemento({ ...item, index: index })"
                    ></vs-button>
                  </div>
                </vs-list-item>
              </vs-list>
              <div
                v-if="exibeCilindrada == true"
                class="vx-col sm:w-1/3 w-full mt-3 mb-2"
              >
                <vs-input
                  class="w-full"
                  label="Cilindradas"
                  name="Cilindradas"
                  id="Cilindradas"
                  type="number"
                  v-model="cilindradas"
                  v-validate="{ min: 3, required: true }"
                  :state="validateState('Cilindradas')"
                  :class="validateClass('Cilindradas')"
                />
              </div>
            </div>

            <div
              class="vx-row"
              v-if="
                (isInterno &&
                  (form.placa ||
                    form.chassi ||
                    form.isZero ||
                    form.somenteAgregado)) ||
                this.propostaParaSomenteAgregado
              "
            >
              <div class="vx-col w-full">
                <h4 class="mb-3 mt-6">Valores de Cobertura</h4>
                <hr class="mb-6" />
              </div>
            </div>

            <div
              class="vx-row"
              v-if="
                (isInterno &&
                  (form.placa ||
                    form.chassi ||
                    form.isZero ||
                    form.somenteAgregado)) ||
                this.propostaParaSomenteAgregado
              "
            >
              <div
                v-if="isInterno || this.propostaParaSomenteAgregado"
                :class="`vx-col ${
                  isInterno == true && !exibirValorTotalConjunto
                    ? 'sm:w-1/2'
                    : 'sm:w-1/3'
                } w-full mb-2`"
              >
                <label for class="vs-input--label">{{
                  form.somenteAgregado ? 'Valor Principal' : 'Valor FIPE'
                }}</label>
                <money
                  class="vs-inputx vs-input--input normal"
                  name="Valor FIPE do Caminhão"
                  id="Valor FIPE do Caminhão"
                  v-model="form.precoVeiculo"
                  v-validate="{ required: true }"
                  :state="validateState('Valor FIPE do Caminhão')"
                  :danger="validateClass('Valor FIPE do Caminhão')"
                  v-bind="money"
                  :disabled="form.somenteAgregado === false ? true : false"
                ></money>
              </div>

              <div
                v-if="exibirValorTotalConjunto"
                :class="`vx-col ${
                  isInterno == true && !exibirValorTotalConjunto
                    ? 'sm:w-1/2'
                    : 'sm:w-1/3'
                } w-full mb-2`"
              >
                <label for class="vs-input--label"
                  >Valor total do conjunto</label
                >
                <money
                  class="vs-inputx vs-input--input normal"
                  name="Valor total do conjunto"
                  id="Valor total do conjunto"
                  v-model="form.valorTotalConjunto"
                  v-validate="{ required: true }"
                  :state="validateState('Valor total do conjunto')"
                  :danger="validateClass('Valor total do conjunto')"
                  v-bind="money"
                  disabled
                ></money>
              </div>

              <div
                :class="`vx-col ${
                  isInterno == true && !exibirValorTotalConjunto
                    ? 'sm:w-1/2'
                    : 'sm:w-1/3'
                } w-full mb-2`"
              >
                <label for class="vs-input--label"
                  >Digite o valor que será coberto</label
                >
                <money
                  class="vs-inputx vs-input--input normal"
                  name="Valor de Cobertura"
                  id="Valor de Cobertura"
                  v-model="form.valorCobertura"
                  v-validate="{ required: true, min: 0.01 }"
                  :state="validateState('Valor de Cobertura')"
                  :danger="validateClass('Valor de Cobertura')"
                  v-bind="money"
                  disabled
                ></money>
              </div>
            </div>

            <!-- Notasical veículo zero -->
            <div v-if="!exibirPlaca() && !verificaEmpresa()" class="vx-row">
              <div
                v-if="form.isZero == true"
                class="vx-col sm:w-1/4 w-full mb-2"
              >
                <vs-input
                  class="w-full"
                  label="Nota Fiscal"
                  v-model="form.nf"
                  name="Nota Fiscal"
                  id="Nota Fiscal"
                  v-validate="{ required: true }"
                  :state="validateState('Nota Fiscal')"
                  :danger="validateClass('Nota Fiscal')"
                />
              </div>

              <div
                v-if="form.isZero == true"
                class="vx-col sm:w-1/4 w-full mb-6"
              >
                <!-- <label for class="vs-input--label">{{
                  verificaEmpresa()
                    ? 'Data Saida NF'
                    : 'Data de Vencimento Nota'
                }}</label> -->
                <!-- <datepicker
                  class="inputData"
                  :format="'dd/MM/yyyy'"
                  label="DD/MM/YYYY"
                  v-model="form.dataNf"
                  name="Data de Vencimento Nota"
                  id="Data de Vencimento Nota"
                  v-validate="{ required: true }"
                  :state="validateState('Data de Vencimento Nota')"
                  :danger="validateClass('Data de Vencimento Nota')"
                ></datepicker> -->

                <vs-input
                  class="w-full"
                  label="Data de Vencimento Nota"
                  v-mask="'##/##/####'"
                  v-model="form.dataNf"
                  name="Data de Vencimento Nota"
                  id="Data de Vencimento Nota"
                  v-validate="'date_format:dd/MM/yyyy'"
                  :state="validateState('Data de Vencimento Nota')"
                  :danger="validateClass('Data de Vencimento Nota')"
                />
              </div>

              <div
                v-if="form.isZero == true"
                class="vx-col sm:w-1/4 w-full mb-2"
              >
                <label for class="vs-input--label">Valor Nota</label>
                <money
                  class="vs-inputx vs-input--input normal"
                  name="Valor Nota"
                  id="Valor Nota"
                  v-model="form.valorNf"
                  v-validate="{ required: true }"
                  :state="validateState('Valor Nota')"
                  :danger="validateClass('Valor Nota')"
                  v-bind="money"
                ></money>
              </div>

              <div class="vx-col sm:w-1/4 w-full mb-2">
                <vs-input
                  class="w-full"
                  label="Chassi"
                  v-model="form.chassi"
                  name="Chassi"
                  id="Chassi"
                  v-validate="{ required: true, min: 17, max: 17 }"
                  :state="validateState('Chassi')"
                  :danger="validateClass('Chassi')"
                  @input="chassiToUpperCase(form.chassi)"
                  @keyup.native="verificaChassiBaseBP"
                />
              </div>
            </div>

            <div v-if="permitirRestricoes" class="vx-row">
              <div class="vx-col sm:w-1/1 w-full mb-2">
                <label for="" class="vs-select--label">Restrições</label>
                <v-select
                  :options="restricoes"
                  name="Restrições"
                  id="Restrições"
                  multiple
                  v-model="restricoesSelecionadas"
                  v-validate="{ required: true }"
                  label="descricao"
                  @input="selecionaRestricoes()"
                  :state="validateState('Restrições')"
                  :class="validateClass('Restrições')"
                ></v-select>
              </div>
            </div>

            <div class="vx-row mt-4" v-if="isInterno == true">
              <div class="vx-col sm:w-1/2 w-full mb-6 flex items-center gap-3">
                <div style="width: 70px">
                  <vs-switch
                    color="success"
                    v-model="form.permiteInvoiceSelfService"
                    style="width: 60px"
                  >
                    <span slot="on">Sim</span>
                    <span slot="off">Não</span>
                  </vs-switch>
                </div>
                <span>Opcionais disponíveis para edição do beneficiário.</span>
              </div>

              <div
                v-if="
                  $can(
                    'Exibe opção de mostrar valores FIPE e cobertura na proposta',
                    'Cotações',
                  )
                "
                class="vx-col sm:w-1/2 w-full mb-6 flex items-center gap-3"
              >
                <div style="width: 70px">
                  <vs-switch
                    color="success"
                    v-model="form.exibirValoresVeiculoNaProposta"
                    style="width: 60px"
                  >
                    <span slot="on">Sim</span>
                    <span slot="off">Não</span>
                  </vs-switch>
                </div>
                <span>Exibir valores FIPE e de cobertura na proposta.</span>
              </div>
            </div>

            <vs-alert
              v-if="validaImplementosAgregados"
              color="danger"
              title="Atenção!!"
              active="true"
              class="my-3"
              style="height: auto !important"
            >
              <ul>
                <li class="mb-2">
                  {{ msgValidacaoImplementoAgregado }}
                </li>
              </ul>
            </vs-alert>

            <vs-alert
              v-if="$validator.errors.all().length > 0"
              color="danger"
              title="Atenção!!"
              active="true"
              class="my-3"
              style="height: auto !important"
            >
              <ul>
                <li
                  class="mb-2"
                  v-for="error in $validator.errors.all()"
                  :key="error.id"
                >
                  {{ error }}
                </li>
              </ul>
            </vs-alert>

            <div class="vx-row my-3">
              <vs-alert
                color="danger"
                title="Atenção"
                :active="desabilitaPropostaPorTipoVeiculoEstacionamento"
                >Não é possível fazer propostas quando o veículo é do tipo
                motorcicleta e o veículo não possui estacionamento
                privado.</vs-alert
              >
            </div>

            <div
              class="vx-row"
              style="flex-wrap: nowrap"
              :class="fixedButton ? 'fixed-buttons' : ''"
            >
              <div
                class="vx-col w-2/5 sm:w-full text-left mt-2 mb-2"
                v-if="isInterno"
              >
                <vs-button
                  :color="colorButton ? `#${colorButton}` : 'dark'"
                  type="border"
                  @click="voltarPasso()"
                >
                  Voltar</vs-button
                >
              </div>
              <!-- !veiculoSemGrupo -->
              <div class="vx-col w-3/5 sm:w-full text-right">
                <vs-button
                  :color="colorButton ? `#${colorButton}` : 'success'"
                  type="filled"
                  @click="buscar"
                  :disabled="
                    disableNovaProposta ||
                    desabilitaPropostaPorTipoVeiculoEstacionamento
                  "
                  class="mt-2 mb-2 rounded-lg botaoContratarAgora"
                  :class="insideApp == true || isLanding ? 'w-full' : ''"
                  :pill="isLanding ? true : false"
                >
                  <span>Fazer Proposta</span>
                  <img
                    v-if="isLanding"
                    src="../../assets/images/svg/iconArrowRight.svg"
                  />
                </vs-button>
              </div>
            </div>
          </div>

          <!-- Container de produtos -->
          <div v-else>
            <div v-if="!isLanding">
              <div ref="listagemProdutos" class="vx-row listagemProdutos">
                <!-- produtos veiculo -->
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <div
                    :style="`${
                      isInterno || exibeItensObrigatoriosB2C
                        ? ''
                        : 'display: none'
                    }`"
                  >
                    <h4 v-if="form.caminhao === true" class="mt-5 mb-3">
                      Veículo
                    </h4>
                    <h5 class="mb-5">{{ $t('Produtos Obrigatórios') }}</h5>
                    <ul class="centerx mb-5">
                      <li
                        class="itemprodutos py-4 flex flex-row w-full"
                        v-for="(item, index) in produtosObrigatorios"
                        :key="'Obri' + index"
                      >
                        <div
                          class="w-full flex flex-col gap-0 justify-center"
                          :class="{ lineThrough: !validaSelecionado(item) }"
                        >
                          {{ item.nomeProduto }}
                          <div class="flex justify-start">
                            <span
                              class="valorprod"
                              v-if="item.visivelProposta"
                              :style="item.style"
                              >{{ item.valor | currency }}</span
                            >
                            <span
                              class="valorprod"
                              v-if="
                                item.descontoConcedido > 0 &&
                                item.visivelProposta
                              "
                              >{{ item.valorFinal | currency }}</span
                            >
                            <span
                              class="valorprod"
                              v-if="item.ismensal && item.visivelProposta"
                              >/mês</span
                            >
                          </div>
                        </div>
                        <div class="w-2/5 flex flex-row justify-end gap-2">
                          <vs-button
                            color="success"
                            v-if="item.alterarValor && AlterarValorProduto"
                            @click="
                              (novoValorProduto = item),
                                (mostrarModalNovoValorProduto = true)
                            "
                          >
                            +
                          </vs-button>

                          <vs-button
                            v-if="
                              item.porcentagemDescontoMaxima &&
                              isInterno &&
                              verificaPermissaoDescontoPorPerfil(
                                item.idsPerfilDesconto,
                              )
                            "
                            @click="exibePorcentagemDesconto(item)"
                            color="dark"
                          >
                            %
                          </vs-button>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="vx-col sm:w-1/2 w-full mb-2" v-if="isInterno">
                  <h5 class="mb-5">{{ $t('Produtos Opcionais') }}</h5>
                  <ul class="mb-5">
                    <div v-if="isInterno === false">
                      <div
                        v-for="(item, index) in produtosNaoObrigatorios"
                        :key="'NObris' + index"
                      >
                        <li
                          v-if="item.exibir == true"
                          class="itemprodutos py-4 flex flex-row w-full justify-between align-center"
                        >
                          <div>
                            <vs-checkbox
                              @input="selecionaProduto(item)"
                              v-model="form.produtosSelecionados"
                              :vs-value="item"
                            />
                          </div>
                          <div class="ml-4">
                            {{ item.nomeProduto }}
                            <span
                              class="valorprod"
                              v-if="item.visivelProposta"
                              :style="item.style"
                              >{{ item.valor | currency }}</span
                            >
                            <span
                              class="valorprod"
                              v-if="
                                item.descontoConcedido > 0 &&
                                item.visivelProposta
                              "
                              >{{ item.valorFinal | currency }}</span
                            >
                            <span
                              class="valorprod mr-2"
                              v-if="item.ismensal && item.visivelProposta"
                              >/mês</span
                            >
                          </div>
                          <!-- </vs-checkbox> -->
                          <div class="flex flex-row justify-end">
                            <vs-button
                              class="mr-2"
                              color="success"
                              v-if="item.alterarValor && AlterarValorProduto"
                              @click="
                                (novoValorProduto = item),
                                  (mostrarModalNovoValorProduto = true)
                              "
                              >+</vs-button
                            ><vs-button
                              v-if="
                                item.porcentagemDescontoMaxima &&
                                isInterno &&
                                verificaPermissaoDescontoPorPerfil(
                                  item.idsPerfilDesconto,
                                )
                              "
                              @click="exibePorcentagemDesconto(item)"
                              color="dark"
                              class="ml-2"
                            >
                              %
                            </vs-button>
                          </div>
                        </li>
                      </div>
                    </div>
                    <div v-if="isInterno">
                      <div
                        v-for="(item, index) in produtosNaoObrigatorios"
                        :key="'NObri' + index"
                        v-show="isInterno"
                      >
                        <li
                          v-if="item.exibir == true"
                          class="itemprodutos flex flex-row w-full justify-between"
                        >
                          <div>
                            <vs-checkbox
                              @input="selecionaProduto(item)"
                              v-model="form.produtosSelecionados"
                              :vs-value="item"
                            >
                              <div class="ml-2 flex flex-col">
                                {{ item.nomeProduto }}
                                <div class="flex flex-row">
                                  <span
                                    class="valorprod"
                                    v-if="item.visivelProposta"
                                    :style="item.style"
                                    >{{ item.valor | currency }}</span
                                  >
                                  <span
                                    class="valorprod"
                                    v-if="
                                      item.descontoConcedido > 0 &&
                                      item.visivelProposta
                                    "
                                    >{{ item.valorFinal | currency }}</span
                                  >
                                  <span
                                    class="valorprod mr-2"
                                    v-if="item.ismensal && item.visivelProposta"
                                    >/mês</span
                                  >
                                </div>
                              </div>
                            </vs-checkbox>
                          </div>
                          <div
                            class="flex flex-row justify-center items-center"
                          >
                            <vs-button
                              class="mr-2"
                              color="success"
                              v-if="item.alterarValor && AlterarValorProduto"
                              @click="
                                (novoValorProduto = item),
                                  (mostrarModalNovoValorProduto = true)
                              "
                              >+</vs-button
                            >
                            <vs-button
                              v-if="
                                item.porcentagemDescontoMaxima &&
                                isInterno &&
                                verificaPermissaoDescontoPorPerfil(
                                  item.idsPerfilDesconto,
                                )
                              "
                              @click="exibePorcentagemDesconto(item)"
                              color="dark"
                            >
                              %
                            </vs-button>
                          </div>
                        </li>
                      </div>
                    </div>
                  </ul>
                </div>
                <div class="vx-col w-full mb-2" v-if="isInterno">
                  <div
                    class="flex items-start flex-col justify-start w-full py-4"
                    v-if="configurarComissao"
                  >
                    <h5 class="mb-5 flex-shrink-0">Comissão</h5>

                    <div class="flex items-center justify-center w-full gap-2">
                      <input
                        type="range"
                        class="slider h-2 rounded-lg appearance-none cursor-pointer w-full"
                        :min="comissionamento.minValue"
                        :max="comissionamento.maxValue"
                        v-model="form.comissaoAplicada"
                      />
                      <strong class="flex-shrink-0 text-lg"
                        >{{ form.comissaoAplicada }}%</strong
                      >
                    </div>
                  </div>
                  <div :style="`${isInterno ? '' : 'display: none'}`">
                    <hr class="my-2" />
                    <h6 class="mt-5" v-if="showTotalEntry">
                      Valor Mensal:
                      {{ totalSemComissao | currency }}
                    </h6>
                    <h6 class="mt-5" v-if="configurarComissao">
                      Valor Comissionamento:
                      {{ form.valorComissaoAplicadaFinal | currency }}
                    </h6>
                    <h6 class="mt-5">
                      Total Mensal:
                      {{ totalMensalidade | currency }}
                    </h6>
                    <h6 class="mt-5" v-if="showTotalEntry">
                      Total Entrada:
                      {{ totalEntrada | currency }}
                    </h6>
                    <hr class="my-2" />
                  </div>
                </div>
              </div>
              <!-- agregados -->
              <div
                v-if="form.agregados.length > 0 && !form.unificarAgregados"
                class="vx-col sm:w-1/2 w-full mb-2 mt-5"
              >
                <h4 class="mt-5 mb-4">Agregados</h4>
                <div
                  v-for="(agregado, id) in form.agregados"
                  :key="'agreg' + id"
                  class="mt-5 mb-2"
                  :style="`${
                    isInterno || exibeItensObrigatoriosB2C
                      ? ''
                      : 'display: none'
                  }`"
                >
                  <h5 class="mt-5 mb-3">
                    {{ agregado.placa || agregado.chassi }} -
                    {{ agregado.descricao }}
                  </h5>
                  <div class="ml-6" v-if="agregado.produtosObrigatorios.length">
                    <h5 class="mb-5">{{ $t('Produtos Obrigatórios') }}</h5>
                    <ul class="centerx mb-2">
                      <li
                        class="itemprodutos mb-2 flex flex-row w-full justify-between"
                        v-for="(
                          produtoObrigatorio, prodIndex
                        ) in agregado.produtosObrigatorios"
                        :key="'Obri' + prodIndex"
                      >
                        <vs-checkbox
                          v-model="form.agregados[id].produtosSelecionados"
                          :vs-value="produtoObrigatorio"
                          :disabled="true"
                          @input="selecionaProduto(produtoObrigatorio, id)"
                        >
                          {{ produtoObrigatorio.nomeProduto }}
                          <span
                            class="mr-2 valorprod"
                            v-if="produtoObrigatorio.visivelProposta"
                            :style="produtoObrigatorio.style"
                            >{{ produtoObrigatorio.valor | currency }}</span
                          >
                          <span
                            class="valorprod mr-2"
                            v-if="
                              produtoObrigatorio.descontoConcedido > 0 &&
                              produtoObrigatorio.visivelProposta
                            "
                            >{{
                              produtoObrigatorio.valorFinal | currency
                            }}</span
                          >
                          <span
                            class="valorprod"
                            v-if="
                              produtoObrigatorio.ismensal &&
                              produtoObrigatorio.visivelProposta
                            "
                            >/mês</span
                          >
                        </vs-checkbox>
                        <div class="flex flex-row justify-end">
                          <vs-button
                            class="mr-2"
                            color="success"
                            v-if="
                              produtoObrigatorio.alterarValor &&
                              AlterarValorProduto
                            "
                            @click="
                              (novoValorProduto = produtoObrigatorio),
                                (mostrarModalNovoValorProduto = true)
                            "
                            >+</vs-button
                          >
                          <vs-button
                            v-if="
                              produtoObrigatorio.porcentagemDescontoMaxima &&
                              isInterno &&
                              verificaPermissaoDescontoPorPerfil(
                                produtoObrigatorio.idsPerfilDesconto,
                              )
                            "
                            @click="
                              exibePorcentagemDesconto(
                                produtoObrigatorio,
                                id,
                                'agregado',
                              )
                            "
                            color="dark"
                          >
                            %
                          </vs-button>
                        </div>
                      </li>
                    </ul>

                    <h5 class="mb-5">{{ $t('Produtos Opcionais') }}</h5>
                    <ul class="centerx">
                      <li
                        class="itemprodutos mb-2"
                        v-for="(
                          prodNaoObrigatorio, prodNIndex
                        ) in agregado.produtosNaoObrigatorios"
                        :key="'NObris' + prodNIndex"
                        v-show="isInterno === false"
                      >
                        <vs-checkbox
                          @input="selecionaProduto(prodNaoObrigatorio, id)"
                          v-model="form.agregados[id].produtosSelecionados"
                          :vs-value="prodNaoObrigatorio"
                        >
                          {{ prodNaoObrigatorio.nomeProduto }}
                          <span
                            class="mr-2 valorprod"
                            v-if="prodNaoObrigatorio.visivelProposta"
                            :style="prodNaoObrigatorio.style"
                            >{{ prodNaoObrigatorio.valor | currency }}</span
                          >
                          <span
                            class="valorprod"
                            v-if="
                              prodNaoObrigatorio.descontoConcedido > 0 &&
                              prodNaoObrigatorio.visivelProposta
                            "
                            >{{
                              prodNaoObrigatorio.valorFinal | currency
                            }}</span
                          >
                          <span
                            class="valorprod mr-2"
                            v-if="
                              prodNaoObrigatorio.ismensal &&
                              prodNaoObrigatorio.visivelProposta &&
                              verificaPermissaoDescontoPorPerfil(
                                prodNaoObrigatorio.idsPerfilDesconto,
                              )
                            "
                            >/mês</span
                          ><vs-button
                            v-if="
                              prodNaoObrigatorio.porcentagemDescontoMaxima &&
                              isInterno
                            "
                            @click="
                              exibePorcentagemDesconto(
                                prodNaoObrigatorio,
                                id,
                                'agregado',
                              )
                            "
                            color="dark"
                            class="ml-2"
                          >
                            %
                          </vs-button>
                        </vs-checkbox>
                      </li>
                      <li
                        class="itemprodutos mb-2 flex flex-row w-full justify-between"
                        v-for="(
                          prodNaoObrigatorio, prodNIndex
                        ) in agregado.produtosNaoObrigatorios"
                        :key="'NObri' + prodNIndex"
                        v-show="isInterno"
                      >
                        <vs-checkbox
                          @input="selecionaProduto(prodNaoObrigatorio, id)"
                          v-model="form.agregados[id].produtosSelecionados"
                          :vs-value="prodNaoObrigatorio"
                        >
                          {{ prodNaoObrigatorio.nomeProduto }}
                          <span
                            class="mr-2 valorprod"
                            v-if="prodNaoObrigatorio.visivelProposta"
                            :style="prodNaoObrigatorio.style"
                            >{{ prodNaoObrigatorio.valor | currency }}</span
                          >
                          <span
                            class="valorprod"
                            v-if="
                              prodNaoObrigatorio.descontoConcedido > 0 &&
                              prodNaoObrigatorio.visivelProposta
                            "
                            >{{
                              prodNaoObrigatorio.valorFinal | currency
                            }}</span
                          >
                          <span
                            class="valorprod mr-2"
                            v-if="
                              prodNaoObrigatorio.ismensal &&
                              prodNaoObrigatorio.visivelProposta
                            "
                            >/mês</span
                          >
                        </vs-checkbox>
                        <div class="flex flex-row justify-end">
                          <vs-button
                            class="mr-2"
                            color="success"
                            v-if="
                              prodNaoObrigatorio.alterarValor &&
                              AlterarValorProduto
                            "
                            @click="
                              (novoValorProduto = prodNaoObrigatorio),
                                (mostrarModalNovoValorProduto = true)
                            "
                            >+</vs-button
                          >
                          <vs-button
                            v-if="
                              prodNaoObrigatorio.porcentagemDescontoMaxima &&
                              isInterno &&
                              verificaPermissaoDescontoPorPerfil(
                                prodNaoObrigatorio.idsPerfilDesconto,
                              )
                            "
                            @click="
                              exibePorcentagemDesconto(
                                prodNaoObrigatorio,
                                null,
                                'agregado',
                              )
                            "
                            color="dark"
                            class="ml-2"
                          >
                            %
                          </vs-button>
                        </div>
                      </li>
                    </ul>
                    <div
                      class="flex items-start flex-col justify-start w-full py-4"
                      v-if="configurarComissao"
                    >
                      <h5 class="mb-5 flex-shrink-0">Comissão Agregados</h5>

                      <div
                        class="flex items-center justify-center w-full gap-2"
                      >
                        <input
                          type="range"
                          class="slider h-2 rounded-lg appearance-none cursor-pointer w-full"
                          :min="comissionamento.minValue"
                          :max="comissionamento.maxValue"
                          v-model="form.agregados[id].comissaoAplicada"
                        />
                        <strong class="flex-shrink-0 text-lg"
                          >{{ form.agregados[id].comissaoAplicada }}%</strong
                        >
                      </div>
                    </div>

                    <div
                      class="flex items-start flex-col justify-start w-full py-4"
                      v-if="configurarComissao"
                    >
                      <h5 class="mb-5 flex-shrink-0">Comissão Agregados</h5>

                      <div
                        class="flex items-center justify-center w-full gap-2"
                      >
                        <input
                          type="range"
                          class="slider h-2 rounded-lg appearance-none cursor-pointer w-full"
                          :min="comissionamento.minValue"
                          :max="comissionamento.maxValue"
                          v-model="form.agregados[id].comissaoAplicada"
                        />
                        <strong class="flex-shrink-0 text-lg"
                          >{{ form.agregados[id].comissaoAplicada }}%</strong
                        >
                      </div>
                    </div>

                    <div :style="`${isInterno ? '' : 'display: none'}`">
                      <hr class="my-2" />
                      <h6 class="mt-5" v-if="configurarComissao">
                        Valor Mensal:
                        {{ totalSemComissaoAgregado[id] | currency }}
                      </h6>
                      <h6 class="mt-5" v-if="configurarComissao">
                        Valor Comissionamento:
                        {{ valorComissaoAplicadaFinalAgregado[id] | currency }}
                      </h6>
                      <h6 class="mt-5">
                        Total Mensal:
                        {{ totalMensalidadeAgregado[id] | currency }}
                      </h6>
                      <h6 class="mt-5" v-if="showTotalEntry">
                        Total Entrada:
                        {{ totalEntradaAgregado[id] | currency }}
                      </h6>
                      <hr class="my-2" />
                    </div>
                  </div>
                  <div v-else class="vx-col sm:w-1/2 w-full mb-2 mt-5">
                    <vs-alert
                      title="Atenção"
                      active="true"
                      color="danger"
                      style="max-height: 220px !important"
                    >
                      Nenhum produto encontrado para esse agregado, verifique se
                      há produtos disponíveis para essa faixa de valor
                    </vs-alert>
                  </div>
                </div>
              </div>

              <!-- agregados unificados-->
              <div
                v-if="form.agregados.length > 0 && form.unificarAgregados"
                class="mb-2 mt-5"
                style="border-top: dotted 3px #00000061"
              >
                <div class="vx-row flex items-center">
                  <div class="vx-col sm:w-1/2 w-full">
                    <h4 class="mt-5 mb-4">Agregados unificados</h4>
                    <div
                      v-for="(agregado, id) in form.agregados"
                      :key="'agreg' + id"
                      class="mb-6"
                      :style="`${
                        isInterno || exibeItensObrigatoriosB2C
                          ? ''
                          : 'display: none'
                      }`"
                    >
                      <h5 class="px-4">
                        {{ agregado.placa || agregado.chassi }} -
                        {{ agregado.descricao }}
                      </h5>
                    </div>

                    <h5 class="mb-5">
                      {{ $t('Produtos Obrigatórios') }} dos Agregados
                    </h5>
                    <ul class="centerx mb-2">
                      <li
                        class="itemprodutos mb-2 flex flex-row w-full justify-between"
                        v-for="(produtoObrigatorio, prodIndex) in form
                          .produtosAgregados.produtosObrigatorios"
                        :key="'Obri' + prodIndex"
                      >
                        <vs-checkbox
                          v-model="form.produtosAgregados.produtosSelecionados"
                          :vs-value="produtoObrigatorio"
                          :disabled="validaSelecionado(produtoObrigatorio)"
                          @input="
                            selecionaProduto(produtoObrigatorio, prodIndex)
                          "
                        >
                          {{ produtoObrigatorio.nomeProduto }}
                          <span
                            class="mr-2 valorprod"
                            v-if="produtoObrigatorio.visivelProposta"
                            :style="produtoObrigatorio.style"
                            >{{ produtoObrigatorio.valor | currency }}</span
                          >
                          <span
                            class="valorprod mr-2"
                            v-if="
                              produtoObrigatorio.descontoConcedido > 0 &&
                              produtoObrigatorio.visivelProposta
                            "
                            >{{
                              produtoObrigatorio.valorFinal | currency
                            }}</span
                          >
                          <span
                            class="valorprod"
                            v-if="
                              produtoObrigatorio.ismensal &&
                              produtoObrigatorio.visivelProposta
                            "
                            >/mês</span
                          >
                        </vs-checkbox>
                        <div class="flex flex-row justify-end">
                          <vs-button
                            class="mr-2"
                            color="success"
                            v-if="
                              produtoObrigatorio.alterarValor &&
                              AlterarValorProduto
                            "
                            @click="
                              (novoValorProduto = produtoObrigatorio),
                                (mostrarModalNovoValorProduto = true)
                            "
                            >+</vs-button
                          >
                          <vs-button
                            v-if="
                              produtoObrigatorio.porcentagemDescontoMaxima &&
                              isInterno &&
                              verificaPermissaoDescontoPorPerfil(
                                produtoObrigatorio.idsPerfilDesconto,
                              )
                            "
                            @click="
                              exibePorcentagemDesconto(
                                produtoObrigatorio,
                                0,
                                'agregado',
                              )
                            "
                            color="dark"
                          >
                            %
                          </vs-button>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div class="vx-col sm:w-1/2 w-full">
                    <h5 class="mb-5">
                      {{ $t('Produtos Opcionais') }} dos Agregados
                    </h5>
                    <ul class="centerx">
                      <li
                        class="itemprodutos mb-2"
                        v-for="(prodNaoObrigatorio, prodNIndex) in form
                          .produtosAgregados.produtosNaoObrigatorios"
                        :key="'NObris' + prodNIndex"
                        v-show="isInterno === false"
                      >
                        <vs-checkbox
                          @input="selecionaProduto(prodNaoObrigatorio)"
                          v-model="form.produtosAgregados.produtosSelecionados"
                          :vs-value="prodNaoObrigatorio"
                        >
                          {{ prodNaoObrigatorio.nomeProduto }}
                          <span
                            class="mr-2 valorprod"
                            v-if="prodNaoObrigatorio.visivelProposta"
                            :style="prodNaoObrigatorio.style"
                            >{{ prodNaoObrigatorio.valor | currency }}</span
                          >
                          <span
                            class="valorprod"
                            v-if="
                              prodNaoObrigatorio.descontoConcedido > 0 &&
                              prodNaoObrigatorio.visivelProposta
                            "
                            >{{
                              prodNaoObrigatorio.valorFinal | currency
                            }}</span
                          >
                          <span
                            class="valorprod mr-2"
                            v-if="
                              prodNaoObrigatorio.ismensal &&
                              prodNaoObrigatorio.visivelProposta &&
                              verificaPermissaoDescontoPorPerfil(
                                prodNaoObrigatorio.idsPerfilDesconto,
                              )
                            "
                            >/mês</span
                          ><vs-button
                            v-if="
                              prodNaoObrigatorio.porcentagemDescontoMaxima &&
                              isInterno
                            "
                            @click="
                              exibePorcentagemDesconto(
                                prodNaoObrigatorio,
                                id,
                                'agregado',
                              )
                            "
                            color="dark"
                            class="ml-2"
                          >
                            %
                          </vs-button>
                        </vs-checkbox>
                      </li>

                      <li
                        class="itemprodutos mb-2 flex flex-row w-full justify-between"
                        v-for="(prodNaoObrigatorio, prodNIndex) in form
                          .produtosAgregados.produtosNaoObrigatorios"
                        :key="'NObri' + prodNIndex"
                        v-show="isInterno"
                      >
                        <vs-checkbox
                          @input="
                            selecionaProduto(prodNaoObrigatorio, prodNIndex)
                          "
                          v-model="form.produtosAgregados.produtosSelecionados"
                          :vs-value="prodNaoObrigatorio"
                        >
                          {{ prodNaoObrigatorio.nomeProduto }}
                          <span
                            class="mr-2 valorprod"
                            v-if="prodNaoObrigatorio.visivelProposta"
                            :style="prodNaoObrigatorio.style"
                            >{{ prodNaoObrigatorio.valor | currency }}</span
                          >
                          <span
                            class="valorprod"
                            v-if="
                              prodNaoObrigatorio.descontoConcedido > 0 &&
                              prodNaoObrigatorio.visivelProposta
                            "
                            >{{
                              prodNaoObrigatorio.valorFinal | currency
                            }}</span
                          >
                          <span
                            class="valorprod mr-2"
                            v-if="
                              prodNaoObrigatorio.ismensal &&
                              prodNaoObrigatorio.visivelProposta
                            "
                            >/mês</span
                          >
                        </vs-checkbox>
                        <div class="flex flex-row justify-end">
                          <vs-button
                            class="mr-2"
                            color="success"
                            v-if="
                              prodNaoObrigatorio.alterarValor &&
                              AlterarValorProduto
                            "
                            @click="
                              (novoValorProduto = prodNaoObrigatorio),
                                (mostrarModalNovoValorProduto = true)
                            "
                            >+</vs-button
                          >
                          <vs-button
                            v-if="
                              prodNaoObrigatorio.porcentagemDescontoMaxima &&
                              isInterno &&
                              verificaPermissaoDescontoPorPerfil(
                                prodNaoObrigatorio.idsPerfilDesconto,
                              )
                            "
                            @click="
                              exibePorcentagemDesconto(
                                prodNaoObrigatorio,
                                null,
                                'agregado',
                              )
                            "
                            color="dark"
                            class="ml-2"
                          >
                            %
                          </vs-button>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div :style="`${isInterno ? '' : 'display: none'}`">
                  <hr class="my-2" />
                  <h6 class="mt-5">
                    Total Mensal:
                    {{ somaValoresAgregadoUnificado(true) | currency }}
                  </h6>
                  <h6 class="mt-5">
                    Total à vista:
                    {{ somaValoresAgregadoUnificado(false) | currency }}
                  </h6>
                </div>
              </div>

              <!-- implementos -->
              <div
                v-if="form.implementos.length > 0"
                class="vx-col sm:w-1/2 w-full mb-5 mt-5"
              >
                <h4 class="mt-5 mb-4">Implementos</h4>
                <div
                  v-for="(implemento, id) in form.implementos"
                  :key="`imple-${id}`"
                  class="mt-5 mb-2"
                  :style="`${
                    isInterno || exibeItensObrigatoriosB2C
                      ? ''
                      : 'display: none'
                  }`"
                >
                  <h5 class="mt-5 mb-3" style="">
                    {{ implemento.descricao }} - {{ implemento.marca }}
                    {{ implemento.modelo }}
                  </h5>
                  <ul class="centerx mb-2">
                    <li class="itemprodutos mb-2">
                      <vs-checkbox
                        :vs-value="implemento"
                        :disabled="true"
                        :checked="true"
                      >
                        Valor de Cobertura
                        <span class="valorprod mr-2">{{
                          implemento.valorCobertura | currency
                        }}</span>
                      </vs-checkbox>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Botões voltar, salvar, cancelar -->
            <div
              v-if="!isLanding"
              class="vx-row"
              :class="fixedButton == true ? 'fixed-buttons' : ''"
            >
              <div class="vx-col sm:w-1/2 text-left">
                <vs-button
                  :color="colorButton ? `#${colorButton}` : 'dark'"
                  @click.stop.prevent="voltar()"
                  type="border"
                  class="mt-2 mb-2"
                  :class="insideApp == true ? 'w-full' : ''"
                  >Voltar</vs-button
                >
              </div>
              <div class="vx-col sm:w-1/2 text-right">
                <vs-button
                  v-if="formasPagamentoEncontradas == true"
                  :color="colorButton ? `#${colorButton}` : 'success'"
                  @click.stop.prevent="(btnBlock = true), GerarPropostaSite()"
                  type="gradient"
                  class="mt-2 mb-2"
                  :class="insideApp == true ? 'w-full' : ''"
                  :disabled="btnBlock"
                  >Concluir proposta</vs-button
                >
                <vs-button
                  v-else
                  color="warning"
                  @click="buscaFormasPagamento()"
                  type="gradient"
                  class="mt-2 mb-2"
                  :class="insideApp == true ? 'w-full' : ''"
                  >Buscar Formas de Pagamento</vs-button
                >
              </div>
            </div>
          </div>
        </form>

        <div v-if="passo == 0 && isInterno" class="vx-row">
          <div class="vx-col w-full text-right mt-5">
            <vs-button
              color="success"
              :disabled="!propostaMultipla"
              @click="onSubmit()"
              >Avançar</vs-button
            >
          </div>
        </div>

        <vs-button
          v-if="insideApp"
          color="dark"
          type="border"
          :class="insideApp == true ? 'w-full' : ''"
          :href="{
            url: `${getWindow().replace('adm.', 'app.')}/?idEmpresa=${
              form.idEmpresa
            }`,
          }"
          >Voltar para o Login</vs-button
        >
      </vx-card>

      <!-- Modal do cartão de credito -->
      <vs-popup
        class="holamundo"
        title="Dados do Cartão"
        :active.sync="modalCreditCard"
      >
        <cartaoCredito
          @adicionar="adicionarCartaoLista"
          :idProspect="form.idProspect"
          :typeCard="isCartaoMensal ? 'isCartaoMensal' : 'isCartaoAvista'"
        ></cartaoCredito>
      </vs-popup>

      <vs-popup
        class="holamundo"
        title="Veículo Sem grupo"
        :active.sync="veiculoSemGrupo"
      >
        <vs-alert
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
        >
          Não foi possível realizar sua cotação, pois o modelo deste veículo não
          está vinculado a um grupo, favor entrar em contato com seu líder.
        </vs-alert>
      </vs-popup>

      <!-- Modal placa recusada -->
      <vs-popup
        class="holamundo"
        title="Placa Recusada"
        :active.sync="modalPlacaRecusada"
        @close="fecharModalPlaca()"
      >
        <h5>{{ situacaoPlaca }}</h5>

        <ul v-if="codigoSituacaoPlaca === '999'" class="mt-2 mb-2">
          <li>
            <b
              ><strong
                >{{ form.placa ? 'Placa: ' : 'Chassi: ' }}
                {{
                  form.placa
                    ? `${form.placa} Placa Alternativa: ${obterPlacaAlternativa}`
                    : form.chassi
                }}</strong
              ></b
            >
          </li>
          <li>
            <b
              >{{ $t('Regional') }}:
              <strong>{{ regionalConsultorPlaca }}</strong>
            </b>
          </li>
          <li>
            <b
              >{{ $t('Consultor') }}:
              <strong>{{ nomeConsultorPlaca }}</strong></b
            >
          </li>
        </ul>

        <h5 v-if="codigoSituacaoPlaca === '999'">
          informe outra placa para dar continuidade
        </h5>
        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              @click="fecharModalPlaca()"
              type="gradient"
              color="warning"
              class="mt-5"
            >
              <feather-icon
                class="text-white"
                icon="CheckIcon"
                svgClasses="h-4 w-4"
              ></feather-icon>
              Entendi
            </vs-button>
          </div>
        </div>
      </vs-popup>

      <vs-popup
        class="holamundo"
        title="Atenção!"
        :active.sync="openEscolherAssociado"
      >
        <vs-alert
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
          color="danger"
        >
          Foram encontrados um ou mais associados / prospects com esse email,
          você pode escolher um para continuar ou clicar em nenhum destes e
          criar um novo registro!
        </vs-alert>
        <table class="table table-bordered">
          <tr v-for="(item, index) in associadoEncontrado" :key="index">
            <td :data="item.nome">
              <label>NOME:</label> {{ item.nome }}
              <br />
              <label>CELULAR:</label>{{ item.celular }}<br />
              <label>SITUAÇÃO:</label
              >{{ item.situacao == null ? 'Prospect' : item.situacao }}
            </td>
            <td>
              <vs-button
                @click="selecionaPorEmail(item)"
                type="gradient"
                color="success"
              >
                <feather-icon
                  class="text-white"
                  icon="CheckIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
              </vs-button>
            </td>
          </tr>
          <tr class="con-vs-alert my-3 con-vs-alert-danger">
            <td>Nenhum destes</td>
            <td>
              <vs-button
                @click="selecionaPorEmail({})"
                type="gradient"
                color="success"
              >
                <feather-icon
                  class="text-white"
                  icon="CheckIcon"
                  svgClasses="h-4 w-4"
                ></feather-icon>
              </vs-button>
            </td>
          </tr>
        </table>
      </vs-popup>

      <!-- modal Configurações caminhão -->
      <vs-popup
        class="holamundo"
        :title="`Adicionar ${popupTitle()}`"
        :active.sync="modalComplemento"
        @close="
          modalComplemento = false;
          resetFormComplemento = true;
        "
      >
        <!-- criar componete form Agregado -->
        <FormComplemento
          :idEmpresa="this.form.idEmpresa"
          :idGrupoVeiculo="idGrupoVinculoAgregado"
          :dadosComplemento="agregadoSelecionado"
          :resetFormComplemento="resetFormComplemento"
          :exibirFormCompleto="exibirFormComplementoCompleto"
          :grupos="gruposAgregados"
          :tipoComplemento="tipoConfiguracaoCaminhao"
          :mascaraAgregado="mascaraAgregado"
          :mascaraImplemento="mascaraImplemento"
          :ativaMascarasVeiculos="ativaMascarasVeiculos"
          :permitePlacaDuplicada="permitePlacaDuplicada"
          :tipoProposta="this.form.tipoProposta"
          :unificarAgregados="form.unificarAgregados"
          :grupoAgregadoSelecionado="grupoAgregadoSelecionado"
          :precoVeiculo="this.form.precoVeiculo"
          @adicionar="adicionarComplemento"
          @atualizar="AtualizarComplemento"
        >
        </FormComplemento>
      </vs-popup>

      <!-- Modal desconto -->
      <vs-popup
        class="holamundo"
        :title="titleSideBar"
        :active.sync="modalForm"
      >
        <formDesconto
          :key="contFormDesconto"
          :dados="itens"
          :produtosSelecionados="formDadosProdutosSelecionadosDesconto"
          :contador="contFormDesconto"
          :valorMensalidade="valorMensalidadeBaseDesconto"
          :modal="modalForm"
          :decoded="decoded"
          @salvarDesconto="salvarDesconto"
        >
        </formDesconto>
      </vs-popup>
      <!-- START MODAL NOVO VALOR PRODUTO -->
      <vs-popup
        id="meu-popup-personalizado"
        :title="'Novo Valor Produto'"
        :active.sync="mostrarModalNovoValorProduto"
      >
        <FormNovoValorProduto
          v-if="mostrarModalNovoValorProduto"
          :produto="novoValorProduto"
          @close="mostrarModalNovoValorProduto = false"
        ></FormNovoValorProduto>
      </vs-popup>
      <!-- END MODAL NOVO VALOR PRODUTO -->
      <!-- --------------------START MODAL GRUPOS-------------------------- -->
      <vs-popup
        v-if="mostrarModalGrupos"
        class="holamundo"
        :title="'Grupo de Veículos'"
        :active.sync="mostrarModalGrupos"
        style="z-index: 99999"
      >
        <vs-list>
          <vs-list-item
            v-for="(grupoTipo, index) in gruposModal.length > 0
              ? gruposModal
              : grupos"
            :key="index"
            :title="grupoTipo.label"
            :subtitle="grupoTipo.descricaoProdutos"
          >
            <vs-radio
              color="rgb(47,53,102)"
              v-model="idGrupo"
              :vs-value="grupoTipo"
              @change="
                selecionaTipo(),
                  preencheMarca(),
                  fecharModal(),
                  verificarSomenteAgregadoPemiteComplemento()
              "
            ></vs-radio>
          </vs-list-item>
        </vs-list>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="flex-end">
            <vs-button
              @click="(mostrarModalGrupos = false), selecionaTipo"
              color="primary"
              type="gradient"
              class="mr-3 mt-2 mb-2"
              :disabled="!Object.hasOwn(idGrupo, 'label')"
              >Escolher</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-popup>
      <!-- --------------------END MODAL GRUPOS-------------------------- -->

      <!-- modal data saída nf invalido -->
      <vs-popup
        class="holamundo"
        title="Data de saída da nota fiscal inválida"
        :active.sync="modalInfoDataSaidaNf"
        @close="modalInfoDataSaidaNf = false"
      >
        A data de saída da nota físcal é inválida, a saída do veículo deve ter
        no máximo {{ diasZeroKM }} dias {{ calcularDiasUteisNfVistoria }}.

        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              @click="modalInfoDataSaidaNf = false"
              type="gradient"
              color="warning"
              class="mt-5"
            >
              <feather-icon
                class="text-white"
                icon="CheckIcon"
                svgClasses="h-4 w-4"
              ></feather-icon>
              Entendi
            </vs-button>
          </div>
        </div>
      </vs-popup>
    </div>
    <div v-else>
      <vs-alert
        title="Atenção"
        active="true"
        color="danger"
        icon="new_releases"
      >
        Você não tem permissão para gerar proposta.
      </vs-alert>
    </div>
  </div>
</template>

<script>
import locale from './../../locale';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import functions from '../../utils/functions';
import { Money } from 'v-money';
import jwt from 'jsonwebtoken';
import cartaoCredito from './../forms/FormCartaoCredito.vue';
import FormComplemento from '../forms/FormComplemento.vue';
import formDesconto from '../forms/formDesconto.vue';
import dateConversion from '../../utils/dateConversion';
import FormNovoValorProduto from '../forms/FormNovoValorProduto.vue';
import regionaisService from '../../services/regionais';
import {
  consultaPlaca,
  buscarPlacaBaseBP,
  obterParticipacaoProduto,
  preparaPlacaParaConsulta,
} from '../../services/cotacao';
import { buscaApolicePorValorFipe } from '../../services/apolices/index';
import { TIPO_PRODUTO } from '../../commons/dicionarioTipoProduto';
import notify from './../../utils/notify';
import {
  updateProdutoValorMensaliade,
  updateProdutoValorMinimoMensalidade,
} from './../../services/propostas';
import estacionamentoService from '../../services/estacionamento';
import produtoService from '../../services/produtos/index';
import { normalizaObjFormasPagamento } from '../../services/formasPagamento';
import { deepClone } from '../../utils/deepClone';
import { decryptData } from '../../services/decryptData';
import { TIPO_VEICULO } from '../../commons/constant/tipo-veiculo';

export default {
  name: 'NovaProposta',
  props: ['idEmpresaProps', 'isLanding'],
  computed: {
    marcaOptions() {
      return this.marcaAgregadoImplemento.map((marca) => ({
        value: marca.idMarcaAgregadoImplemento,
        label: marca.nome,
      }));
    },
    disableNovaProposta() {
      const regraGeral = this.btnDisabled2;

      if (this.veiculoSemGrupo) {
        return true;
      } else if (regraGeral) {
        return true;
      }

      return false;
    },

    AlterarValorProduto() {
      const bemProtege = this.verificaEmpresa();
      if (bemProtege) {
        return this.$can('Alterar Valor Produto', 'Cotações');
      } else {
        return false;
      }
    },
    seletorTiposProposta() {
      if (this.codigoSituacaoPlaca === '998') {
        return this.tiposPropostaReduzidos;
      }

      if (this.codigoSituacaoPlaca === '997') {
        return [{ text: 'Selecione', value: null }, 'Troca de Titularidade'];
      }

      return this.tiposProposta;
    },
    obterPlacaAlternativa() {
      const [placaAlternativa] = preparaPlacaParaConsulta(this.form.placa);
      return placaAlternativa;
    },
    translatedRegional() {
      return this.$t('Regional');
    },
    translatedDivision() {
      return this.$t('Divisão');
    },
  },
  watch: {
    'form.veiculo.marca'(newVal) {
      const ehAgregadoOuImplemento =
        (this.form.agregado ||
          this.form.implemento ||
          this.form.somenteAgregado) &&
        newVal;
      if (ehAgregadoOuImplemento) {
        this.getModeloAgregadoImplemento(newVal.value);
      }
    },
    'form.estado': function (newValue, oldValue) {
      const isValueChanged = newValue !== oldValue;
      const shouldProcessValueChange =
        isValueChanged && oldValue !== null && typeof oldValue === 'string';
      if (shouldProcessValueChange) {
        this.form.cidade = null;
        this.cidade = null;
        this.cidades = [];
      }
    },
    'form.classe': function (newValue, oldValue) {
      const changeValue =
        (newValue && oldValue && newValue.id !== oldValue.id) || !newValue;

      if (changeValue) {
        this.radioSelecionado = null;
        this.idGrupo = [];
        this.gruposModal = [];
        this.gruposPorClasse = [];
        this.inputClasseIsTrue = false;
        this.configuracaoPropostaCaminhao = false;
        this.form.implemento = false;
        this.form.agregado = false;
        this.form.agregados = [];
        this.form.implementos = [];
        this.buscaDadosGrupos();
      }
    },
    isLanding() {
      this.validaIsLanding();
    },
    isCarroZero: function (newValue) {
      this.verificaZero(newValue);
    },
    dados() {
      this.preencheForm();
    },
    permitirRestricoes(value) {
      this.restricoesSelecionadas =
        value === false
          ? [{ idRestricao: null, descricao: 'Nenhuma Restrição' }]
          : [];
    },
    'form.veiculo.resultFipe.preco': function (newValue) {
      const valorNf = this.form.valorNf;
      this.form.precoVeiculo =
        (!this.form.isZero && !valorNf) ||
        (this.form.isZero && !this.verificaEmpresa())
          ? newValue
          : valorNf;

      this.calcularCoberturaConjunto();
    },
    'form.valorNf': function (value) {
      this.form.precoVeiculo =
        this.form.isZero && this.verificaEmpresa()
          ? value
          : this.form.veiculo.resultFipe.preco;

      this.calcularCoberturaConjunto();
    },

    'form.idTipoEstacionamento': function () {
      this.verificaTipoEstacionamento();
    },

    'idTipoFipe.id': function (newValue) {
      if (newValue === this.tipoVeiculo.CAMINHAO) {
        this.form.isTaxiOrApp = false;
      }
      if (newValue === 3 && !this.permitirSomenteAgregado) {
        this.exibirValorTotalConjunto = true;
      }

      if (newValue !== 3) {
        this.exibirValorTotalConjunto = false;
        this.permitirCaminhao = false;
        this.form.caminhao = false;

        this.permitirImplemento = false;
        this.form.implemento = false;

        this.permitirAgregado = false;
        this.form.agregado = false;

        this.permitirSomenteAgregado = false;
        this.form.somenteAgregado = false;

        this.form.implementos = [];
        this.form.agregados = [];

        this.configuracaoPropostaCaminhao = false;
      }
      this.calcularCoberturaConjunto();
      this.verificaTipoEstacionamento();
    },

    'form.precoVeiculo': function (value) {
      if (this.form.somenteAgregado === true) {
        this.form.valorTotalConjunto = value;
        this.form.valorCobertura = value;

        this.calcularCoberturaConjunto();
      }
    },
    placaEncontrada: function (value) {
      if (value === false) this.resetBuscaPlaca();

      if (this.alterarGrupoVeiculoCotacao && this.naoPermitirEmpresa(120)) {
        this.habilitaAlterarGrupo = value === false ? false : true;
      }
    },
    buscouRegionais() {
      if (this.isInterno != true) {
        this.passo = 1;
        return;
      }
    },
    buscouDivisoes() {
      if (this.isInterno != true) {
        this.passo = 1;
        return;
      }
    },
    passo() {
      if (this.passo === 1 && this.idCotacaoRapida) {
        this.buscaCotacaoRapida();
      }
      if (this.passo === 1 && this.idPreCotacao) {
        this.buscaPreCotacao();
      }
    },
    cilindradas: function (newValue) {
      this.form.veiculo.cilindradas = newValue;
    },
    codigoSituacaoPlaca() {
      if (this.codigoSituacaoPlaca == 0) {
        this.btnDisabled2 = false;
      }

      if (this.codigoSituacaoPlaca == 999) {
        this.btnDisabled2 = true;
      }
    },
    produtos: {
      handler() {
        this.somaValores();
      },
      deep: true,
    },
    'form.produtosSelecionados': {
      handler() {
        this.somaValores();
      },
      deep: true,
    },
    'form.agregados': {
      handler() {
        this.somaValoresAgregado();
      },
      deep: true,
    },
    'form.agregado': function (newValue) {
      if (!newValue) {
        this.form.agregados = [];
      }
    },
    'form.implemento': function (newValue) {
      if (!newValue) {
        this.form.implementos = [];
      }
    },
    'form.comissaoAplicada': function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.aumentarComissao = newValue > oldValue;
        this.somaValores();
      }
    },
  },
  data() {
    return {
      inputClasseIsTrue: null,
      gruposModal: [],
      controllerClasse: 'classe',
      gruposPorClasse: [],
      gruposPorTipo: [],
      gruposAux: null,
      desabilitarInputVeiculoZero: false,
      propostaParaSomenteAgregado: false,
      hideLogo: this.$route.query.hideLogo,
      colorButton: this.$route.query.colorButton,
      showPanel: this.$route.query.showPanel,
      fixedButton: this.$route.query.fixedesabilitaAlterarMarcaButton,
      isRedirect: this.$route.query.isRedirect,
      nomeConsultorPlaca: '',
      modalPlacaRecusada: false,
      permitePlacaRepetida: null,
      idGrupoVinculoAgregado: null,
      tipoConfiguracaoCaminhao: null,
      gruposAgregados: [],
      msgValidacaoImplementoAgregado: '',
      validaImplementosAgregados: false,
      exibirformImplementoCompleto: false,
      exibirFormComplementoCompleto: false,
      exibirValorTotalConjunto: false,
      permitirRestricoes: null,
      alterarGrupoVeiculoCotacao: null,
      exigirCampoEstacionamentoProposta: null,
      habilitaAlterarGrupo: false,
      desabilitaAlterarMarca: true,
      desabilitaAlterarAnoModelo: true,
      desabilitaAlterarModelo: true,
      desabilitaAlterarAnoFabricacao: true,
      resetFormComplemento: false,
      placaVinculoSelecionado: null,
      chassiVinculoSelecionado: null,
      placaVeiculoTratorSelecionado: null,
      chassiVeiculoTratorSelecionado: null,
      implementoSelecionado: {},
      agregadoSelecionado: {},
      configuracaoPropostaCaminhao: false,
      permitirImplemento: false,
      permitirCaminhao: false,
      permitirSomenteAgregado: false,
      permitirAgregado: false,
      modalImplemento: false,
      modalComplemento: false,
      isCarroZero: false,
      regionalDefault: [],
      regionaisUsuario: [],
      usuarios_regionais: [],
      formDadosProdutosSelecionadosDesconto: [],
      modalForm: false,
      contFormDesconto: 0,
      nomenclatura120: false,
      tiposProposta: [
        'Contratação',
        'Reativação',
        'Substituição',
        'Inclusão',
        'Troca de Titularidade',
      ],
      tiposPropostaReduzidos: ['Reativação', 'Troca de Titularidade'],
      openEscolherAssociado: false,
      logo: '',
      insideApp: false,
      isInterno: false,
      alteraRegional: false,
      formCompletoB2C: false,
      exibeItensObrigatoriosB2C: true,
      isPropostaConsultor: false,
      exibeCilindrada: false,
      percentage: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: ' %',
        precision: 1,
        maxLength: 6,
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true,
      },
      passo: 0,
      dadosConsultor: null,
      decoded: null,
      aguardeCadastro: false,
      idEmpresa: this.idEmpresaProps
        ? this.idEmpresaProps
        : this.$route.params.idEmpresa,
      id_usuario: this.$route.params.idUsuario,
      idGrupo: {},
      idMarca: null,
      idModelo: null,
      idAnoModelo: null,
      idAnoFabricacao: null,
      idTipoFipe: null,
      estados: [],
      cidades: [],
      grupos: [],
      mostrarModalGrupos: false,
      tipos: [],
      produtos: [],
      produtosObrigatorios: [],
      produtosNaoObrigatorios: [],
      restricoesSelecionadas: [],
      formAssociadoEncontrado: {},
      associadoEncontrado: [],
      listaProdutosMensais: [],
      listaProdutosAAvista: [],
      produtoToDesconto: null,
      modalCreditCard: false,
      mostrarModalNovoValorProduto: false,
      novoValorProduto: {},
      listCartoes: [],
      itens: null,
      dadosFinanceiros: null,
      formasPagamentoEncontradas: false,
      marcas: [],
      modelos: [],
      modelosAux: [],
      anosModelo: [],
      anosFabricacao: [],
      restricoes: [],
      foraTabela: null,
      languages: lang,
      cep: null,
      endereco: null,
      bairro: null,
      estado: null,
      cidade: null,
      funcoesValicao: null,
      hasCartaoCredito: null,
      isCartaoAvista: null,
      isCartaoMensal: null,
      btnDisabled: null,
      dadosPlaca: null,
      placaEncontrada: false,
      modelosFipeEncontrados: [],
      titleSideBar: 'Desconto',
      modeloFipeSelecionado: null,
      modeloFipeAnoModeloSelecionado: null,
      idTipoModeloSelecionado: null,
      fipeEncontrada: false,
      radioSelecionado: null,
      btnDisabled2: false,
      regionais: [],
      buscouRegionais: false,
      divisoes: [],
      buscouDivisoes: false,
      idPreCotacao: null,
      usaUF: false,
      formInformacoes: [],
      informacoes: [],
      cilindradas: null,
      dicionarioChassisNacionais: [],
      dicionarioTiposVeiculos: {},
      valorMensalidadeBaseDesconto: 0,
      listLeads: [],
      form: {
        classe: [],
        origemCadastroProposta: window.location,
        caminhao: false,
        implemento: false,
        agregado: false,
        somenteAgregado: false,
        descricaoAgregado: null,
        implementos: [],
        agregados: [],
        valorTotalConjunto: 0,
        valorCobertura: 0,
        idEmpresa: this.idEmpresaProps
          ? this.idEmpresaProps
          : this.$route.params.idEmpresa,
        tipoProposta: null,
        idGrupo: {},
        regional: null,
        idDivisao: null,
        nome: null,
        email: '',
        telefone: null,
        precoVeiculo: 0,
        cidade: '',
        estado: null,
        endereco: null,
        bairro: null,
        cep: null,
        placa: '',
        isZero: false,
        idMarcaParticipacao: null,
        idModeloParticipacao: null,
        restricoesSelecionadas: [],
        produtosSelecionados: [],
        nf: null,
        dataNf: null,
        valorNf: 0,
        chassi: null,
        numeroMotor: null,
        renavam: null,
        combustivel: null,
        cor: null,
        quantidadePassageiro: null,
        valor: 0, //preço utilizado no simulador
        permiteInvoiceSelfService: true,
        exibirValoresVeiculoNaProposta: true,
        idTipoDesconto: '',
        dadosFinanceiros: {
          mensais: null,
          avista: null,
        },
        veiculo: {
          idGrupo: null,
          tipoVeiculo: null,
          codigoMarca: null,
          codigoModelo: null,
          anoGeral: null,
          anoModelo: null,
          anoFabricacao: null,
          codigoTipoCombustivel: null,
          combustivel: '',
          marca: null,
          modelo: null,
          codigoFipe: '',
          ano: null,
          resultFipe: {},
        },
        dadosUtm: [],
        origemLead: null,
        placas: [],
        valorCotaParticipacao: null,
        valorParticipacaoMinimo: null,
        idTipoEstacionamento: null,
        unificarAgregados: null,
        comissaoAplicada: 0,
        valorComissaoAplicadaFinal: 0,
        idApolice: null,
        isTaxiOrApp: false,
        is1app: false,
        idUser1app: false,
      },
      consultorCelular: null,
      idTipoFipeAux: null,
      regionalConsultorPlaca: null,
      modalInfoDataSaidaNf: false,
      btnBlock: false,
      exibirIptDadosVeiculo: false,
      placaValidada: false,
      codigoSituacaoPlaca: '0',
      situacaoPlaca: '',
      buscouProdutos: false,
      clicks: 0,
      totalSemComissao: 0,
      totalEntrada: 0,
      totalMensalidade: 0,
      totalEntradaAgregado: [],
      totalMensalidadeAgregado: [],
      totalSemComissaoAgregado: [],
      valorComissaoAplicadaFinalAgregado: [],
      veiculoSemGrupo: false,
      liberaPropostaMotoNaRua: null,
      desabilitaPropostaPorTipoVeiculoEstacionamento: false,
      isClasse: null,
      classes: [],
      classesSelecionadas: [],

      //Listas
      listLocaisEstacionamento: [],
      propostaMultipla: null,
      podeAlterarRegional: this.$can(
        'Permitir alterar regional da proposta',
        'Cotações',
      ),
      mascaraCarro: null,
      mascaraMoto: null,
      mascaraCaminhao: null,
      mascaraAgregado: null,
      mascaraImplemento: null,
      ativaMascarasVeiculos: null,
      calcularDiasUteisNfVistoria: null,
      diasZeroKM: null,
      comissionamento: {
        minValue: 0,
        maxValue: 0,
      },
      aplicaComissao: false,
      configurarComissao: false,
      propostaViaMigracaoSga: false,

      // Disable fields
      isCampoNomeDisabled: false,
      isCampoCelularDisabled: false,
      geraPropostaMoto: null,
      tipoVeiculo: TIPO_VEICULO,
      marcaAgregadoImplemento: [],
      modeloAgregadoImplemento: [],
      ehImportado: null,
      showTotalEntry: true,
      permitePlacaDuplicada: false,
      labelLocalEstacionamento: 'Você possui garagem para guarda do veículo?',
      grupoAgregadoSelecionado: {},
      aumentarComissao: true,
    };
  },
  methods: {
    defineTipoPagamentoProdutos(objPagamento, isMensal) {
      if (isMensal) {
        this.form.dadosFinanceiros.mensais = objPagamento.valor;
      }

      if (!isMensal) {
        this.form.dadosFinanceiros.avista = objPagamento.valor;
      }

      this.form.produtosSelecionados.forEach((item) => {
        if (item.ismensal && this.form.dadosFinanceiros.mensais) {
          item.idTipoPagamentoEmpresa =
            this.form.dadosFinanceiros.mensais.idTipoPagamentoEmpresa;
          item.tipoPagamento = this.form.dadosFinanceiros.mensais.tipoPagamento;

          return;
        }

        if (!item.ismensal && this.form.dadosFinanceiros.avista) {
          item.idTipoPagamentoEmpresa =
            this.form.dadosFinanceiros.avista.idTipoPagamentoEmpresa;
          item.tipoPagamento = this.form.dadosFinanceiros.avista.tipoPagamento;

          return;
        }
      });

      if (this.form.agregado) {
        this.form.agregados.forEach((item) => {
          item.produtosSelecionados.forEach((produto) => {
            if (produto.ismensal && this.form.dadosFinanceiros.mensais) {
              produto.idTipoPagamentoEmpresa =
                this.fform.dadosFinanceiros.mensais.idTipoPagamentoEmpresa;
              produto.tipoPagamento =
                this.form.dadosFinanceiros.mensais.tipoPagamento;

              return;
            }

            if (!produto.ismensal && this.form.dadosFinanceiros.avista) {
              produto.idTipoPagamentoEmpresa =
                this.form.dadosFinanceiros.avista.idTipoPagamentoEmpresa;
              produto.tipoPagamento =
                this.form.dadosFinanceiros.avista.tipoPagamento;

              return;
            }
          });
        });
      }
    },
    getWindow() {
      return window.location.origin;
    },
    definirTituloListaComplementos(item) {
      const temPlaca = item.placa ? item.placa + ' ' : '';
      const temChassi = item.chassi ? item.chassi + ' ' : '';
      const temDescricao = item.descricao ? item.descricao + ' -' : '';
      const temValorCobertura = item.valorCobertura ? item.valorCobertura : '';
      const temValorNf = item.valorNf ? item.valorNf : '';
      const temValor = ` Valor: R$ ${temValorCobertura || temValorNf}`;

      return `${temPlaca || temChassi}${temDescricao}${temValor}`;
    },
    definirSubTituloListaComplementos(item) {
      const temMarca = item.marca ? item.marca + ' ' : '';
      const temModelo = item.modelo ? item.modelo + ' ' : '';
      const temPlacaVinculo = item.placaVinculo
        ? `| Vinculo: ${item.placaVinculo}`
        : '';
      const temChassiVinculo = item.chassiVinculo
        ? `| Vinculo: ${item.chassiVinculo}`
        : '';
      const temVinculo = temPlacaVinculo || temChassiVinculo;

      return `${temMarca}${temModelo}${temVinculo}`;
    },
    exibirPlaca() {
      const exibirPlaca = this.isCarroZero || this.form.somenteAgregado;
      return !exibirPlaca;
    },
    calcularCoberturaConjunto() {
      let precoVeiculo =
        this.form.veiculo.resultFipe.preco || this.form.precoVeiculo;
      const precoFIPE = precoVeiculo
        ? parseFloat(precoVeiculo.replace(/[^\d,]/g, '').replace(',', '.'))
        : 0;

      const temValorNf = this.form.valorNf;
      const valorNF =
        temValorNf && typeof this.form.valorNf == 'string'
          ? parseFloat(
              this.form.valorNf
                .replace('R$ ', '')
                .replaceAll('.', '')
                .replace(',', '.'),
            )
          : 0;
      const veiculoZero = this.form.isZero;
      let preco = veiculoZero ? valorNF : precoFIPE;

      if (veiculoZero && this.verificaEmpresa()) {
        preco = precoFIPE;
        this.form.valorNf = precoFIPE;
      }

      let totalValorImplemento = 0;
      let valorTotalConjunto = 0;

      this.form.implementos.forEach((implemento) => {
        const { valorCobertura, valorNf } = implemento;
        totalValorImplemento += valorNf > 0 ? valorNf : valorCobertura;
      });

      valorTotalConjunto = preco + totalValorImplemento;

      this.form.valorTotalConjunto = valorTotalConjunto;
      this.form.valorCobertura = valorTotalConjunto || precoFIPE;
    },
    AtualizarComplemento(dadosComplemento) {
      const { index, ...dadosComplementos } = dadosComplemento;
      const tipo = `${dadosComplementos.tipo}s`;
      const itemSelecionado = `${dadosComplementos.tipo}Selecionado`;

      this.form[tipo][index] = dadosComplementos;
      this.modalComplemento = false;
      this[itemSelecionado] = {};

      if (dadosComplemento.tipo === 'implemento') {
        this.calcularCoberturaConjunto();
      }
    },
    excluirComplemento(dadosComplemento) {
      const { index, ...dadosComplementos } = dadosComplemento;
      const tipo = `${dadosComplementos.tipo}s`;
      const itemSelecionado = `${dadosComplementos.tipo}Selecionado`;

      this.form[tipo].splice(index, 1);
      this[itemSelecionado] = {};

      this.calcularCoberturaConjunto();
    },
    editarComplemento(dadosComplemento) {
      this.agregadoSelecionado = dadosComplemento;
      this.resetFormComplemento = false;
      this.abrirModalComplemento();
    },
    adicionarComplemento(dadosComplementos) {
      if (
        this.form.unificarAgregados &&
        this.grupoAgregadoSelecionado.idGrupo
      ) {
        dadosComplementos = {
          ...dadosComplementos,
          ...this.grupoAgregadoSelecionado,
        };
      }

      const tipo = `${dadosComplementos.tipo}s`;
      this.form[tipo].push(dadosComplementos);

      this.modalComplemento = false;

      if (dadosComplementos.tipo === 'agregado') {
        this.validaImplementosAgregados = false;
      }

      if (dadosComplementos.tipo === 'implemento') {
        this.validaImplementosAgregados = false;
        this.calcularCoberturaConjunto();
      }

      this.msgValidacaoImplementoAgregado = '';
    },
    verificaZero(value) {
      this.form.isZero = value;

      //if (value) {
      this.form.placa = '';
      this.resetBuscaPlaca();
      // }
      if (this.alterarGrupoVeiculoCotacao) {
        this.habilitaAlterarGrupo = this.form.isZero ? false : true;
      }
    },
    keymonitorPlaca: async function (param) {
      try {
        const ehComplemento = param === 'complemento';
        this.btnDisabled2 = false;

        const permitirPlacaDuplicada =
          this.form.placa.length === 8 &&
          this.form.regional.permitePlacaDuplicada;
        if (permitirPlacaDuplicada) {
          this.buscaPlacaFipe();

          return;
        }

        if (this.form.placa.length === 8 || param === 'isB2C') {
          this.$vs.loading();

          this.placaValidada = await this.consultarExisteCotacao();

          await this.consultarPlacaChassiBaseBP('placa');
          if (!this.placaValidada) {
            return;
          }
          if (ehComplemento) {
            return;
          }
          this.buscaPlacaFipe();
        }

        this.$vs.loading.close();
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Não Foi possível buscar pela placa',
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    keymonitor: function () {
      if (this.cep.length == 10) {
        this.$vs.loading();
        var cepbusca = this.cep.replace('.', '').replace('-', '');
        service
          .post('g', 'BuscaCEP', {
            cep: cepbusca,
          })
          .then((res) => {
            res.data = decryptData(res.data);

            this.endereco = res.data.street;
            this.bairro = res.data.neighborhood;
            this.cidade = res.data.city;
            this.estado = res.data.state;
            this.form.estado = this.estado;
            this.form.cidade = this.cidade;
            this.form.endereco = this.endereco;
            this.form.bairro = this.bairro;
            this.form.cep = this.cep;

            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não Foi possível encontrar o cep',
              color: 'danger',
            });
          });
      }
    },
    setDesconto(item) {
      let produtos = this.produtos;
      var aux = produtos.find((x) => x.id_produto === item.id_produto);

      if (item.valorDesconto === 0) {
        aux = {
          ...item,
          valorFinal: item.valor,
          isDesconto: false,
          style: null,
        };
      } else {
        aux = {
          ...item,
          style: 'text-decoration: line-through;',
        };
      }

      if (item && item.tipoVeiculo === 'principal') {
        this.produtosObrigatorios.forEach((element, index) => {
          if (element.id_produto === item.id_produto) {
            this.produtosObrigatorios[index] = aux;
          }
        });

        this.produtosNaoObrigatorios.forEach((element, index) => {
          if (element.id_produto === item.id_produto) {
            this.produtosNaoObrigatorios[index] = aux;
          }
        });

        this.form.produtosSelecionados.forEach((element, index) => {
          if (element.id_produto === item.id_produto) {
            this.form.produtosSelecionados[index] = aux;
          }
        });

        this.somaValores();
      }

      if (item && item.tipoVeiculo === 'agregado') {
        if (this.form.produtosAgregados && this.form.unificarAgregados) {
          this.form.produtosAgregados.produtosObrigatorios.forEach(
            (element, index) => {
              if (element.id_produto === item.id_produto) {
                this.form.produtosAgregados.produtosObrigatorios[index] = aux;
              }
            },
          );

          this.form.produtosAgregados.produtosNaoObrigatorios.forEach(
            (element, index) => {
              if (element.id === item.id) {
                this.form.produtosAgregados.produtosNaoObrigatorios[index] =
                  aux;
              }
            },
          );

          this.form.produtosAgregados.produtosSelecionados.forEach(
            (element, index) => {
              if (element.id === item.id) {
                this.form.produtosAgregados.produtosSelecionados[index] = aux;
              }
            },
          );
        }

        if (this.form.agregados.length && !this.form.unificarAgregados) {
          this.form.agregados[item.indexAgregado].produtosObrigatorios.forEach(
            (element, index) => {
              if (element.id_produto === item.id_produto) {
                this.form.agregados[item.indexAgregado].produtosObrigatorios[
                  index
                ] = aux;
              }
            },
          );

          this.form.agregados[
            item.indexAgregado
          ].produtosNaoObrigatorios.forEach((element, index) => {
            if (element.id === item.id) {
              this.form.agregados[item.indexAgregado].produtosNaoObrigatorios[
                index
              ] = aux;
            }
          });

          this.form.agregados[item.indexAgregado].produtosSelecionados.forEach(
            (element, index) => {
              if (element.id === item.id) {
                this.form.agregados[item.indexAgregado].produtosSelecionados[
                  index
                ] = aux;
              }
            },
          );

          this.somaValoresAgregado();
        }
      }

      this.produtoToDesconto = null;
    },
    onSubmit() {
      if (this.propostaMultipla === 'multi') {
        const pathMultiProposta = `/novaProposta/multi-proposta?idDivisao=${this.form.idDivisao}&idRegional=${this.form.regional.id}`;
        this.$router.replace(pathMultiProposta);
        return;
      }
      this.comissionamento.minValue = this.form.regional.valorMinimoComissao
        ? this.form.regional.valorMinimoComissao
        : 0;
      this.comissionamento.maxValue = this.form.regional.valorMaximoComissao
        ? this.form.regional.valorMaximoComissao
        : 0;
      this.form.comissaoAplicada = this.comissionamento.minValue;

      if (this.form.idDivisao) {
        this.passo = 1;
        this.mostrarRangeComissao();
      } else {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Selecione uma ${this.$t('Regional')}`,
          color: 'danger',
          timer: 5000,
        });
      }
    },
    voltar() {
      this.btnBlock = false;
      this.produtos = [];
      this.buscouProdutos = false;
    },
    buscaPlacaFipe() {
      if (this.form.placa.length === 8)
        return new Promise(async (resolve, reject) => {
          this.$vs.loading();

          service
            .post('CotacaoAberta', `BuscaDadosPlaca`, this.form, {
              timeout: 30000,
            })
            .then((res) => {
              this.dadosPlaca = {};
              if (res.status == 204 && res.data == '') {
                this.buscarPlacasZerado();
              }
              if (res.data) {
                this.dadosPlaca = res.data;
                const tipoVeiculo = this.dadosPlaca.segmento;
                const TIPO_VEICULO = 'Moto';
                const deveOcultarMoto =
                  !this.geraPropostaMoto && tipoVeiculo === TIPO_VEICULO;
                if (deveOcultarMoto) {
                  this.$vs.loading.close();
                  this.$vs.notify({
                    position: 'top-center',
                    title: 'Atenção',
                    text: 'Não é possível realizar propostas para motocicletas.',
                    color: 'danger',
                    timer: 30000,
                  });
                  this.placaEncontrada = false;
                  this.exibirIptDadosVeiculo = true;
                  this.dadosPlaca = {};
                  this.habilitaAlterarGrupo = false;
                  return;
                }
                this.preencheDadosPlaca();
              } else {
                this.placaEncontrada = false;
                this.exibirIptDadosVeiculo = true;
                this.dadosPlaca = {};
                this.habilitaAlterarGrupo = false;
              }
              this.$vs.loading.close();
              resolve();
            })
            .catch(() => {
              this.$vs.loading.close();

              this.placaEncontrada = false;
              this.exibirIptDadosVeiculo = true;
              this.habilitaAlterarGrupo = false;
              this.modelosFipeEncontrados = [];

              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Não foi possível buscar a placa, preencha os dados manualmente, ou tente novamente.',
                color: 'danger',
                timer: 10000,
              });

              reject();
            });
        });
    },
    resetBuscaPlaca(infoResetPlaca = null) {
      this.form.resultadoPlaca = null;
      this.form.chassi = null;
      this.form.renavam = null;
      this.form.combustivel = null;
      this.form.cor = null;
      this.form.quantidadePassageiro = null;
      this.placaEncontrada = false;
      this.btnDisabled = false;
      this.form.dataNf = null;
      this.form.valorNf = null;
      this.form.chassi = null;
      this.dadosPlaca = {};
      this.modelosFipeEncontrados = [];
      this.form.veiculo.resultFipe = {};
      this.form.valorTotalConjunto = 0;
      this.form.valorCobertura = 0;
      this.idGrupo = {};
      this.idTipoFipe = {};
      this.habilitaAlterarGrupo = false;
      //this.formCompletoB2C = true;
      this.form.veiculo.anoModelo = null;
      this.form.veiculo.combustivel = null;
      this.form.veiculo.tipoVeiculo = null;
      this.form.veiculo.idGrupo = null;
      this.form.precoVeiculo = 0;
      this.form.cilindradas = null;
      this.form.veiculo.cilindradas = null;
      this.exibeCilindrada = false;
      this.grupos = null;

      if (infoResetPlaca != null) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: infoResetPlaca,
          color: 'warning',
        });
      }

      this.calcularCoberturaConjunto();
    },
    /**
     * Displays a modal with information about the discount percentage based on the found Fipe models.
     *
     *
     * @param {Array} modelosFipeEncontrados - Array of found Fipe models.
     * @param {number|null} indexAgregado - Aggregate index, if applicable.
     * @param {string|null} tipoVeiculo - Type vehicles (pincipal | agregado) .
     *
     * @returns {void}
     */
    exibePorcentagemDesconto(
      modelosFipeEncontrados,
      indexAgregado = null,
      tipoVeiculo = 'principal',
    ) {
      if (this.modalForm && this.itens) {
        return;
      }

      if (tipoVeiculo === 'principal') {
        this.formDadosProdutosSelecionadosDesconto =
          this.form.produtosSelecionados;
        this.valorMensalidadeBaseDesconto = this.totalMensalidade;
      }

      if (tipoVeiculo === 'agregado') {
        if (this.form && this.form.unificarAgregados) {
          if (
            this.formDadosProdutosSelecionadosDesconto !==
            this.form.produtosAgregados.produtosSelecionados
          ) {
            this.valorMensalidadeBaseDesconto =
              this.somaValoresAgregadoUnificado(true);
            this.formDadosProdutosSelecionadosDesconto = deepClone(
              this.form.produtosAgregados.produtosSelecionados,
            );
          }
        } else {
          if (
            this.formDadosProdutosSelecionadosDesconto !==
            this.form.agregados[indexAgregado].produtosSelecionados
          ) {
            this.formDadosProdutosSelecionadosDesconto =
              this.form.agregados[indexAgregado].produtosSelecionados;
          }
        }
      }

      this.modalForm = true;
      const _idEmpresa = this.$route.params.idEmpresa || this.form.idEmpresa;

      this.contFormDesconto += 1;
      if (
        !this.itens ||
        this.itens.idProduto !== modelosFipeEncontrados.id_produto
      ) {
        this.itens = { ...modelosFipeEncontrados };
        this.itens.estado = this.form.estado;
        this.itens.tipoProposta = this.form.tipoProposta;
        this.itens.indexAgregado = indexAgregado;
        this.itens.idEmpresa = _idEmpresa;
        this.itens.nomeGrupo = this.idGrupo.label;
        this.itens.precoVeiculo = this.form.precoVeiculo;
        this.itens.tipoVeiculo = tipoVeiculo;
      }
    },
    salvarDesconto(data) {
      this.setDesconto(data);
      this.form.idTipoDesconto = data.idTipoDesconto;
      this.modalForm = false;
    },
    preencheDadosPlaca() {
      const temDadosPlaca = !functions.isObjectEmpty(this.dadosPlaca);

      if (temDadosPlaca) {
        const temDadosExtraPlaca = !functions.isObjectEmpty(
          this.dadosPlaca.extra,
        );

        const temDadosFipePlaca = !functions.isObjectEmpty(
          this.dadosPlaca.fipe,
        );

        // Verificação realizada pois a mensagem de erro retornada é inconsistente
        const _dadosPlacaValidos =
          this.dadosPlaca.mensagemRetorno == 'Sem erros.' ||
          (temDadosExtraPlaca && temDadosFipePlaca);

        if (!_dadosPlacaValidos) {
          const menssagemParaResetPlaca =
            'Nenhum modelo foi associado a essa placa';

          this.resetBuscaPlaca(menssagemParaResetPlaca);
          this.placaEncontrada = false;
          this.exibirIptDadosVeiculo = true;
        } else {
          if (temDadosExtraPlaca) {
            this.form.resultadoPlaca = this.dadosPlaca;
            this.form.chassi = this.dadosPlaca.extra.chassi.toUpperCase();
            this.form.renavam = this.dadosPlaca.extra.renavam;
            this.form.numeroMotor = this.dadosPlaca.extra.motor;
            this.form.combustivel = this.dadosPlaca.extra.combustivel;
            this.form.cor = this.dadosPlaca.cor;
            this.form.quantidadePassageiro =
              this.dadosPlaca.extra.quantidade_passageiro;

            if (this.dadosPlaca.extra.tipo_veiculo) {
              var idTipoFipe = this.pegarTipoVeiculo(
                this.dadosPlaca.extra.tipo_veiculo,
              );
              var aux = this.tipos.find((x) => x.id == idTipoFipe);
              this.idTipoFipe = aux;
              if (idTipoFipe === 2) {
                this.exibeCilindrada = true;
                this.cilindradas = this.dadosPlaca.extra.cilindradas;
              } else {
                this.exibeCilindrada = false;
                this.cilindradas = null;
              }

              this.selecionaTipoFipe();
            }
          } else {
            this.cilindradas = null;
          }
          if (temDadosFipePlaca) {
            this.btnDisabled2 = true;
            this.placaEncontrada = true;
            this.exibirIptDadosVeiculo = false;
            this.formCompletoB2C = false;
            this.modelosFipeEncontrados = [];
            this.dadosPlaca.fipe.dados.forEach((element) => {
              element.selecionado = false;
              element.checked = null;
              this.modelosFipeEncontrados.push(element);
            });
            this.modelosFipeEncontrados.sort(function (a, b) {
              return a.score > b.score ? -1 : a.score < b.score ? 1 : 0;
            });

            this.scrollBloco('ModelosEncontrados');
          }
        }
      }
    },
    scrollBloco(divDestino) {
      if (!this.isInterno) {
        setTimeout(() => {
          const element = this.$refs[divDestino];
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 500);
      }
    },
    pegarTipoVeiculo(tipo_veiculo) {
      const tipoVeiculo = this.dicionarioTiposVeiculos[tipo_veiculo];
      return tipoVeiculo ? tipoVeiculo.codigoTipo : 3;
    },
    async selecionaModelo(item) {
      for (let index = 0; index < this.modelosFipeEncontrados.length; index++) {
        const element = this.modelosFipeEncontrados[index];

        element.selecionado = null;

        if (element.codigo_fipe == item.codigo_fipe) {
          this.modeloFipeSelecionado = element.codigo_fipe;
          this.modeloFipeAnoModeloSelecionado = `${element.ano_modelo}-${element.tipo_modelo}`;
          this.idTipoModeloSelecionado = element.tipo_modelo;

          element.selecionado = true;
        }
      }
      // armazena o objeto do grupo selecionado
      const grupoVeiculoAux = this.idGrupo;

      // busca fipe do modelo
      try {
        await this.confirmaModeloFipe();

        if (!this.alterarGrupoVeiculoCotacao) {
          this.idGrupo = grupoVeiculoAux;
        }

        this.abrirModalGrupos();

        this.calcularCoberturaConjunto();

        this.anosFabricacao.unshift({ text: 'Selecione', value: null });
      } catch (error) {
        if (error == 'Falha na conexão com internet, tente novamente') {
          this.idTipoModeloSelecionado = null;
          this.radioSelecionado = null;
          this.modeloFipeSelecionado = null;
          this.modeloFipeAnoModeloSelecionado = null;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Erro na FIPE, tente novamente.',
            color: 'warning',
            timer: 5000,
          });
        }
      }
    },
    buscarDicionarioTiposVeiculos() {
      service
        .post('dicionarios', 'buscar-dicionario-tipos-veiculos', {})
        .then((res) => {
          this.dicionarioTiposVeiculos = res.data;
        })
        .catch((e) => {
          throw new Error(e);
        });
    },

    async separaGruposImportados(grupos = this.grupos) {
      const gruposImportados = grupos.filter(
        (grupo) => grupo.importado === this.ehImportado,
      );
      this.grupos = gruposImportados.length ? gruposImportados : grupos;
    },
    async marcaGrupoPorModelo() {
      if (this.alterarGrupoVeiculoCotacao) {
        const idMarca = this.form.veiculo.codigoMarca;
        const idModelo = this.form.veiculo.codigoModelo;

        if (!idMarca || !idModelo) {
          this.$vs.loading().close();

          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possível buscar os grupos, sistema temporariamente indisponivel ou falha de conexão com a internet ',
            color: 'warning',
            timer: 5000,
          });
          return;
        }

        const tipo = this.form.veiculo.tipoVeiculo || this.idTipoFipe.id;
        const anoFabricacao = this.form.veiculo.anoFabricacao;
        const anoModelo = this.form.veiculo.anoModelo;
        //const _idEmpresa = localStorage.getItem('idEmpresa');
        const _idEmpresa = !this.$route.params.idEmpresa
          ? this.form.idEmpresa
          : this.$route.params.idEmpresa;

        let chassi = null;
        if (this.dadosPlaca || this.form.chassi)
          chassi = this.form.chassi
            ? this.form.chassi
            : this.dadosPlaca.extra
            ? this.dadosPlaca.extra.chassi
            : '';

        this.ehImportado = await functions.verificaVeiculoImportado(
          chassi,
          this.decoded.id_empresa,
          this.idEmpresaProps,
        );
        const objBuscaGrupo = {
          idEmpresa: _idEmpresa,
          idMarca,
          idModelo,
          tipo,
          anoFabricacao,
          anoModelo,
          importado: this.verificaEmpresa() ? this.ehImportado : null,
        };

        const objGrupos = await service.post(
          'CotacaoAberta',
          'buscaGrupoMarcaModelo',
          objBuscaGrupo,
        );
        this.preencheGruposPosSelecao(objGrupos);
      }
    },
    async confirmaModeloFipe(codigoFipeParam) {
      const codigoFipe = codigoFipeParam || this.modeloFipeSelecionado;

      if (codigoFipeParam) {
        this.radioSelecionado = codigoFipeParam;
      }

      let modelo = this.modelosFipeEncontrados.find(
        (x) => x.codigo_fipe == codigoFipe,
      );

      if (!this.form.idTipoFipe) {
        var aux = this.tipos.find((x) => x.id == modelo.tipo_modelo);
        this.form.idTipoFipe = aux;
        this.idTipoFipe = aux;
        await this.selecionaTipoFipe();
      }

      this.$vs.loading();
      modelo.codigoTipoVeiculo = modelo.tipo_modelo;
      modelo.anoModelo = this.dadosPlaca.anoModelo;
      modelo.selecionado = true;

      await service
        .post('CotacaoAberta', 'BuscaDadosFipeModelo', modelo, {
          timeout: 5000,
        })
        .then(async (res) => {
          let dadosModelo = null;

          if (this.alterarGrupoVeiculoCotacao) {
            let idMarca = res.data.id_marca;
            let idModelo = res.data.id_modelo;

            if (!idMarca || !idModelo) {
              const modelo = res.data.find(
                (_modelo) =>
                  _modelo.fipe_codigo == this.modeloFipeSelecionado &&
                  _modelo.id_modelo_ano == this.modeloFipeAnoModeloSelecionado,
              );

              dadosModelo = modelo;
              idMarca = modelo.id_marca;
              idModelo = modelo.id_modelo;

              if (!idMarca || !idModelo) {
                this.$vs.loading().close();

                this.$vs.notify({
                  position: 'top-center',
                  title: 'Atenção',
                  text: 'Não foi possível busca dados, sistema indisponivel no momento ou falha com a conexão de internet ',
                  color: 'warning',
                  timer: 8000,
                });

                return;
              }
            }

            const tipo =
              res.data.tipo || dadosModelo.tipo || this.idTipoModeloSelecionado;
            const anoFabricacao = res.data.ano;
            const anoModelo = res.data.ano_modelo;
            const _idEmpresa = !this.$route.params.idEmpresa
              ? this.form.idEmpresa
              : this.$route.params.idEmpresa;

            const chassi = this.form.chassi
              ? this.form.chassi
              : this.dadosPlaca.extra
              ? this.dadosPlaca.extra.chassi
              : '';
            this.ehImportado = await functions.verificaVeiculoImportado(
              chassi,
              _idEmpresa,
              this.idEmpresaProps,
            );
            const objBuscaGrupo = {
              idEmpresa: _idEmpresa,
              idMarca,
              idModelo,
              tipo,
              anoFabricacao,
              anoModelo,
              importado: this.verificaEmpresa() ? this.ehImportado : null,
            };

            const objGrupos = await service.post(
              'CotacaoAberta',
              'buscaGrupoMarcaModelo',
              objBuscaGrupo,
            );

            this.preencheGruposPosSelecao(objGrupos);
            if (objGrupos.data.length === 0) {
              this.verificaEmpresa() && this.separaGruposImportados();
              this.habilitaAlterarGrupo = false;
              this.idGrupo = null;
              this.grupos = [];

              this.verificaVeiculoSemGrupo();

              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Nenhum grupo encontrado',
                color: 'danger',
                timer: 5000,
              });
            }

            if (objGrupos && objGrupos.data && objGrupos.data.length > 0) {
              this.idGrupo = objGrupos.data[0];
              this.grupos = objGrupos.data;

              this.exibeCilindrada =
                this.idGrupo.idTipoFipe === 2 ? true : false;

              // if (this.idGrupo.idTipoFipe === 3) {
              this.permitirCaminhao = true;
              this.permitirAgregado = this.idGrupo.permiteAgregado
                ? true
                : false;
              this.permitirImplemento = this.idGrupo.permiteImplemento
                ? true
                : false;

              this.permitirSomenteAgregado = this.idGrupo.permiteSomenteAgregado
                ? true
                : false;

              this.form.somenteAgregado = this.permitirSomenteAgregado
                ? true
                : false;

              this.configuracaoPropostaCaminhao =
                this.idGrupo.permiteAgregado || this.idGrupo.permiteImplemento
                  ? true
                  : false;
              // }

              this.habilitaAlterarGrupo = true;
            }

            if (objGrupos && objGrupos.data && objGrupos.data.length > 1) {
              this.habilitaAlterarGrupo = true;

              this.verificaEmpresa() &&
                this.separaGruposImportados(objGrupos.data);
            }
          }

          this.form.veiculo.resultFipe = !dadosModelo ? res.data : dadosModelo;
          this.form.veiculo.anoModelo = this.dadosPlaca.anoModelo
            ? parseInt(this.dadosPlaca.anoModelo)
            : null;
          this.form.veiculo.anoFabricacao = this.dadosPlaca.ano
            ? parseInt(this.dadosPlaca.ano)
            : null;
          this.form.veiculo.combustivel = !dadosModelo
            ? res.data.combustivel
            : dadosModelo.combustivel;
          this.fipeEncontrada = true;

          this.$vs.loading.close();
          this.btnDisabled2 = false;
          this.$forceUpdate();
        });
    },
    preencheGruposPosSelecao(objGrupos) {
      if (!objGrupos.data.length) {
        this.habilitaAlterarGrupo = false;
        this.verificaVeiculoSemGrupo();
      }

      if (objGrupos && objGrupos.data && objGrupos.data.length > 0) {
        if (this.idGrupo) {
          let grupoExistente = objGrupos.data.find(
            (x) => x.id == this.idGrupo.id,
          );
          if (!grupoExistente) {
            this.idGrupo = objGrupos.data[0];
          }
        } else {
          this.idGrupo = objGrupos.data[0];
        }

        this.grupos = objGrupos.data;

        this.exibeCilindrada = this.idGrupo.idTipoFipe === 2 ? true : false;

        // if (this.idGrupo.idTipoFipe === 3) {
        this.permitirCaminhao = true;
        this.permitirAgregado = this.idGrupo.permiteAgregado ? true : false;

        this.permitirImplemento = this.idGrupo.permiteImplemento ? true : false;

        this.permitirSomenteAgregado = this.idGrupo.permiteSomenteAgregado
          ? true
          : false;

        this.form.somenteAgregado = this.permitirSomenteAgregado ? true : false;

        this.configuracaoPropostaCaminhao =
          this.idGrupo.permiteAgregado || this.idGrupo.permiteImplemento
            ? true
            : false;
        //}
        this.habilitaAlterarGrupo = false;
      }

      if (objGrupos && objGrupos.data && objGrupos.data.length > 1) {
        if (this.inputClasseIsTrue) {
          if (this.gruposModal.length > 1) {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Mais de Um grupo encontrado, selecione um grupo de Veículo',
              color: 'warning',
              timer: 5000,
            });
            this.habilitaAlterarGrupo = true;
            this.abrirModalGrupos();
            return;
          }
          this.habilitaAlterarGrupo = false;
          return;
        }
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Mais de Um grupo encontrado, selecione um grupo de Veículo',
          color: 'warning',
          timer: 5000,
        });
        this.habilitaAlterarGrupo = true;
        this.abrirModalGrupos();
      }
    },
    buscaDadosRegionalDefault(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data = decryptData(res.data);

          res.data.forEach((element) => {
            if (element[campoPK] == this.decoded.id_regional) {
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
            }
          });
        });
    },
    voltarPasso() {
      this.passo = 0;
    },
    buscaEmail() {
      if (this.form.email.length > 4)
        return new Promise(async (resolve, reject) => {
          this.$vs.loading();
          service
            .post('CotacaoAberta', `validaAssociado`, this.form)
            .then((res) => {
              if (res.data && res.data.length > 0) {
                this.associadoEncontrado = res.data;
                this.openEscolherAssociado = true;
              } else {
                this.form.idProspect = null;
              }

              this.$vs.loading.close();
              resolve();
            })
            .catch((e) => {
              this.$vs.loading.close();
              reject(e);
            });
        });
    },
    adicionarCartaoLista(value) {
      this.listCartoes.forEach((element) => {
        element.selecionado = false;
      });

      this.modalCreditCard = false;
      this.listCartoes.push(value);

      this.btnDisabled = false;
    },
    selecionaCartao(item) {
      this.listCartoes.forEach((element) => {
        element.selecionado = false;
      });
      item.selecionado = true;
      this.$vs.loading();
      service
        .post('Associado', 'AtualizarCartaoAssociadoPrincipal', {
          idProspect: this.form.idProspect,
          idAssociadoCartao: item.id_associado_cartao,
        })
        .then(() => {
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    filtraCartoesSelecionados() {
      return this.listCartoes.filter((x) => x.selecionado == true);
    },
    verificaCartaoCredito() {
      this.hasCartaoCredito = false;
      this.btnDisabled = false;

      this.listaProdutosMensais.forEach((element) => {
        if (element.valor)
          if (element.valor.tipoPagamento == 'Cartão de Crédito') {
            this.hasCartaoCredito = true;
            this.isCartaoMensal = true;
            this.btnDisabled = true;
            if (this.filtraCartoesSelecionados().length > 0)
              this.btnDisabled = false;
          }
      });
      this.listaProdutosAAvista.forEach((element) => {
        if (element.valor)
          if (element.valor.tipoPagamento == 'Cartão de Crédito') {
            this.hasCartaoCredito = true;
            this.isCartaoAvista = true;
            this.btnDisabled = true;
            if (this.filtraCartoesSelecionados().length > 0)
              this.btnDisabled = false;
          }
      });
    },
    async buscaDadosRegionais() {
      this.$vs.loading();
      this.regionais = [];
      let objSend = {};
      objSend.idEmpresa = !this.$route.params.idEmpresa
        ? this.form.idEmpresa
        : this.$route.params.idEmpresa;

      try {
        this.regionais = await regionaisService.buscaRegionaisUsuario(
          this.id_usuario,
          objSend,
        );

        const primeiraRegionalArray = this.regionais[0];
        const {
          permitePlacaDuplicada,
          valorMinimoComissao,
          valorMaximoComissao,
        } = await this.buscarDadosRegional(primeiraRegionalArray.id);
        this.permitePlacaDuplicada = permitePlacaDuplicada;

        this.form.regional = {
          ...primeiraRegionalArray,
          permitePlacaDuplicada,
          valorMinimoComissao,
          valorMaximoComissao,
        };
      } catch (e) {
        notify.notifyFail(this.$vs, 'Falha ao buscar os Regionais e Divisões');
      }
      this.idRegionais = this.regionais.map((item) => item.id);
      this.buscouRegionais = true;
      this.$vs.loading.close();
      this.buscaDivisoes();
    },
    async buscaFormasPagamento() {
      this.$vs.loading();

      try {
        const {
          idEmpresa,
          idProspect,
          produtosSelecionados: produtos,
          regional,
        } = this.form;
        const { listaProdutosMensais, listaProdutosAAvista, cartoes } =
          await normalizaObjFormasPagamento(
            'buscaFormasPagamentoSemProposta',
            {
              idEmpresa,
              idProspect,
              produtos,
              regional,
            },
            null,
          );

        this.formasPagamentoEncontradas = true;
        this.listCartoes = cartoes || [];
        this.listaProdutosMensais = listaProdutosMensais || [];
        this.listaProdutosAAvista = listaProdutosAAvista || [];

        const preencheFormaPagamento = (element) => {
          element.valor = element.formas[1].value;
        };

        this.listaProdutosMensais.forEach(preencheFormaPagamento);
        this.listaProdutosAAvista.forEach(preencheFormaPagamento);

        this.verificaCartaoCredito();

        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Não foi possível encontrar as formas de Pagamento',
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    selecionaPorEmail(item) {
      this.form.tipoProposta = 'Adesão';
      this.form.tipoPessoa = item.tipo;
      this.form.nome = item.nome;
      this.form.telefone = item.telefone;
      this.form.celular = item.celular;
      this.cep = item.cep;
      this.form.cep = item.cep;
      this.form.endereco = item.endereco;
      this.form.bairro = item.bairro;
      this.form.cidade = item.cidade;
      this.form.estado = item.estado;

      this.estado = this.estados.find((estado) => estado.label === item.estado);
      this.cidade = item.cidade;

      this.form.pais = item.pais;
      this.form.preenchidoAutomatico = true;
      this.form.idProspect = item.idProspect;
      this.openEscolherAssociado = false;
    },
    selecionaEstado() {
      if (!this.estado) {
        this.cidade = null;
        return;
      }

      const findEstado = this.estados.find(
        (estado) => estado.id == this.estado.id,
      );
      this.form.estado = findEstado.label;
    },
    selecionaCidade() {
      if (!this.cidade) {
        this.cidade = null;
        return;
      }

      var aux = this.cidades.find((x) => x.id == this.cidade.id);
      this.form.cidade = aux.label;
    },
    selecionaRestricoes() {
      this.form.restricoesSelecionadas = [];
      this.restricoesSelecionadas.forEach((element) => {
        this.form.restricoesSelecionadas.push(element.idRestricao);
      });
    },
    somaValorTotalMesAtualizados() {
      var total = 0;
      this.form.produtosSelecionados.forEach((prod) => {
        if (prod.ismensal == true) total = total + prod.valorFinal;
      });
      return total;
    },
    somaValorTotalMesAtualizadosAgregado(id) {
      let total = 0;
      const somarValorTotal =
        id >= 0 &&
        this.form.agregados[id] &&
        this.form.agregados[id].produtosSelecionados.length;

      if (somarValorTotal) {
        this.form.agregados[id].produtosSelecionados.forEach((prod) => {
          if (prod.ismensal == true) total = total + prod.valorFinal;
        });
      }
      return total;
    },
    somaValorTotalAtualizados() {
      const calc = this.form.produtosSelecionados.reduce((acc, produto) => {
        if (!produto.ismensal) {
          acc += Number(produto.valorFinal);
        }
        return acc;
      }, 0);

      return calc < this.totalMensalidade ? this.totalMensalidade : calc;
    },
    somaValorTotalAtualizadosAgregado(id) {
      let total = 0;
      this.form.agregados[id].produtosSelecionados.forEach((prod) => {
        if (prod.ismensal != true) total = total + prod.valorFinal;
      });
      return total;
    },
    formataMoeda(valor) {
      return `R$ ${valor.toFixed(2)} `;
    },
    somaValorTotalMes() {
      var total = 0;
      this.produtos.forEach((prod) => {
        if (prod.obrigatorio == true)
          if (prod.ismensal == true) total = total + prod.valor;
      });
      return total;
    },
    somaValorTotal() {
      var total = 0;
      this.produtos.forEach((prod) => {
        if (prod.obrigatorio == true)
          if (prod.ismensal != true) total = total + prod.valor;
      });
      return total;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    validateStyle(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return {
          border: '1px solid red !important',
          borderRadius: '5px',
        };
      }
      return null;
    },
    selecionaTipo() {
      if (this.placaEncontrada) {
        const _tipoVeiculo = this.tipos.find(
          (tipo) => tipo.id == this.idGrupo.idTipoFipe,
        );
        this.idTipoFipe = _tipoVeiculo;

        const verificaTipoSelecionado = this.modelosFipeEncontrados.find(
          (modelo) => modelo.codigo_fipe == this.modeloFipeSelecionado,
        );
        const tipoVeiculoCorreto =
          verificaTipoSelecionado.tipo_modelo == this.idTipoFipe.id;

        if (verificaTipoSelecionado && !tipoVeiculoCorreto) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'O tipo de veículo não é compatível com o tipo do grupo selecionado',
            color: 'warning',
          });

          this.resetBuscaPlaca();
        }

        this.idGrupo
          ? (this.form.veiculo.idGrupo = this.idGrupo.id)
          : (this.form.veiculo.idGrupo = null);
        this.idMarca = null;
        this.idModelo = null;
        this.idAnoModelo = null;
        this.idAnoFabricacao = null;
        this.modelos = [];
        this.anosModelo = [];
        this.anosFabricacao = [];

        this.idGrupo
          ? (this.form.veiculo.tipoVeiculo = this.idGrupo.idTipoFipe)
          : (this.form.veiculo.tipoVeiculo = null);

        if (this.idGrupo && this.idGrupo.idTipoFipe == 2) {
          this.exibeCilindrada = true;
        } else {
          this.exibeCilindrada = false;
        }

        if (this.idGrupo) {
          const grupoSelecionado = this.idGrupo;
          this.configuracaoPropostaCaminhao =
            grupoSelecionado.permiteAgregado ||
            grupoSelecionado.permiteImplemento
              ? true
              : false;

          this.permitirCaminhao =
            grupoSelecionado.idTipoFipe === 3 ? true : false;
          this.permitirImplemento = grupoSelecionado.permiteImplemento;
          this.permitirAgregado = grupoSelecionado.permiteAgregado;
          this.permitirSomenteAgregado =
            grupoSelecionado.permiteSomenteAgregado;
        }

        if (this.permitirSomenteAgregado) {
          this.form.somenteAgregado = true;
        }
      }
    },
    preencheMarca() {
      if (this.placaEncontrada) {
        if (this.idGrupo == null) {
          this.desabilitaAlterarMarca = true;
          this.desabilitaAlterarAnoModelo = true;
          this.desabilitaAlterarModelo = true;
        } else {
          this.desabilitaAlterarMarca = false;
        }

        var obj = { idGrupo: {} };
        obj.idGrupo.id = this.form.veiculo.idGrupo;
        obj.idEmpresa = !this.$route.params.idEmpresa
          ? this.form.idEmpresa
          : this.$route.params.idEmpresa;
        this.form.veiculo.marca = null;
        this.form.veiculo.modelo = null;
        this.form.veiculo.anoGeral = null;
        this.form.veiculo.anoFabricacao = null;
        this.form.cilindradas = null;
        this.idMarca = null;
        this.marcas = [];
        this.modelos = [];
        this.anosModelo = [];
        this.anosFabricacao = [];
        this.$vs.loading();
        this.desabilitaAlterarAnoModelo = true;
        this.desabilitaAlterarModelo = true;

        service
          .post('CotacaoAberta', 'ConsultaMarcasModeloPorGrupo', obj)
          .then((res) => {
            this.$vs.loading.close();
            if (res.data && res.data.length > 0) {
              this.isGrupoModelos = true;
              this.marcas = [];
              this.modelosAux = [];
              res.data.forEach((element) => {
                var aux = this.marcas.filter(
                  (x) => x.value.id == element.idMarca,
                );
                var auxModelos = this.modelosAux.filter(
                  (y) => y.value.id == element.idModelo,
                );
                if (!aux.length)
                  this.marcas.push({
                    value: {
                      id: element.idMarca,
                      valor: element.marca,
                      isGrupoModelos: true,
                    },
                    text: element.marca,
                  });

                if (!auxModelos.length)
                  this.modelosAux.push({
                    idMarca: element.idMarca,
                    idTipo: element.idTipo,
                    value: {
                      id: element.idModelo,
                      valor: element.modelo,
                      isGrupoModelos: true,
                    },
                    text: element.modelo,
                  });
              });
              this.buscaDadosFipe('ConsultarMarcas', 'marcas', 'name', 'id');
              this.marcas.unshift({ id: null, text: 'Selecione' });
            } else {
              this.isGrupoModelos = false;
              this.buscaDadosFipe('ConsultarMarcas', 'marcas', 'name', 'id');
            }
          });
      } else {
        if (this.idGrupo == null) {
          this.desabilitaAlterarMarca = true;
          this.desabilitaAlterarAnoModelo = true;
          this.desabilitaAlterarModelo = true;
        } else {
          this.desabilitaAlterarMarca = false;
        }
      }
    },
    preencheModelo() {
      this.modelos = [];
      this.anosModelo = [];
      this.anosFabricacao = [];
      if (this.idMarca) {
        this.form.veiculo.marca = this.idMarca.value
          ? this.idMarca.value
          : this.idMarca.text;
        this.form.veiculo.codigoMarca = this.idMarca.value
          ? this.idMarca.value.id
          : this.idMarca.id;
      } else {
        this.form.veiculo.marca = null;
        this.form.veiculo.codigoMarca = null;
        this.idModelo = null;
        this.idAnoModelo = null;
        this.idAnoFabricacao = null;
      }
      this.form.veiculo.modelo = null;
      this.form.veiculo.anoGeral = null;
      this.form.veiculo.anoFabricacao = null;

      this.desabilitaAlterarAnoModelo = false;
      this.desabilitaAlterarModelo = false;

      this.form.cilindradas = null;
      this.selecionaTipo();

      if (!this.form.veiculo.marca.isGrupoModelos) {
        this.buscaDadosFipe('ConsultarModelos', 'modelos', 'name', 'id');
      } else {
        this.modelos = this.modelosAux.filter(
          (x) => x.idMarca == this.form.veiculo.marca.id,
        );
      }
    },
    async preencheAnos() {
      if (!this.idModelo) {
        this.idAnoFabricacao = null;
        this.desabilitaAlterarAnoFabricacao = true;
        return;
      }

      this.desabilitaAlterarAnoFabricacao = false;

      this.form.veiculo.modelo = this.idModelo.value;
      this.form.veiculo.anoGeral = null;
      this.anosModelo = [];
      this.form.cilindradas = null;
      this.idAnoFabricacao = null;
      if (this.form.veiculo.marca.isGrupoModelos == true) {
        var modeloAux = this.modelosAux.find(
          (x) => x.value.id == this.form.veiculo.modelo.id,
        );
        this.form.veiculo.tipoVeiculo = modeloAux.idTipo;
      }

      this.form.veiculo.codigoModelo = this.form.veiculo.modelo.id;
      await this.buscaDadosFipe(
        'ConsultarAnoModelo',
        'anosModelo',
        'name',
        'id',
      );

      var auxAnos = [];

      this.anosModelo.forEach((element) => {
        if (element.value) {
          var ano = element.value.valor.split(' ')[0];
          var combustivel = element.value.valor.split(' ')[1];
          var codigoTipoCombustivel = element.value.id.split('-')[1];
          if (ano <= new Date().getFullYear() + 1) {
            // this.anosFabricacao.push({
            //   value: ano,
            //   text: ano,
            // });
            auxAnos.push({
              value: {
                ano: ano,
                combustivel: combustivel,
                codigoTipoCombustivel: codigoTipoCombustivel,
              },
              text: element.value.valor.includes('32000')
                ? '0km'
                : element.value.valor,
            });
          }
        }
      });
      this.anosModelo = auxAnos;
    },
    selecionaAnoModelo() {
      if (this.idAnoModelo == null) {
        this.$emit('option:deselected', this.preencheModelo());
        this.idModelo = null;
        this.idAnoFabricacao = null;
      } else {
        this.form.veiculo.anoGeral = this.idAnoModelo.value;
        this.form.veiculo.ano = this.form.veiculo.anoGeral.ano;
        this.form.veiculo.codigoTipoCombustivel =
          this.form.veiculo.anoGeral.codigoTipoCombustivel;
        this.form.veiculo.anoModelo = this.form.veiculo.anoGeral.ano;
        this.form.veiculo.combustivel = this.form.veiculo.anoGeral.combustivel;

        this.form.veiculo.anoFabricacao = null;
        this.form.cilindradas = null;
        this.idAnoFabricacao = [];
        this.anosFabricacao = [];

        let _anoFabricao = {
          value: this.form.veiculo.anoModelo - 1,
          text: this.form.veiculo.anoModelo - 1,
        };

        this.anosFabricacao = [
          {
            value: this.form.veiculo.anoModelo,
            text:
              this.form.veiculo.anoModelo == '32000'
                ? '0km'
                : this.form.veiculo.anoModelo,
          },
          {
            ..._anoFabricao,
          },
        ];

        this.buscaDadosFipe(
          'ConsultarModelosPorAno',
          'modelosPorAno',
          'name',
          'id',
        );
      }
    },
    async buscaValorFipe() {
      if (this.idAnoFabricacao === null || this.idModelo === null) {
        this.desabilitaAlterarAnoFabricacao = true;
        this.idModelo = null;
        this.form.veiculo.codigoModelo = null;

        return;
      }

      this.form.veiculo.anoFabricacao = this.idAnoFabricacao.value;
      await this.buscaDadosFipe(
        'ConsultarValorComTodosParametros',
        'form.veiculo.resultFipe',
        '',
        '',
      );
      await this.marcaGrupoPorModelo();
      this.calcularCoberturaConjunto();
      this.abrirModalGrupos();
    },
    async buscaDadosFipe(action, array, campoDescricao, campoPK) {
      return new Promise(async (resolve) => {
        this.$vs.loading();

        var formFipe = {
          idEmpresa: !this.$route.params.idEmpresa
            ? this.form.idEmpresa
            : this.$route.params.idEmpresa,
          codigoTabelaReferencia: this.codigoTabelaReferencia,
          codigoTipoVeiculo:
            this.form.veiculo.tipoVeiculo || this.idTipoFipe.id,
          codigoMarca: this.form.veiculo.codigoMarca,
          ano:
            this.form.veiculo.anoModelo +
            '-' +
            this.form.veiculo.codigoTipoCombustivel,
          codigoTipoCombustivel: this.form.veiculo.codigoTipoCombustivel,
          anoModelo: this.form.veiculo.anoModelo,
          codigoModelo: this.form.veiculo.codigoModelo,
        };
        service
          .post('Fipe', `${action}`, formFipe)
          .then((res) => {
            var arrayRes = res.data;
            this[array] = [];
            if (array == 'form.veiculo.resultFipe') {
              this.form.veiculo.resultFipe = arrayRes;
              this.$vs.loading.close();
              resolve();
              return;
            }
            // this[array].push({ text: 'Selecione', value: null });

            if (array == 'modelos') {
              this.modelos = [];
              arrayRes[0].forEach((element) => {
                this.modelos.push({
                  value: { id: element['id'], valor: element['name'] },
                  text: element['name'],
                });
              });
              this.anosModelo = [];
              arrayRes[1].forEach((element) => {
                let _combustivel = element.name.split(' ')[1];

                if (this.idTipoFipe.id == 2) {
                  _combustivel = '';
                }

                if (this.idTipoFipe.id == 3) {
                  _combustivel = 'Diesel';
                }

                this.anosModelo.push({
                  value: {
                    ano: element.name.split(' ')[0],
                    combustivel: element.name.split(' ')[1],
                    codigoTipoCombustivel: element.id.split('-')[1],
                  },
                  text: element.name.includes('32000')
                    ? `0km ${_combustivel}`
                    : element.name,
                });
              });
            } else if (array == 'modelosPorAno') {
              this.modelos = [];
              arrayRes.forEach((element) => {
                this.modelos.push({
                  value: { id: element['id'], valor: element['name'] },
                  text: element['name'],
                });
              });
            } else {
              arrayRes.forEach((element) => {
                if (array == 'codigoTabelaReferencia') {
                  this[array] = element[campoPK];
                } else
                  this[array].push({
                    value: {
                      id: element[campoPK],
                      valor: element[campoDescricao],
                    },
                    text: element[campoDescricao],
                  });
              });
            }
            this.$vs.loading.close();
            resolve();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: `Ocorreu um erro, por favor tente novamente!`,
              color: 'danger',
            });
          });
      });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data = decryptData(res.data);

        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });

        this[array].sort(function (a, b) {
          return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });
      });
    },
    async selecionaTipoFipe() {
      if (!this.idTipoFipe) return;
      this.habilitaAlterarGrupo = false;
      this.idGrupo = {};
      this.marcas = [];
      this.modelos = [];
      this.anosModelo = [];
      this.anosFabricacao = [];
      this.idMarca = null;
      this.idModelo = null;
      this.idAnoModelo = null;
      this.idAnoFabricacao = null;
      this.desabilitaAlterarMarca = true;
      this.desabilitaAlterarAnoModelo = true;
      this.desabilitaAlterarModelo = true;
      this.desabilitaAlterarAnoFabricacao = true;
      // this.propostaParaSomenteAgregado = false;
      this.grupos = [];

      await this.buscaDadosGrupos();

      if (!this.placaEncontrada) {
        this.desabilitaAlterarMarca = false;
        if (this.idTipoFipe) {
          this.buscaMarcasPorTipoVeiculo(this.idTipoFipe);
          this.form.veiculo.tipoVeiculo = this.idTipoFipe.id;
          //this.abrirModalGrupos();
        }
      }

      if (this.idTipoFipe) {
        const _tipoFipe = this.idTipoFipe.id;
        const tipoCaminhao = _tipoFipe === this.tipoVeiculo.CAMINHAO;
        this.form.caminhao = tipoCaminhao;
        if (tipoCaminhao) {
          this.form.isTaxiOrApp = false;
        }
      }
    },
    async buscaDadosTipos() {
      try {
        const { data } = await service.getAll('g/domTipoFipe', {}, 'list/');
        const _data = decryptData(data);
        const TIPO_VEICULO = 'Moto';
        this.tipos = [];

        _data.forEach(({ idTipoFipe, nomeTipo, deletedAt }) => {
          if (!deletedAt) {
            this.tipos.push({ id: idTipoFipe, label: nomeTipo });
          }
        });

        if (!this.geraPropostaMoto) {
          this.tipos = this.tipos.filter(({ label }) => label !== TIPO_VEICULO);
        }

        this.tipos.forEach((element, index) => {
          if (element.deletedAt) return;

          let label = element.label;
          if (this.ativaMascarasVeiculos) {
            if (label === 'Carro' && this.mascaraCarro) {
              label = this.mascaraCarro;
            }
            if (label === 'Moto' && this.mascaraMoto) {
              label = this.mascaraMoto;
            }
            if (label === 'Caminhão' && this.mascaraCaminhao) {
              label = this.mascaraCaminhao;
            }
          }
          this.tipos[index] = {
            id: element.id,
            label: label,
          };
        });

        this.tipos = this.tipos.filter(
          (tipo, index, self) =>
            index ===
            self.findIndex((t) => t.id === tipo.id && t.label === tipo.label),
        );
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Erro ao Buscar Tipos',
          color: 'danger',
          timer: 5000,
        });
      }
    },

    async buscaDadosGrupos() {
      return new Promise(async (resolve) => {
        this.$vs.loading();
        service
          .getAll('Grupo', {}, 'list/' + this.form.idEmpresa)
          .then((res) => {
            this.grupos = [];

            if (!this.idTipoFipe.id) {
              this.idTipoFipe = this.idTipoFipeAux;
            }

            res.data.forEach((element) => {
              if (!element.deletedAt) {
                if (
                  element.idTipoFipe == this.idTipoFipe.id &&
                  this.propostaParaSomenteAgregado == false
                ) {
                  this.grupos.push({
                    id: element.idGrupo,
                    label: element.nomeGrupo,
                    descricao: element.descricao,
                    importado: element.importado,
                    idTipoFipe: element.idTipoFipe,
                    descricaoProdutos: element.descricaoProdutos,
                    permiteAgregado: element.permiteAgregado,
                    permiteSomenteAgregado: element.permiteSomenteAgregado,
                    permiteImplemento: element.permiteImplemento,
                    gruposAgregados: element.permiteAgregado
                      ? element.gruposAgregados
                      : null,
                  });
                }

                if (
                  this.propostaParaSomenteAgregado &&
                  element.permiteSomenteAgregado
                ) {
                  this.grupos.push({
                    id: element.idGrupo,
                    label: element.nomeGrupo,
                    descricao: element.descricao,
                    importado: element.importado,
                    idTipoFipe: element.idTipoFipe,
                    descricaoProdutos: element.descricaoProdutos,
                    permiteAgregado: element.permiteAgregado,
                    permiteSomenteAgregado: element.permiteSomenteAgregado,
                    permiteImplemento: element.permiteImplemento,
                    gruposAgregados: element.permiteAgregado
                      ? element.gruposAgregados
                      : null,
                  });
                }
              }
            });
            this.$vs.loading.close();
            resolve();
          })
          .catch(() => {});
      });
    },
    abrirModalGrupos() {
      if (!this.idTipoFipe) return;

      if (this.inputClasseIsTrue) {
        const objGruposClone = deepClone(this.grupos);
        const gruposComMesmoId = objGruposClone.filter((obj) => {
          return this.gruposPorClasse.some((grupo) => grupo.idGrupo === obj.id);
        });
        if (gruposComMesmoId && gruposComMesmoId.length > 0) {
          this.gruposModal = gruposComMesmoId;
          const umGrupoSelecionado =
            this.gruposModal && this.gruposModal.length == 1;
          if (umGrupoSelecionado) {
            this.idGrupo = this.gruposModal[0];
          }
          if (this.gruposModal && this.gruposModal.length > 1) {
            this.mostrarModalGrupos = true;
          }
          return;
        } else {
          this.gruposModal = [];
          this.grupos = [];
          this.idGrupo = null;
          this.habilitaAlterarGrupo = false;
          this.idGrupo = null;
          this.veiculoSemGrupo = true;
          return;
        }
      }
      const grupoSemValor = this.grupos && !this.grupos.length;
      if (grupoSemValor) {
        this.idGrupo = null;
        this.verificaVeiculoSemGrupo();
      } else if (this.grupos && this.grupos.length === 1) {
        this.idGrupo = this.grupos[0];
      } else if (this.grupos && this.grupos.length > 1) {
        this.mostrarModalGrupos = true;
      }
    },
    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      if (!this.estado) {
        this[array] = [];
        this.cidade = null;
        return;
      }

      this.$vs.loading();
      this[array] = [];
      if (this.estado && this.estado.id) {
        this.$vs.loading();

        service
          .getAll('g', {}, `${model}/list/codUf/${this.estado.id}`)
          .then((res) => {
            if (res) {
              res.data = decryptData(res.data);

              res.data.forEach((element) => {
                this[array].push({
                  id: element[campoPK],
                  label: element[campoDescricao],
                });
              });
            }

            this.$vs.loading.close();
          });
      }
    },
    buscaRestricoes() {
      return new Promise(async () => {
        this.$vs.loading();
        service
          .getAll('Restricoes', {}, `list/${this.form.idEmpresa}`)
          .then((res) => {
            var aux = res.data.filter((x) => x.deletedAt == null);
            this.restricoes = aux;
            this.restricoes.push({
              idRestricao: null,
              descricao: 'Nenhuma Restrição',
            });
            this.$vs.loading.close();
          });
      });
    },
    capturaParamsUtm() {
      const utmData = this.$route.query;
      const arrUtmData = Object.entries(utmData);

      let arrInsert = [];

      arrUtmData.forEach((element) => {
        let chave = element[0];
        let valor = element[1];
        let objInsert = {
          utm: chave,
          valorUtm: valor,
        };
        arrInsert.push(objInsert);
      });
      this.form.dadosUtm = arrInsert;
    },

    async GerarPropostaSite() {
      this.btnBlock = true;

      const isMigracaoInternaSga =
        this.form.tipoProposta === 'Migração Interna SGA';

      const skipValidatePlaca =
        !isMigracaoInternaSga || !this.propostaViaMigracaoSga;
      if (skipValidatePlaca) {
        if (!this.form.regional.permitePlacaDuplicada) {
          this.placaValidada = await this.consultarExisteCotacao();
          await this.consultarPlacaChassiBaseBP('placa', 'chassi');
          if (!this.placaValidada) {
            return;
          }
        }
      }

      var msg = '';
      if (this.isInterno) {
        this.listaProdutosMensais.forEach((element) => {
          if (element.valor == null) {
            msg =
              msg +
              'Selecione a Forma de Pagamento do item ' +
              element.nomeProduto +
              '<br><br>';

            this.btnBlock = false;
          }
        });

        this.listaProdutosAAvista.forEach((element) => {
          if (element.valor == null) {
            msg =
              msg +
              'Selecione a Forma de Pagamento do item ' +
              element.nomeProduto +
              '<br><br>';

            this.btnBlock = false;
          }
        });
      }

      if (msg != '') {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: msg.toString(),
          color: 'danger',
        });

        this.btnBlock = false;
      } else {
        this.btnBlock = true;
        this.form.dadosFinanceiros.mensais = this.listaProdutosMensais;
        this.form.dadosFinanceiros.avista = this.listaProdutosAAvista;
        this.form.jsonFacilitadorProdutos = JSON.stringify(this.produtos);

        if (this.produtos && this.produtos.length > 0) {
          this.form.jsonFacilitadorProdutos = JSON.stringify(this.produtos);
        } else {
          this.btnBlock = false;
          this.passo = 1;
          this.$vs.loading.close();

          notify.notifyFail(
            this.$vs,
            'Não há produtos disponiveis para essa proposta, tente novamente',
            'Atenção',
            'danger',
            5000,
          );

          return;
        }

        this.$vs.loading();

        const objBuscaApolice = {
          idEmpresa: this.form.idEmpresa,
          idGrupo: this.form.idGrupo.id,
          valorFipe: this.form.precoVeiculo,
        };

        const resultApolice = await buscaApolicePorValorFipe(objBuscaApolice);
        if (resultApolice) this.form.idApolice = resultApolice.idApolice;

        if (this.form.tipoProposta === 'Contratação') {
          this.form.tipoProposta = 'Adesão';
        }

        if (this.form.veiculo.marca && this.form.veiculo.modelo) {
          this.form.veiculo.marca = this.form.veiculo.marca.label;

          this.form.veiculo.modelo = this.form.veiculo.modelo.label;
        }

        service
          .post('CotacaoAberta', 'GerarPropostaSite', this.form)
          .then((res) => {
            let linkRelativo = window.location.origin;

            this.idPreCotacao && this.convertePreCotacao(res.data);
            let pageTo = 'proposta';
            if (this.isLanding) {
              pageTo = 'propostasBP';
            }
            if (this.isInterno == false) {
              if (this.isRedirect) {
                window.parent.location.href = `${linkRelativo.replace(
                  'app.',
                  'adm.',
                )}/${pageTo}/${res.data.chave}`;
              } else
                window.location.href = `${linkRelativo.replace(
                  'app.',
                  'adm.',
                )}/${pageTo}/${res.data.chave}`;
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Cotação adicionada com sucesso',
                color: 'success',
              });
              this.$router.push('/Cotacoes');
            }

            this.$vs.loading.close();
            this.capturaParamsUtm();
          })
          .catch((error) => {
            this.btnBlock = false;

            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: error,
              color: 'danger',
            });
          });
      }

      this.btnBlock = false;
    },
    convertePreCotacao(data) {
      service
        .put('PreCotacao', 'ConverterPreCotacao', {
          idEmpresa: data.idEmpresa,
          idPropostaConvertida: data.idProposta,
          idPreCotacao: this.idPreCotacao,
        })
        .then(() => {
          this.carregando = false;
        })
        .catch((e) => {
          this.carregando = false;
          this.passo = 6;
          this.resultNegativo = true;
          this.msgNegativo = e;

          this.$bvToast.toast(e, {
            title: 'Atenção!',
            solid: true,
            variant: 'danger',
            toaster: 'b-toaster-top-full',
            appendToast: false,
            autoHideDelay: 5000,
          });
        });
    },

    validaConfiguracaoCaminhao() {
      this.validaImplementosAgregados = false;
      this.msgValidacaoImplementoAgregado = '';

      const configuracaoAgregado = this.form.agregado;
      const configuracaoImplemento = this.form.implemento;

      if (configuracaoAgregado || configuracaoImplemento) {
        const temAgregados = this.form.agregados.length;
        const temImplemento = this.form.implementos.length;

        const msgValidaAgregado =
          temAgregados == 0 && configuracaoAgregado
            ? 'É necessario adicionar um agregado'
            : '';

        if (msgValidaAgregado && temAgregados == 0) {
          this.msgValidacaoImplementoAgregado = msgValidaAgregado;
          this.validaImplementosAgregados = true;
          // this.btnDisabled2 = true;

          return false;
        }

        if (msgValidaAgregado == '' && temAgregados > 0) {
          this.btnDisabled2 = false;
        }

        const msgValidaImplemento =
          !temImplemento && configuracaoImplemento
            ? 'É necessario adicionar um Implemento'
            : '';

        if (msgValidaImplemento && temImplemento == 0) {
          this.msgValidacaoImplementoAgregado = msgValidaImplemento;
          this.validaImplementosAgregados = true;
          // this.btnDisabled2 = true;

          return false;
        }

        if (msgValidaImplemento == '' && temImplemento > 0) {
          this.btnDisabled2 = false;
        }
      }

      if (
        !this.form.agregado &&
        this.form.agregados &&
        this.form.agregados.length > 0
      ) {
        this.form.agregados = [];
      }

      if (
        !this.form.implemento &&
        this.form.agregados &&
        this.form.implementos.length > 0
      ) {
        this.form.implementos = [];
      }

      return true;
    },

    async buscar() {
      this.btnBlock = false;

      const isMigracaoInternaSga =
        this.form.tipoProposta === 'Migração Interna SGA';

      const skipValidatePlaca =
        !isMigracaoInternaSga || !this.propostaViaMigracaoSga;
      if (skipValidatePlaca) {
        if (!this.form.regional.permitePlacaDuplicada) {
          this.placaValidada = await this.consultarExisteCotacao();
          await this.consultarPlacaChassiBaseBP('placa', 'chassi');
          if (!this.placaValidada) {
            return;
          }
        }
      }

      let precoVeiculo = '0';
      let preco = '0';
      let valorNf =
        typeof this.form.valorNf == 'string'
          ? this.form.valorNf.replace('R$ ', '').replace('.', '')
          : this.form.valorNf;

      if (this.form.veiculo.resultFipe.preco) {
        preco = this.form.veiculo.resultFipe.preco.slice(3).replace(',', '.');
      }

      precoVeiculo =
        typeof this.form.precoVeiculo == 'string'
          ? this.form.precoVeiculo.slice(3).replace(',', '.')
          : this.form.precoVeiculo;

      precoVeiculo = parseFloat(precoVeiculo);
      preco = !this.form.somenteAgregado ? parseFloat(preco) : precoVeiculo;
      valorNf = parseFloat(valorNf);

      this.capturaParamsUtm();

      if (this.isCarroZero && valorNf == 0 && !this.verificaEmpresa()) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Favor informar o valor da Nota Fiscal do Veículo',
          color: 'danger',
        });

        return;
      }

      const _validaCelular = await this.$validator.validate('Celular');
      if (!_validaCelular) {
        return;
      }

      if (this.form.celular) {
        const validateCompleto = this.verificaCelular(this.form.celular);
        if (!validateCompleto) {
          return;
        }
      }

      const precoIsZero = precoVeiculo == 0 || this.form.valorCobertura == 0;
      const _veiculoZero = valorNf == 0 && this.form.isZero;
      const veiculoNaoZero = this.isCarroZero == false;
      if (
        (precoIsZero || _veiculoZero) &&
        veiculoNaoZero &&
        !this.propostaParaSomenteAgregado
      ) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Preço FIPE ou Valor de cobertura zerado',
          color: 'danger',
        });
      } else {
        this.form.idGrupo.id = this.idGrupo.id || this.form.veiculo.idGrupo;
        const configuracoesCaminhaoValidas = this.validaConfiguracaoCaminhao();
        if (!configuracoesCaminhaoValidas) {
          this.voltar();
          return;
        }

        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$vs.loading();
            service
              .post('CotacaoAberta', 'BuscaProdutos', this.form)
              .then((res) => {
                this.foraTabela = false;
                this.buscouProdutos = true;

                const naoTemProdutoCarroMoto =
                  Array.isArray(res.data) && res.data.length === 0;

                if (naoTemProdutoCarroMoto) {
                  this.$vs.loading.close();
                  this.$vs.notify({
                    position: 'top-center',
                    title: 'Atenção',
                    text: `Nenhum Produto Encontrado para essa faixa`,
                    color: 'danger',
                  });

                  return;
                }

                const naoTemProdutoCaminhao =
                  this.idTipoFipe.id == 3 &&
                  (!res.data.produtosVeiculo ||
                    res.data.produtosVeiculo.length == 0);

                if (naoTemProdutoCaminhao) {
                  this.$vs.loading.close();
                  this.$vs.notify({
                    position: 'top-center',
                    title: 'Atenção',
                    text: `Nenhum Produto Encontrado para essa faixa`,
                    color: 'danger',
                  });

                  return;
                }

                var prodsOk = true;
                if (this.idTipoFipe.id != 3) {
                  this.produtos = res.data;
                }

                if (this.idTipoFipe.id == 3) {
                  this.produtos = res.data.produtosVeiculo;

                  if (
                    res.data &&
                    res.data.produtosAgregados.length > 0 &&
                    !this.form.unificarAgregados
                  ) {
                    let _agregados = res.data.produtosAgregados.reduce(
                      (acc, item) => {
                        let _produtosObrigatorios = [];
                        let _produtosNaoObrigatorios = [];
                        let _produtosSelecionados = [];

                        item.produtos.forEach((produto) => {
                          produto.valorFinal = produto.valor;
                          produto.descontoConcedido = 0;
                          produto.id = produto.id_produto;
                          if (produto.obrigatorio == true) {
                            _produtosObrigatorios.push(produto);
                            _produtosSelecionados.push(produto);
                          } else {
                            _produtosNaoObrigatorios.push(produto);
                          }
                        });

                        const agregado = {
                          ...item,
                          produtosObrigatorios: _produtosObrigatorios,
                          produtosNaoObrigatorios: _produtosNaoObrigatorios,
                          produtosSelecionados: _produtosSelecionados,
                        };

                        if (!agregado.produtosObrigatorios.length) {
                          this.btnBlock = true;
                        }

                        acc.push(agregado);
                        return acc;
                      },
                      [],
                    );
                    this.form.agregados = _agregados;
                  }

                  if (
                    res.data.produtosAgregados &&
                    res.data.produtosAgregados.length > 0 &&
                    this.form.unificarAgregados
                  ) {
                    let _agregados = res.data.produtosAgregados.reduce(
                      (acc, item) => {
                        let _produtosObrigatorios = [];
                        let _produtosNaoObrigatorios = [];
                        let _produtosSelecionados = [];

                        item.produtos.forEach((produto) => {
                          produto.valorFinal = produto.valor;
                          produto.descontoConcedido = 0;
                          produto.id = produto.id_produto;
                          if (produto.obrigatorio == true) {
                            _produtosObrigatorios.push(produto);
                            _produtosSelecionados.push(produto);
                          } else {
                            _produtosNaoObrigatorios.push(produto);
                          }
                        });

                        acc = {
                          ...item,
                          produtosObrigatorios: _produtosObrigatorios,
                          produtosNaoObrigatorios: _produtosNaoObrigatorios,
                          produtosSelecionados: _produtosSelecionados,
                        };

                        // acc.push(agregado);
                        return acc;
                      },
                      {},
                    );

                    this.form.produtosAgregados = _agregados;
                  }
                }

                this.produtos.forEach((produto, index) => {
                  if (produto.acrescimoMensalidade === 'null') {
                    produto.acrescimoMensalidade = null;
                  }

                  if (
                    produto.acrescimoMensalidade &&
                    this.form.idTipoEstacionamento === 2
                  ) {
                    const produtoComAcrescimo =
                      produtoService.aplicaAcrescimoMensalidade(
                        produto,
                        this.form.estado,
                      );

                    this.produtos[index] = produtoComAcrescimo;
                  }

                  if (produto.isComplementar != true) {
                    produto.exibir = true;
                  }

                  if (produto.isComplementar === true) {
                    produto.exibir = false;
                  }
                });

                this.produtosObrigatorios = [];
                this.produtosNaoObrigatorios = [];
                this.form.produtosSelecionados = [];
                this.produtos.forEach((element) => {
                  element.valorFinal = element.valor;
                  element.descontoConcedido = 0;
                  element.id = element.id_produto;
                  if (element.obrigatorio == true) {
                    this.produtosObrigatorios.push(element);
                    this.form.produtosSelecionados.push(element);
                  } else {
                    this.produtosNaoObrigatorios.push(element);
                  }
                  if (element.valor == null) {
                    prodsOk = false;
                  }
                });

                this.produtosObrigatorios.sort(function (a, b) {
                  return a.nomeProduto < b.nomeProduto
                    ? -1
                    : a.nomeProduto > b.nomeProduto
                    ? 1
                    : 0;
                });
                this.formInformacoes = this.form;
                this.produtosNaoObrigatorios.sort(function (a, b) {
                  return a.nomeProduto < b.nomeProduto
                    ? -1
                    : a.nomeProduto > b.nomeProduto
                    ? 1
                    : 0;
                });
                if (this.isLanding) {
                  this.$vs.loading();
                  this.GerarPropostaSite();
                  return;
                }

                this.produtosNaoObrigatorios =
                  this.produtosNaoObrigatorios.filter(
                    (produto) => produto.id_tipoProduto !== 17,
                  );

                if (!this.isInterno && !this.produtosNaoObrigatorios.length) {
                  this.GerarPropostaSite();
                }
                if (prodsOk == false) {
                  this.produtos = [];
                  this.foraTabela = true;
                  this.$vs.notify({
                    position: 'top-center',
                    title: 'Atenção',
                    text: `Valores fora da Tabela`,
                    color: 'danger',
                  });
                } else {
                  this.buscaFormasPagamento();
                }
                this.$vs.loading.close();
              })
              .catch((e) => {
                this.$vs.loading.close();
                this.$vs.notify({
                  position: 'top-center',
                  title: 'Atenção',
                  text: e,
                  color: 'danger',
                });
              });
          }
        });
      }
    },
    async defineRota() {
      if (this.$route.path == '/novaProposta/Interno') {
        this.isInterno = true;
        const token = localStorage.getItem('user-token');
        if (token) {
          this.decoded = jwt.decode(token);
          this.form.idEmpresa = this.decoded.id_empresa;
          this.form.idUsuarioConsultor = this.decoded.id_usuario;
        }
        this.id_usuario = this.decoded.id_usuario;
      }

      if (this.$route.query.insideApp) {
        this.insideApp = true;
        //await this.buscaDadosEmpresa();
      }

      if (this.$route.params.userName) {
        this.isPropostaConsultor = true;
        //await this.buscaDadosEmpresa();
        await this.buscaDadosConsultor();
      }

      if (this.$route.query.idPreCotacao) {
        this.idPreCotacao = this.$route.query.idPreCotacao;
      }

      if (this.isInterno) {
        this.exibeItensObrigatoriosB2C = true;
      } else {
        this.exibeItensObrigatoriosB2C = false;
      }

      // @Alternar empresa 117 para 118
      if (['117', '118', '119'].includes(this.$route.params.idEmpresa)) {
        const { fullPath } = this.$route;
        const newRouter = fullPath
          .replace('117', '120')
          .replace('118', '120')
          .replace('119', '120');

        this.$router.replace(newRouter);
      }

      this.buscaDadosRegionais();
    },
    buscaDadosConsultor() {
      return new Promise((resolve, reject) => {
        var objSend = {
          idEmpresa: this.form.idEmpresa,
          userName: this.$route.params.userName,
        };
        service
          .post('Usuario', 'buscarUsuario', objSend)
          .then((res) => {
            this.dadosConsultor = res.data[0];
            this.form.idUsuarioConsultor = res.data[0].idUsuario;
            this.id_usuario = res.data[0].idUsuario;
            this.form.origem = 'B2C';

            resolve();
          })
          .catch((e) => {
            this.erroConexao =
              'Seu aplicativo parece estar offline, verifique sua conexao';
            reject(e);
          });
      });
    },
    buscaRegionais() {
      this.regionais = [];
      this.regionais = this.regionais.buscaRegionais(this.idEmpresa);
    },

    async buscaDadosEmpresa() {
      try {
        this.$vs.loading();
        let { data } = await service.getAll(
          'g',
          {},
          `empresas/list/idEmpresa/${this.form.idEmpresa}`,
        );

        data = decryptData(data);

        const [resultEmpresa] = data;
        this.aplicaComissao = resultEmpresa.aplicarRegraComissionamento;
        this.liberaPropostaMotoNaRua = resultEmpresa.liberaPropostaMotoNaRua;
        this.permitirRestricoes = resultEmpresa.permitirRestricoes;
        this.permitePlacaRepetida = resultEmpresa.permiteVariasCotacoesPorPlaca;
        this.alterarGrupoVeiculoCotacao =
          resultEmpresa.alterarGrupoVeiculoCotacao;
        this.exigirCampoEstacionamentoProposta =
          resultEmpresa.exigirCampoEstacionamentoProposta;
        this.isClasse = resultEmpresa.classe;
        this.form.unificarAgregados = resultEmpresa.unificarAgregados;
        this.calcularDiasUteisNfVistoria =
          resultEmpresa.calcularDiasUteisNfVistoria;
        this.diasZeroKM = resultEmpresa.diasZeroKM;
        this.geraPropostaMoto = resultEmpresa.geraPropostaMoto;

        if (this.alterarGrupoVeiculoCotacao) {
          this.habilitaAlterarGrupo = true;
        }

        const ativaMascara = resultEmpresa.ativaMascarasVeiculos;

        if (ativaMascara) {
          (this.mascaraCarro = resultEmpresa.mascaraCarro),
            (this.mascaraMoto = resultEmpresa.mascaraMoto),
            (this.mascaraCaminhao = resultEmpresa.mascaraCaminhao),
            (this.mascaraAgregado = resultEmpresa.mascaraAgregado),
            (this.mascaraImplemento = resultEmpresa.mascaraImplemento);
          this.ativaMascarasVeiculos = resultEmpresa.ativaMascarasVeiculos;
          this.buscaDadosTipos();
        }

        this.logo = resultEmpresa.logo;
      } catch (error) {
        this.erroConexao =
          'Seu aplicativo parece estar offline, verifique sua conexão';
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },
    obterProdutosFaltantes(produtosObrigatorios, produtosSelecionados) {
      return produtosObrigatorios.filter(
        (produtoObrigatorio) =>
          !produtosSelecionados.some(
            (produtoSelecionado) =>
              produtoSelecionado.id_produto === produtoObrigatorio.id_produto,
          ),
      );
    },
    podeSubstituirProduto(produtoSelecionado, idProdutoFaltante) {
      if (!produtoSelecionado.sobreporOutrosProdutos) return false;

      const produtosParaSubstituir =
        produtoSelecionado.sobreporOutrosProdutos.split(',');
      return produtosParaSubstituir.includes(idProdutoFaltante.toString());
    },
    buscaProdutosSobrepoeFaltante(indexAgregado) {
      const produtos =
        (indexAgregado || indexAgregado >= 0) && this.form.agregados.length > 0
          ? this.form.agregados[indexAgregado].produtos
          : this.produtos;
      const produtosObrigatorios =
        (indexAgregado || indexAgregado >= 0) && this.form.agregados.length > 0
          ? this.form.agregados[indexAgregado].produtosObrigatorios
          : this.produtosObrigatorios;
      const produtosSelecionados =
        (indexAgregado || indexAgregado >= 0) && this.form.agregados.length > 0
          ? this.form.agregados[indexAgregado].produtosSelecionados
          : this.form.produtosSelecionados;
      const produtosFaltantes = this.obterProdutosFaltantes(
        produtosObrigatorios,
        produtosSelecionados,
      );
      if (produtosFaltantes.length) {
        produtosFaltantes.forEach((produtoFaltante) => {
          const encontrouFaltante = produtosSelecionados.some(
            (produtoSelecionado) => {
              const produtoFaltanteSelecionado = produtos.find(
                (produto) =>
                  produto.id_produto == produtoSelecionado.id_produto,
              );
              return this.podeSubstituirProduto(
                produtoFaltanteSelecionado,
                produtoFaltante.id_produto,
              );
            },
          );

          if (!encontrouFaltante) {
            produtosSelecionados.push(produtoFaltante);
          }
        });
      }
    },
    validaSelecionado(item) {
      var aux = this.form.produtosSelecionados.filter(
        (x) => x.id == item.id_produto,
      );
      if (item.obrigatorio && aux.length > 0) return true;
      else if (item.obrigatorio && !aux.length) return false;
      return false;
    },
    async selecionaProduto(item, indexAgregado) {
      const produtosSelecionados =
        (indexAgregado || indexAgregado >= 0) && this.form.agregados.length > 0
          ? this.form.agregados[indexAgregado].produtosSelecionados
          : this.form.produtosSelecionados;
      const produtos =
        (indexAgregado || indexAgregado >= 0) && this.form.agregados.length > 0
          ? this.form.agregados[indexAgregado].produtos
          : this.produtos;

      if (item.sobreporOutrosProdutos) {
        const idsProdutossobreporOutrosProdutos =
          item.sobreporOutrosProdutos.split(',');
        idsProdutossobreporOutrosProdutos.forEach((idProduto) => {
          produtosSelecionados.forEach((produtoSelecionado, index) => {
            if (produtoSelecionado.id == idProduto) {
              produtosSelecionados.splice(index, 1);
            }
          });
        });
      } else {
        produtos.forEach((produto) => {
          if (produto.sobreporOutrosProdutos) {
            const idsProdutossobreporOutrosProdutos =
              produto.sobreporOutrosProdutos.split(',');
            const produtoSobreposto = idsProdutossobreporOutrosProdutos.find(
              (id) => id == item.id_produto,
            );
            if (produtoSobreposto) {
              produtosSelecionados.forEach((produtoSelecionado, index) => {
                if (produtoSelecionado.id == item.id_produto) {
                  produtosSelecionados.splice(index, 1);
                }
              });
            }
          }
        });
      }

      this.buscaProdutosSobrepoeFaltante(indexAgregado);
      if (!item.ismensal) this.buscaFormasPagamento();

      // produtos linkados
      if (item.produtosLinkados) {
        const produtosLinkados = item.produtosLinkados.split(',');

        produtosLinkados.forEach((id) => {
          const produtoLinkado = this.produtos.find(
            (produto) => produto.id_produto == id,
          );
          if (produtoLinkado) {
            const existeSelecionado = produtosSelecionados.find(
              (produto) => produtoLinkado.id_produto == produto.id_produto,
            );

            if (!existeSelecionado) {
              produtosSelecionados.push(produtoLinkado);
            } else {
              produtosSelecionados.forEach((produtoSelecionado, index) => {
                if (
                  produtoSelecionado.id_produto == produtoLinkado.id_produto
                ) {
                  produtosSelecionados.splice(index, 1);
                }
              });
            }
          }
        });
      }

      //Produtos complementares
      if (item.produtosComplementares) {
        const produtosComplementares = item.produtosComplementares.split(',');

        produtosComplementares.forEach((idComplementar) => {
          produtos.forEach((produto) => {
            if (produto.id_produto == idComplementar) {
              produto.exibir = !produto.exibir;
            }
          });

          produtosSelecionados.forEach((produtoSelecionado, index) => {
            if (
              produtoSelecionado.id_produto == idComplementar &&
              !produtoSelecionado.exibir
            ) {
              produtosSelecionados.splice(index, 1);
            }
          });
        });
      }

      //Cota de participação por produto
      if (item.id_tipoProduto === TIPO_PRODUTO.TIPO_PRODUTO_CASCO) {
        const participacao = await obterParticipacaoProduto(
          item,
          produtosSelecionados,
        );

        const { valorCotaParticipacao, valorParticipacaoMinimo } = participacao;

        this.form.valorParticipacaoMinimo = valorParticipacaoMinimo;
        this.form.valorCotaParticipacao = valorCotaParticipacao;
      }
    },
    abrirModalImplemento() {
      this.modalImplemento = true;
      this.resetFormImplemento = false;
    },
    abrirModalComplemento() {
      this.idGrupoVinculoAgregado = this.idGrupo.id;
      const temAgregadoUnificados =
        this.form.unificarAgregados &&
        this.form.agregados &&
        this.form.agregados.length > 0;
      if (temAgregadoUnificados) {
        const { idGrupo, nomeGrupo } = this.form.agregados[0];
        this.grupoAgregadoSelecionado = {
          idGrupo,
          nomeGrupo,
        };
      }
      this.modalComplemento = true;
      this.resetFormComplemento = false;
    },
    async buscaDivisoes() {
      const { idEmpresa, userName } = this.$route.params;
      const page = this.$route.name;
      const ID_EMPRESA_LANDING_PAGE = 120;

      const _idEmpresa =
        !idEmpresa && page == 'landingPageBP'
          ? ID_EMPRESA_LANDING_PAGE
          : idEmpresa;

      if (this.form.regional) {
        var objSend = {
          idRegional: this.form.regional.id,
          idEmpresa: _idEmpresa,
          userName,
        };

        this.$vs.loading();
        try {
          const divisoes = await regionaisService.buscaDivisoes(objSend);
          this.divisoes = divisoes;
        } catch (e) {
          notify.notifyFail(
            this.$vs,
            'Falha ao buscar os Regionais e Divisões',
          );
        }
        this.form.idDivisao = this.divisoes[0].id;
        this.$vs.loading.close();
        this.buscouDivisoes = true;
        this.$vs.loading.close();
      }
    },
    buscaPreCotacao() {
      const id = this.idPreCotacao;
      service
        .post('PreCotacao', 'buscarPreCotacao', { idPreCotacao: id })
        .then((res) => {
          res.data.resultado[0].idPropostaConvertida
            ? this.preCotacaoCovertida()
            : this.atribuiDadosPreCotacao(res.data.resultado[0]);
          this.$vs.loading.close();
        })
        .catch(() => {});
    },
    atribuiDadosPreCotacao(data) {
      this.form.nome = data.nome;
      this.form.celular = data.celular;
      this.form.email = data.email;
      this.form.estado = data.estado;
      this.estado = data.estado;
      this.form.cidade = data.cidade;
      this.cidade = data.cidade;
      this.form.tipoProposta = 'Adesão';
      this.form.idGrupo.id = data.jsonRetorno.grupoSeleciondo.id;
      this.form.idGrupo.valor = data.jsonRetorno.grupoSeleciondo.label;
      if (
        typeof data.jsonRetorno.dadosPlaca === 'object' &&
        Object.hasOwn(data.jsonRetorno.dadosPlaca, 'placa')
      ) {
        let placa = data.jsonRetorno.dadosPlaca.placa.split('');
        placa.splice(3, 0, '-');
        placa = placa.join('');
        this.form.placa = placa;
        this.buscaPlacaFipe();
      }
    },
    preCotacaoCovertida() {
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: 'Essa Pré Cotação já foi convertida em uma cotação',
        color: 'danger',
      });
      this.$router.go(-1);
    },
    fecharModal() {
      this.mostrarModalGrupos = false;
    },
    fecharModalPlaca() {
      this.modalPlacaRecusada = false;

      if (this.buscouProdutos) {
        this.passo = 1;
        this.produtos = [];
        this.produtosNaoObrigatorios = [];
        this.produtosObrigatorios = [];
        this.placaEncontrada = false;
        this.resetBuscaPlaca();
        this.buscouProdutos = false;
      }

      if (this.codigoSituacao === '999') {
        this.form.placa = '';
        this.fipeEncontrada = false;
        this.placaEncontrada = false;
      }
    },
    converteParams() {
      if (this.$route.query.hideLogo) {
        this.hideLogo = JSON.parse(this.$route.query.hideLogo.toLowerCase());
      } else this.hideLogo = false;

      if (this.$route.query.showPanel) {
        this.showPanel = JSON.parse(this.$route.query.showPanel.toLowerCase());
      } else this.showPanel = true;

      if (this.$route.query.fixedButton) {
        this.fixedButton = JSON.parse(
          this.$route.query.fixedButton.toLowerCase(),
        );
      } else this.fixedButton = false;

      if (this.$route.query.isRedirect) {
        this.isRedirect = JSON.parse(
          this.$route.query.isRedirect.toLowerCase(),
        );
      } else this.isRedirect = true;
    },
    selecionaGrupo() {
      this.form.veiculo.idGrupo = this.idGrupo.id;
      this.form.idGrupo.id = this.idGrupo.id;
    },
    verificaEmpresa() {
      return functions.verificaEmpresaBemProtege(this.form.idEmpresa);
    },
    chassiToUpperCase(chassi) {
      if (chassi) {
        this.form.chassi = chassi.toUpperCase();
      }
    },
    verificaCelular(telefone) {
      telefone = telefone.replace(/\D/g, '');
      const regexSequencial = /(\d)\1{8}/;
      if (!(telefone.length >= 10 && telefone.length <= 11)) return false;

      //Se tiver 11 caracteres, verificar se começa com 9 o celular
      if (telefone.length == 11 && parseInt(telefone.substring(2, 3)) != 9) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Digite um número de celular válido',
          color: 'warning',
        });
        return false;
      }

      for (let n = 0; n < 10; n++) {
        if (
          telefone == new Array(11).join(n) ||
          telefone == new Array(12).join(n)
        ) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Digite um número de celular válido',
            color: 'warning',
          });
          return false;
        }
      }
      const codigosDDD = [
        11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34,
        35, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 53, 54, 55, 61, 62,
        64, 63, 65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85,
        86, 87, 88, 89, 91, 92, 93, 94, 95, 96, 97, 98, 99,
      ];
      if (codigosDDD.indexOf(parseInt(telefone.substring(0, 2))) == -1) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Digite um número de celular válido',
          color: 'warning',
        });
        return false;
      }
      if (
        telefone.length == 10 &&
        [2, 3, 4, 5, 7].indexOf(parseInt(telefone.substring(2, 3))) == -1
      ) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Digite um número de celular válido',
          color: 'warning',
        });
        return false;
      }
      if (regexSequencial.test(telefone)) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Digite um número de celular válido',
          color: 'warning',
        });
        return false;
      }
      if (this.dadosConsultor || this.consultorCelular) {
        let celularConsultor = '';
        let celularConsultor2 = '';
        this.dadosConsultor
          ? (celularConsultor = this.dadosConsultor.celular.replace(/\D/g, ''))
          : '';
        this.consultorCelular
          ? (celularConsultor2 = this.consultorCelular.replace(/\D/g, ''))
          : '';
        if (telefone == (celularConsultor || celularConsultor2)) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: `Digite um número de celular diferente do ${this.$t(
              'Consultor',
            )}.`,
            color: 'danger',
          });
          return false;
        }
      }
      return true;
    },
    async buscaDadosConsultorAdm() {
      if (this.decoded) {
        this.$vs.loading();
        const objSend = {
          idEmpresa: this.decoded.id_empresa,
          userName: this.decoded.userName,
        };
        try {
          const res = await service.post('Usuario', 'buscarUsuario', objSend);
          this.consultorCelular = res.data[0].celular;
        } catch (error) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: error,
            color: 'danger',
          });
        } finally {
          this.$vs.loading.close();
        }
      }
    },
    buscarPlacasZerado() {
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: 'Não foi possível buscar a placa, preencha os dados manualmente, ou tente novamente.',
        color: 'warning',
        timer: 10000,
      });
    },
    async buscaMarcasPorTipoVeiculo(tipoVeiculo) {
      let objSend = {
        tipoVeiculo: tipoVeiculo.id,
      };

      try {
        this.$vs.loading();
        const res = await service
          .post('Fipe', 'consultar-marcas-por-tipo-veiculo', objSend)
          .catch(() => {
            this.$vs.loading.close();
          });

        this.marcas = res.data;
      } catch (error) {
        this.$vs.loading.close();

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Falha ao busca os dados, falha na conexão com a internet ou serviço indisponível. Tente novamente',
          color: 'danger',
          timer: 5000,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async ajustarPropostaParaSomenteAgregado() {
      this.form.classe = null;
      this.form.placa = null;
      const _propostaParaSomenteAgregado = this.propostaParaSomenteAgregado;

      if (
        (this.placaEncontrada && _propostaParaSomenteAgregado) ||
        !_propostaParaSomenteAgregado
      ) {
        this.placaEncontrada = false;
        this.modelosFipeEncontrados = [];
        this.grupos = [];
        this.idGrupo = null;
      }

      this.idGrupo = { id: null, label: '' };

      // this.form.somenteAgregado = _propostaParaSomenteAgregado ? true : false;

      this.desabilitarInputVeiculoZero = _propostaParaSomenteAgregado
        ? true
        : false;

      this.idTipoFipeAux = _propostaParaSomenteAgregado
        ? {
            id: 3,
            label: this.mascaraCaminhao ? this.mascaraCaminhao : 'Caminhão',
          }
        : { id: null, label: 'Selecione' };

      this.idTipoFipe = this.idTipoFipeAux;

      this.form.veiculo.tipoVeiculo = _propostaParaSomenteAgregado
        ? this.idTipoFipe.id
        : null;

      if (!this.idTipoFipe) this.idTipoFipe = this.idTipoFipe;
      if (_propostaParaSomenteAgregado) {
        this.grupos = [];
        await this.buscaDadosGrupos();
      }
      this.permitirSomenteAgregado = _propostaParaSomenteAgregado
        ? true
        : false;

      this.form.somenteAgregado = _propostaParaSomenteAgregado ? true : false;
      this.habilitaAlterarGrupo = _propostaParaSomenteAgregado ? false : true;

      if (
        this.grupos &&
        this.grupos.length > 1 &&
        _propostaParaSomenteAgregado
      ) {
        this.idGrupo = {};
        this.mostrarModalGrupos = !this.isClasse ? true : false;
        this.habilitaAlterarGrupo = true;
      }

      if (
        this.grupos &&
        this.grupos.length === 1 &&
        _propostaParaSomenteAgregado
      ) {
        this.mostrarModalGrupos = false;
        this.habilitaAlterarGrupo = false;
        this.idGrupo = this.grupos[0];
      }

      this.verificarSomenteAgregadoPemiteComplemento();
    },

    verificaVeiculoSemGrupo() {
      // Funcionalidade Somente para empresa 120
      if (this.form.idEmpresa == 120) {
        this.veiculoSemGrupo = true;
      }
    },

    validarDataSaidaNf() {
      if (this.decoded.id_empresa == 119) {
        return;
      }

      let dataValida = false;
      this.btnDisabled2 = true;
      const dataNfValida = this.form.dataNf.length == 10;
      let exibirAlerta = false;

      if (dataNfValida) {
        dataValida = dateConversion.verificarSaidaNotaFiscal(
          this.form.dataNf,
          this.calcularDiasUteisNfVistoria,
          this.diasZeroKM,
        );
        if (this.diasZeroKM === 0) {
          dataValida = false;
        }
        this.btnDisabled2 = dataValida ? false : true;
        if (dataValida) {
          return dataValida;
        }
      }

      exibirAlerta = dataNfValida && !dataValida;
      this.modalInfoDataSaidaNf = exibirAlerta ? true : false;
    },
    async buscaOrigemLeads() {
      try {
        this.$vs.loading();
        const result = await service.getAll(
          'CotacaoAberta',
          {},
          'buscar-origem-leads',
        );

        this.listLeads = result.data;
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Falha ao busca os dados da origem dos leads.',
          color: 'danger',
          timer: 5000,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    validaIsLanding() {
      if (localStorage.getItem('estado')) {
        this.form.cep = localStorage.getItem('cep');
        this.form.bairro = localStorage.getItem('bairro');
        this.form.endereco = localStorage.getItem('endereco');
        this.form.cidade = localStorage.getItem('cidade');
        this.form.estado = localStorage.getItem('estado');
        this.form.tipoAtendimento = localStorage.getItem('tipoAtendimento');
      }
    },
    salvaProspect() {
      if (this.isLanding) {
        if (!this.form.nome) {
          return;
        }
        if (this.form.celular) {
          const validateCompleto = this.verificaCelular(this.form.celular);
          if (!validateCompleto) {
            return;
          }
        }
        if (this.form.nome && this.form.celular) {
          service
            .post('CotacaoAberta', 'SalvarLeadB2C', this.form)
            .then((res) => {
              this.form.idLead = res.data.idLead;
            });
        }
      }
    },
    exibirAlertaPlaca(dadosConsultaPlaca) {
      if (!dadosConsultaPlaca) return;

      const {
        nomeConsultorPlaca,
        regionalConsultorPlaca,
        modalPlacaRecusada,
        codigoSituacao,
        situacao,
      } = dadosConsultaPlaca;

      this.nomeConsultorPlaca = nomeConsultorPlaca;
      this.regionalConsultorPlaca = regionalConsultorPlaca;
      this.modalPlacaRecusada = modalPlacaRecusada;
      this.codigoSituacaoPlaca = codigoSituacao;
      this.situacaoPlaca = situacao;

      return;
    },
    async consultarExisteCotacao() {
      try {
        if (this.propostaParaSomenteAgregado) {
          return true;
        }

        const _identificadoVeiculo = this.form.placa || this.form.chassi;

        const tipoIdentificado =
          _identificadoVeiculo.length == 17 ? 'chassi' : 'placa';

        if (!tipoIdentificado) {
          this.$vs.loading.close();

          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Uma placa ou chassi ou valido deve ser informado',
            color: 'danger',
          });

          return;
        }

        if (this.isPropostaConsultor || this.isInterno) {
          const dadosConsultaPlaca = await consultaPlaca({
            tipoIdentificado,
            identificador: this.form.placa || this.form.chassi,
            idEmpresa: this.form.idEmpresa,
            somenteAgregado: this.propostaParaSomenteAgregado,
            permitePlacaRepetida: this.permitePlacaRepetida,
          });

          if (dadosConsultaPlaca.codigoSituacao === '999') {
            this.$vs.loading.close();
            this.exibirAlertaPlaca(dadosConsultaPlaca);
            return false;
          }
        }

        return true;
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error,
          color: 'danger',
        });
      }
    },
    verificaChassiBaseBP: async function () {
      if (this.propostaParaSomenteAgregado && !this.form.chassi) {
        return;
      }

      if (this.form.chassi && this.form.chassi.length === 17) {
        this.placaValidada = await this.consultarExisteCotacao();

        if (!this.placaValidada) {
          return;
        }

        await this.consultarPlacaChassiBaseBP(null, 'chassi');
      }
    },
    async consultarPlacaChassiBaseBP(placa = null, chassi = null) {
      const isBP = functions.verificaEmpresaBemProtege(this.form.idEmpresa);
      const isViaVante = functions.verificaEmpresaViavante(this.form.idEmpresa);

      if (!isBP || (!this.placaValidada && placa) || isViaVante) {
        return true;
      }

      const dadosConsultaPlaca = await buscarPlacaBaseBP({
        idEmpresa: this.form.idEmpresa,
        placa: placa ? this.form.placa : placa,
        chassi: chassi ? this.form.chassi : chassi,
      });

      if (dadosConsultaPlaca.codigoSituacao === '998') {
        this.$vs.loading.close();

        if (
          !['Reativação', 'Troca de Titularidade'].includes(
            this.form.tipoProposta,
          )
        ) {
          this.form.tipoProposta = null;
          this.exibirAlertaPlaca(dadosConsultaPlaca);
          return false;
        } else {
          return true;
        }
      }

      if (dadosConsultaPlaca.codigoSituacao === '997') {
        this.$vs.loading.close();

        if (!['Troca de Titularidade'].includes(this.form.tipoProposta)) {
          this.form.tipoProposta = null;
          this.exibirAlertaPlaca(dadosConsultaPlaca);
          return false;
        }

        return true;
      }

      this.codigoSituacaoPlaca = '0';
      return true;
    },

    verificaPermissaoDescontoPorPerfil(ids) {
      if (ids) {
        const arrayIds = ids.split(', ').map((id) => id.trim());
        return arrayIds.includes(this.decoded.id_perfil.toString());
      } else return this.$can('Pode oferecer desconto', 'Cotações');
    },
    somaValores() {
      this.totalMensalidade = this.somaValorTotalMesAtualizados();
      this.totalSemComissao = this.somaValorTotalMesAtualizados();
      const valorComissaoAplicada = this.calcularEAumentarComissao();
      updateProdutoValorMensaliade(this.produtos, this.totalMensalidade);
      updateProdutoValorMinimoMensalidade(
        this.produtos,
        this.totalMensalidade,
        valorComissaoAplicada,
        this.aumentarComissao,
      );
      this.totalEntrada = this.somaValorTotalAtualizados();
    },
    calcularEAumentarComissao() {
      const aumentoComissao =
        this.form.comissaoAplicada > 0
          ? this.totalMensalidade * (this.form.comissaoAplicada / 100)
          : 0;
      this.form.valorComissaoAplicadaFinal = aumentoComissao;
      this.totalMensalidade += aumentoComissao;

      return aumentoComissao;
    },
    somaValoresAgregado() {
      this.totalEntradaAgregado = [];
      this.totalMensalidadeAgregado = [];
      this.totalSemComissaoAgregado = [];
      this.valorComissaoAplicadaFinalAgregado = [];

      if (!this.form.agregados || !this.form.agregados.length) return;

      this.form.agregados.forEach((agregado, index) => {
        const agregadoTemProdutos = agregado.hasOwnProperty('produtos');
        if (!agregadoTemProdutos) return;

        const totalMensalidade =
          this.somaValorTotalMesAtualizadosAgregado(index);
        this.totalMensalidadeAgregado[index] = totalMensalidade;

        const temProdutos = agregado.produtos && agregado.produtos.length >= 0;
        if (temProdutos) {
          updateProdutoValorMensaliade(agregado.produtos, totalMensalidade);
          updateProdutoValorMinimoMensalidade(
            agregado.produtos,
            totalMensalidade,
          );
        }

        const totalEntrada = this.somaValorTotalAtualizadosAgregado(index);
        this.totalEntradaAgregado[index] =
          totalEntrada < totalMensalidade ? totalMensalidade : totalEntrada;

        this.totalSemComissaoAgregado[index] = totalMensalidade;

        const valorComissao =
          agregado.comissaoAplicada > 0
            ? totalMensalidade * (agregado.comissaoAplicada / 100)
            : 0;
        agregado.valorComissaoAplicadaFinal = valorComissao;

        this.valorComissaoAplicadaFinalAgregado[index] = valorComissao;

        this.totalMensalidadeAgregado[index] += valorComissao;
      });
    },
    naoPermitirEmpresa(idEmpresa) {
      return (
        this.form.idEmpresa != idEmpresa || this.decoded.id_empresa != idEmpresa
      );
    },
    async buscarDadosRegional(idRegional) {
      try {
        const { data } = await service.post(
          'RegionalAberta',
          `find/${idRegional}`,
          {},
        );
        return data;
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Falha ao buscar dados da regional',
          'Atenção',
          'danger',
          5000,
        );
      }
    },
    async definirDadosRegional() {
      try {
        const {
          permitePlacaDuplicada,
          valorMinimoComissao,
          valorMaximoComissao,
        } = await this.buscarDadosRegional(this.form.regional.id);
        this.permitePlacaDuplicada = permitePlacaDuplicada;

        const regional = {
          ...this.form.regional,
          permitePlacaDuplicada,
          valorMinimoComissao,
          valorMaximoComissao,
        };
        this.form.regional = regional;
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Falha ao definir os dados da regional',
          'Atenção',
          'danger',
          5000,
        );
      }
    },

    async buscaDadosTiposEstacionamento() {
      try {
        this.$vs.loading();
        const result = await estacionamentoService.buscar();
        this.listLocaisEstacionamento = result.data;
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Não foi possível buscar os locais de estacionamento, tente novamente',
          'Atenção',
          'danger',
          5000,
        );
      } finally {
        this.$vs.loading.close();
      }
    },

    /**
     * Bloqueia a criação de novas propostas caso o veículo seja do tipo "moto", o local de estacionamento seja "estacionamento na rua",
     * e a configuração da empresa não permita propostas com essas condições
     **/
    verificaTipoEstacionamento() {
      if (!this.idTipoFipe || !this.form.idTipoEstacionamento) {
        return;
      }

      if (
        this.idTipoFipe.id === 2 &&
        this.form.idTipoEstacionamento === 2 &&
        !this.liberaPropostaMotoNaRua
      ) {
        this.desabilitaPropostaPorTipoVeiculoEstacionamento = true;

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Não é possível criar propostas de motorcicletas que não possuam estacionamento privado.',
          color: 'danger',
          time: 4000,
        });
        return;
      }

      this.desabilitaPropostaPorTipoVeiculoEstacionamento = false;
    },
    mostrarMultiPropostas() {
      const isMultipleProposal = this.$can('Proposta Múltipla', 'Cotações');
      return isMultipleProposal;
    },
    async buscaClasses() {
      const classes = await service.getAll(
        `${this.controllerClasse}`,
        {},
        `obterClasses/1/10000/true?idEmpresa=${this.idEmpresa}`,
      );
      this.classes = classes.data.classes.map((classe) => ({
        id: classe.idClasse,
        label: classe.nome,
      }));
    },
    async selecionaClasse() {
      const gruposSemValor = !this.grupos || !this.grupos.length;
      if (gruposSemValor) {
        await this.buscaDadosGrupos();
      }
      this.gruposModal = [];
      const subTipoSelecionado = this.form.classe.id;
      const gruposClasse = await service.getAll(
        `${this.controllerClasse}`,
        {},
        `busca-grupo-classe/${subTipoSelecionado}`,
      );
      this.gruposPorClasse = gruposClasse.data.gruposClasse;
      const objGruposClone = deepClone(this.grupos);
      const gruposComMesmoId = objGruposClone.filter((obj) => {
        return this.gruposPorClasse.some((grupo) => grupo.idGrupo === obj.id);
      });
      if (gruposComMesmoId.length > 0) {
        this.gruposModal = gruposComMesmoId;
      } else {
        if (this.propostaParaSomenteAgregado) {
          this.gruposModal = [];
          this.idGrupo = {};
          this.habilitaAlterarGrupo = false;

          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Nenhum grupo vinculado a essa Classe',
            color: 'danger',
            timer: 5000,
          });
          return;
        }
        this.gruposModal = [];
        this.grupos = [];
        this.idGrupo = null;
        this.habilitaAlterarGrupo = false;

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Nenhum grupo vinculado a essa Classe',
          color: 'danger',
          timer: 5000,
        });
      }
      if (this.propostaParaSomenteAgregado) {
        const apenasUmGrupoSelecionado =
          this.gruposModal && this.gruposModal.length === 1;
        if (apenasUmGrupoSelecionado) {
          this.idGrupo = this.gruposModal;
          this.abrirModalGrupos();
          return;
        }
        this.abrirModalGrupos();
        this.habilitaAlterarGrupo = true;
      }
      const apenasUmGrupoSelecionado =
        this.gruposModal && this.gruposModal.length === 1;
      if (apenasUmGrupoSelecionado) {
        this.idGrupo = this.gruposModal[0];
      }
      this.radioSelecionado = null;
      this.idGrupo = [];
      this.inputClasseIsTrue = true;
    },
    verificarSomenteAgregadoPemiteComplemento() {
      if (!this.propostaParaSomenteAgregado) {
        return;
      }

      this.form.caminhao = false;
      this.configuracaoPropostaCaminhao = false;
      this.form.agregado = false;
      this.form.implemento = false;
      this.form.agregados = [];
      this.form.implementos = [];

      this.form.caminhao = this.permitirSomenteAgregado
        ? this.idGrupo.permiteSomenteAgregado
        : false;

      this.configuracaoPropostaCaminhao = this.permitirSomenteAgregado
        ? this.idGrupo.permiteSomenteAgregado
        : false;

      this.permitirAgregado = this.permitirSomenteAgregado
        ? this.idGrupo.permiteAgregado
        : false;

      this.permitirImplemento = this.permitirSomenteAgregado
        ? this.idGrupo.permiteImplemento
        : false;
    },
    somaValoresAgregadoUnificado(mensal = true) {
      this.totalEntradaAgregado = [];
      this.totalMensalidadeAgregado = [];

      const calculaTotal = (produtos, periodo) =>
        produtos
          .filter(({ ismensal }) => ismensal === periodo)
          .reduce((valor, produto) => (valor += produto.valorFinal), 0);

      let totalProdutos = calculaTotal(
        this.form.produtosAgregados.produtosSelecionados,
        mensal,
      );

      updateProdutoValorMensaliade(
        this.form.produtosAgregados.produtosSelecionados,
        totalProdutos,
      );
      updateProdutoValorMinimoMensalidade(
        this.form.produtosAgregados.produtosSelecionados,
        totalProdutos,
      );

      return totalProdutos;
    },
    mostrarRangeComissao() {
      const isAllowEditComission = this.$can(
        'Alterar valores de comissão regional',
        'Cotações',
      );

      const isValidMinValue = this.comissionamento.minValue !== null;
      const isValidMaxValue = this.comissionamento.maxValue > 0;

      this.configurarComissao =
        isAllowEditComission &&
        this.aplicaComissao &&
        isValidMinValue &&
        isValidMaxValue;

      if (this.configurarComissao) {
        this.form.comissaoAplicada = this.comissionamento.maxValue;
      }
    },
    aplicaPermissaoParaTipoProposta() {
      const possuiAcessoMigracaoInternaSga = this.$can(
        'Acesso ao tipo de proposta Migração Interna SGA',
        'Cotações',
      );

      if (!possuiAcessoMigracaoInternaSga) {
        this.tiposProposta = this.tiposProposta.filter(
          (tipoProposta) => tipoProposta !== 'Migração Interna SGA',
        );
      }
    },
    selectRegional(regional) {
      const STANDARD_REGIONAL_MIGRATION_SGA = 'Funcionários bem protege';

      return (
        this.regionais.find(
          ({ label }) =>
            label.toLocaleLowerCase().trim() ===
            regional.toLocaleLowerCase().trim(),
        ) ||
        this.regionais.find(
          ({ label }) => label === STANDARD_REGIONAL_MIGRATION_SGA,
        ) ||
        this.regionais[0]
      );
    },
    selectLeadByOrigin(origin) {
      return (
        this.listLeads.find(({ origem }) => origem === origin) ||
        this.listLeads[0]
      );
    },

    async loadReactiveVehicles() {
      try {
        const reactivateVehicleData = localStorage.getItem('reactivateSGA');

        if (!reactivateVehicleData) {
          return;
        }

        const reactivateVehicleObject = JSON.parse(reactivateVehicleData);
        const {
          regional,
          nome,
          email,
          celular,
          telefone,
          estado,
          cidade,
          placa,
          tipoProposta,
          codigoFipe,
        } = reactivateVehicleObject;

        const { id, label } = this.selectRegional(regional);
        const { idOrigemLeads } = this.selectLeadByOrigin('Migração SGA');

        this.form = {
          ...this.form,
          origemLead: idOrigemLeads,
          regional: {
            id,
            label,
          },
          nome,
          email,
          celular,
          telefone,
          estado,
          cidade,
          placa,
          tipoProposta,
        };

        this.propostaMultipla = 'unica';
        this.estado = estado;
        this.cidade = cidade;
        this.passo = 1;

        await this.buscaPlacaFipe();
        this.propostaViaMigracaoSga = true;

        if (codigoFipe) {
          await this.confirmaModeloFipe(codigoFipe);
        }
        localStorage.removeItem('reactivateSGA');
      } catch (error) {
        console.error(
          'Erro ao carregar os dados do veículo para reativar:',
          error,
        );
      } finally {
        this.$vs.loading.close();
      }
    },

    preencheFormB2CByQueryParams() {
      const isB2C = !this.$route.path.includes('Interno');

      if (!isB2C) {
        return;
      }

      const queryParams = this.$route.query;
      const isVeiculoZero = queryParams.isZero === 'true' ? true : false;

      let idTipoEstacionamento = null;
      if (queryParams.possuiGaragem === 'true') {
        idTipoEstacionamento = 1;
      }

      if (queryParams.possuiGaragem === 'false') {
        idTipoEstacionamento = 2;
      }

      this.form.is1app = queryParams.is1app === 'true' ? true : false;
      this.form.idUser1app = queryParams.idUser1app;

      this.isCarroZero = isVeiculoZero;
      this.form.nome = queryParams.nome;
      this.form.email = queryParams.email;
      this.form.celular = queryParams.celular;
      this.form.placa = queryParams.placa;
      this.form.chassi = queryParams.chassi;
      this.cep = queryParams.cep;
      this.form.idTipoEstacionamento = idTipoEstacionamento;
      this.keymonitor();
      this.keymonitorPlaca('isB2C');
      this.desabilitaCamposB2C();
    },

    desabilitaCamposB2C() {
      this.isCampoNomeDisabled = true;
      this.isCampoCelularDisabled = true;
    },
    popupTitle() {
      if (this.ativaMascarasVeiculos) {
        if (this.tipoConfiguracaoCaminhao === 'agregado') {
          return this.mascaraAgregado;
        }
        if (this.tipoConfiguracaoCaminhao === 'implemento') {
          return this.mascaraImplemento;
        }
      }
      return this.tipoConfiguracaoCaminhao;
    },
    async getMarcaAgregadoImplemento() {
      try {
        this.$vs.loading();

        const marcas = await service.getAll(
          'Cotacao',
          {},
          'get-marca-agregado-implemento',
        );

        this.marcaAgregadoImplemento = marcas.data.map((marca) => ({
          value: marca.idMarcaAgregadoImplemento,
          label: marca.nome,
        }));
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `'Erro ao buscar marcas de agregado e implemento`,
          color: 'danger',
          time: 3000,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async getModeloAgregadoImplemento(marcaId) {
      try {
        this.$vs.loading();

        const modelos = await service.getAll(
          'Cotacao',
          {},
          `get-modelo-agregado-implemento/${marcaId}`,
        );

        this.modeloAgregadoImplemento = modelos.data.map((marca) => ({
          value: marca.idModeloAgregadoImplemento,
          label: marca.nome,
        }));
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `'Erro ao buscar modelos de agregado e implemento`,
          color: 'danger',
          time: 3000,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async showTotalEntrys() {
      const EXCLUDED_COMPANY_IDS = [126, 128];
      const showTotal = !EXCLUDED_COMPANY_IDS.includes(this.form.idEmpresa);
      return showTotal;
    },
  },
  async created() {
    await this.defineRota();
    await this.buscaDadosEmpresa();
  },

  async mounted() {
    this.aplicaPermissaoParaTipoProposta();
    this.buscarDicionarioTiposVeiculos();
    this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
    this.buscaRestricoes();
    await this.buscaOrigemLeads();
    this.buscaDadosTiposEstacionamento();
    this.buscaClasses();

    this.$validator.localize('ptBr', locale);
    this.converteParams();
    this.buscaDadosConsultorAdm();
    this.validaIsLanding();
    this.item = {};
    this.produtosObrigatorios = [];
    this.produtosNaoObrigatorios = [];
    this.form.produtosSelecionados = [];
    this.produtos.forEach((element) => {
      element.valorFinal = element.valor;
      element.descontoConcedido = 0;
      element.id = element.id_produto;
      if (element.obrigatorio == true) {
        this.produtosObrigatorios.push(element);
        this.form.produtosSelecionados.push(element);
      } else {
        this.produtosNaoObrigatorios.push(element);
      }
    });
    this.$can(
      'Exibe opção de mostrar valores FIPE e cobertura na proposta',
      'Cotações',
    )
      ? (this.form.exibirValoresVeiculoNaProposta = false)
      : (this.form.exibirValoresVeiculoNaProposta = true);

    // nomenclatura 120
    if (this.form.idEmpresa == 120) {
      this.nomenclatura120 = true;
    }

    this.$i18n.locale = functions.setLocaleBasedOnCompany();
    this.mostrarMultiPropostas();

    await this.buscaDadosTipos();
    await this.buscaDadosRegionais();
    await this.loadReactiveVehicles();
    this.preencheFormB2CByQueryParams();
    await this.getMarcaAgregadoImplemento();
    this.showTotalEntry = await this.showTotalEntrys();
  },
  components: {
    'v-select': vSelect,
    Money,
    cartaoCredito,
    FormComplemento,
    formDesconto,
    FormNovoValorProduto,
  },
};
</script>

<style lang="scss">
.form-landing {
  font-family: 'Roboto';
  padding-top: 60px;
  min-height: 80vh;

  .coluna-switch {
    padding: 0px 5px;
    div {
      background-color: #eff7ff;
      padding: 10px;
      min-height: 60px;
      vertical-align: middle;
      .label-switch {
        font-size: 12px;
        color: #078fcf;
      }
    }
  }

  label,
  .vs-input--label {
    color: #078fcf !important;
    font-size: 1rem;
  }

  .vs-input--input,
  .vs__dropdown-toggle,
  .vs-con-input .vs-inputx {
    height: 52px;
    background: white;
    border-radius: 9px;
    border: 1px #eeeeee solid !important;
  }
}
.botaoContratarAgora {
  background-color: #158c12;
  border-radius: 1rem;
  font-size: 1rem;
  color: #ffffff;
  padding: 1rem 2rem 1rem 2rem;
  transition: background-color 0.3s;
  font-family: 'Product Sans', sans-serif;
  cursor: pointer;
  border: 0;
  text-align: center;

  img {
    float: right;
    margin-top: 5px;
  }
}
</style>
<style scoped>
.input-data {
  width: 300px !important;
  max-width: 100% !important;
}
body {
  background-color: white;
}
.valorprod {
  color: #000;
  font-weight: bolder;
}
.lineThrough {
  text-decoration: line-through;
}
.listagemProdutos .vs-button {
  font-size: 1.2rem !important;
}
.con-slot-label {
  width: 100%;
  margin-left: 10px;
}
.semPadding {
  padding: 0em 0em 0em 0em !important;
}
.container {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.my-custom-money {
  font-size: 1.5em;
  color: #555555;
}
.my-custom-money-danger {
  font-size: 1.5em;
  color: #ea5455;
}
.my-custom-input {
  width: 100%;
  padding: 0.5em;
  border: 2px solid #b4b4b4;
  border-radius: 8px;
}
.my-custom-input-danger {
  width: 100%;
  padding: 0.5em;
  border: 2px solid #ea5455;
  border-radius: 8px;
}
#meu-popup-personalizado.con-vs-popup .vs-popup {
  width: fit-content;
}

.vs-checkbox {
  overflow: auto !important;
}
</style>
<style lang="scss" scoped>
.vs__search,
.vs__search:focus {
  padding: 0 6px !important;
}
.fixed-buttons {
  position: fixed;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #ccc;
  padding: 10px;
  margin-left: -25px;
  background-color: #fff;
  z-index: 999;
}
.painel-no-border {
  box-shadow: none !important;
  padding-bottom: 70px;
}
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 10px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
.item-lista {
  border: 1px solid #ccc;
  padding: 15px;
}
</style>
<style lang="scss" scoped>
.itemprodutos {
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
  padding: 10px 0 10px;
}

.title-item-veiculo {
  border-bottom: 1px solid #000;
}

.slider {
  background: #158c12;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  background: #158c12;
  cursor: pointer;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
}

.slider::-moz-range-thumb {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  background: #158c12;
  cursor: pointer;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
}

.vs-checkbox {
  overflow: auto !important;
}
</style>
